<template>
  <RF-Dialog
    :cpntLargura='"900px"'
    :cpntStatus="[ 'regime', 'estado' ].indexOf(statusGeral) !== -1 ? '' : statusGeral"
    :cpntOnFecharDialog='proSitFisFormularioFechar'>
    <template slot='titulo'>
      <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
      <span v-if="[ '', null, undefined, '0', 0 ].indexOf(cpntId) !== -1">Nova Situação Fiscal</span>
      <span v-else-if="cpntId === 'editar-massa'">Editar as Situações Fiscal em massa</span>
      <span v-else>Editar as Situações Fiscal</span>
    </template>

    <template slot='botoes' v-if="statusGeral === ''">
      <!-- SETA O BOTÃO EXCLUIR -->
      <App-Button v-if="[ '', null, undefined, '0', 0, 'editar-massa' ].indexOf(cpntId) === -1" :cpntClass="[ 'btn', 'btn-sm', 'btn-danger' ]" :cpntIcone="'excluir'" @onClick="proSitFisFormularioExcluirCaso" style="margin-right: 8px;"></App-Button>

      <!-- SETA O BOTÃO COPIAR -->
      <App-Button :cpntIcone="'copiar'" @onClick="proSitFisFormularioCopiarCaso"></App-Button>
    </template>

    <template slot='conteudo'>      
      <!-- FALTA INFORMAÇÕES NO CADASTRO -->
      <div v-if="statusGeral === 'estado'" class="pro-sit-fis-alerta">
        <svg class="fa fa-exclamation-circle"></svg>
        <br/>
        Para inserir as situações fiscais dos produtos é necessário inserir o Estado da sua empresa.
        <br/>
        <br/>
        <router-link :to="{ name: 'config_cadastro' }" tag='a' target="_parent"> Clique aqui </router-link>
        para inserir. (É necessário ser o Administrador da Licença de Uso para realizar esta operação).      
      </div>

      <!-- FALTA INFORMAÇÕES NO CADASTRO -->
      <div v-else-if="statusGeral === 'regime'" class="pro-sit-fis-alerta">
        <svg class="fa fa-exclamation-circle"></svg>
        <br/>
        Para inserir as situações fiscais dos produtos é necessário inserir o Regime Tributário da sua empresa.
        <br/>
        <br/>
        <router-link :to="{ name: 'config_cadastro' }" tag='a' target="_parent"> Clique aqui </router-link>
        para inserir. (É necessário ser o Administrador da Licença de Uso para realizar esta operação).      
      </div>

      <!-- FORMULARIO -->
      <template v-else-if="statusGeral === ''">
        <div class="pro-sit-fis-form">
          <div class="seletores">
            <div class="campos">
              <div>
                <App-Select :data-time="time" :class="campos.id_caso.id + ' ' + campos.id_caso.class" :title='campos.id_caso.title'
                :cpntStatus='campos.id_caso.status'
                :cpntId='campos.id_caso.id'
                :cpntTabIndex='campos.id_caso.tabIndex'
                :cpntNome='campos.id_caso.nome'
                :cpntValue='campos.id_caso.value'
                :cpntMensagem='campos.id_caso.mensagem'
                :cpntMensagemTipo='campos.id_caso.mensagemTipo'
                :cpntDisabled='campos.id_caso.disabled'
                :cpntMostrar='campos.id_caso.mostrar'
                :cpntExplica='campos.id_caso.explica'
                :cpntPlaceholder='campos.id_caso.placeholder'
                :cpntValueRef='campos.id_caso.valueRef'
                :cpntRouter='campos.id_caso.router'
                :cpntMethod='campos.id_caso.method'
                :cpntField='campos.id_caso.field'
                :cpntWhere='campos.id_caso.where'
                :cpntAddButForm='campos.id_caso.addButForm'
                :cpntKeyMostra='campos.id_caso.keyMostra'
                :cpntTipoOrder='campos.id_caso.tipoOrder'
                :cpntOrder='campos.id_caso.order'
                :cpntOptions='campos.id_caso.options'
                :cpntKeyValue='campos.id_caso.keyValue'
                :cpntSearchMinimo='campos.id_caso.searchMinimo'
                :cpntMask='campos.id_caso.mask'
                :cpntNewOption='campos.id_caso.newOption'
                :cpntOptionInicialNome='campos.id_caso.optionInicialNome'
                :cpntOptionInicialValue='campos.id_caso.optionInicialValue'
                
                :cpntOnBuscarOptions='campos.id_caso.onBuscarOptions'
                :cpntOnChange='campos.id_caso.onChange'
                :cpntOnBlur='campos.id_caso.onBlur'
                :cpntOnRealizaBusca='campos.id_caso.onRealizaBusca'
                :cpntOnKeyPressEnter='campos.id_caso.onKeyPressEnter'
                ref="id_caso"
              ></App-Select>
              </div>
            </div>

            <div class="demanda_cfop">
              <div class="demanda">
                <div>
                  <App-Select :data-time="time" :class="campos.id_cfop.id + ' ' + campos.id_cfop.class" :title='campos.id_cfop.title'
                    :cpntStatus='campos.id_cfop.status'
                    :cpntId='campos.id_cfop.id'
                    :cpntTabIndex='campos.id_cfop.tabIndex'
                    :cpntNome='campos.id_cfop.nome'
                    :cpntValue='campos.id_cfop.value'
                    :cpntMensagem='campos.id_cfop.mensagem'
                    :cpntMensagemTipo='campos.id_cfop.mensagemTipo'
                    :cpntDisabled='campos.id_cfop.disabled'
                    :cpntMostrar='campos.id_cfop.mostrar'
                    :cpntExplica='campos.id_cfop.explica'
                    :cpntPlaceholder='campos.id_cfop.placeholder'
                    :cpntValueRef='campos.id_cfop.valueRef'
                    :cpntRouter='campos.id_cfop.router'
                    :cpntField='campos.id_cfop.field'
                    :cpntWhere='campos.id_cfop.where'
                    :cpntAddButForm='campos.id_cfop.addButForm'
                    :cpntKeyMostra='campos.id_cfop.keyMostra'
                    :cpntTipoOrder='campos.id_cfop.tipoOrder'
                    :cpntOrder='campos.id_cfop.order'
                    :cpntOptions='campos.id_cfop.options'
                    :cpntOptionInicialNome='campos.id_cfop.optionInicialNome'
                    :cpntOptionInicialValue='campos.id_cfop.optionInicialValue'
                    :cpntKeyValue='campos.id_cfop.keyValue'
                    :cpntSearchMinimo='campos.id_cfop.searchMinimo'
                    :cpntMask='campos.id_cfop.mask'

                    :cpntOnBuscarOptions='campos.id_cfop.onBuscarOptions'
                    :cpntOnChange='campos.id_cfop.onChange'
                    :cpntOnBlur='campos.id_cfop.onBlur'
                    :cpntOnRealizaBusca='campos.id_cfop.onRealizaBusca'
                    :cpntOnKeyPressEnter='campos.id_cfop.onKeyPressEnter'
                    ref="id_cfop"
                  ></App-Select>

                  <App-Select :data-time="time" :class="campos.demanda.id + ' ' + campos.demanda.class" :title='campos.demanda.title' v-if="campos.demanda.disabled() === false"
                    :cpntStatus='campos.demanda.status'
                    :cpntId='campos.demanda.id'
                    :cpntTabIndex='campos.demanda.tabIndex'
                    :cpntNome='campos.demanda.nome'
                    :cpntValue='campos.demanda.value'
                    :cpntMensagem='campos.demanda.mensagem'
                    :cpntMensagemTipo='campos.demanda.mensagemTipo'
                    :cpntDisabled='campos.demanda.disabled()'
                    :cpntMostrar='campos.demanda.mostrar'
                    :cpntExplica='campos.demanda.explica'
                    :cpntPlaceholder='campos.demanda.placeholder'
                    :cpntValueRef='campos.demanda.valueRef'
                    :cpntRouter='campos.demanda.router'
                    :cpntField='campos.demanda.field'
                    :cpntWhere='campos.demanda.where'
                    :cpntAddButForm='campos.demanda.addButForm'
                    :cpntKeyMostra='campos.demanda.keyMostra'
                    :cpntTipoOrder='campos.demanda.tipoOrder'
                    :cpntOrder='campos.demanda.order'
                    :cpntOptions='campos.demanda.options'
                    :cpntOptionInicialNome='campos.demanda.optionInicialNome'
                    :cpntOptionInicialValue='campos.demanda.optionInicialValue'
                    :cpntKeyValue='campos.demanda.keyValue'
                    :cpntSearchMinimo='campos.demanda.searchMinimo'
                    :cpntMask='campos.demanda.mask'
                    :cpntMultiple='campos.demanda.multiple'
                    :cpntRequestAjax='campos.demanda.requestAjax'

                    :cpntOnBuscarOptions='campos.demanda.onBuscarOptions'
                    :cpntOnChange='campos.demanda.onChange'
                    :cpntOnBlur='campos.demanda.onBlur'
                    :cpntOnRealizaBusca='campos.demanda.onRealizaBusca'
                    :cpntOnKeyPressEnter='campos.demanda.onKeyPressEnter'
                    ref="demanda"
                  ></App-Select>
                </div>
              </div>

              <div class="estado" :class="campos.estado_todas.value === true ? 'pro-sit-fis-form--todos' : ''" v-if="proSitFisFormularioCampoEstadoMostrar() === true">
                <App-Toggles :data-time="time" :class="campos.estado_todas.id + ' ' + campos.estado_todas.class" :title='campos.estado_todas.title'
                  :cpntStatus='campos.estado_todas.status'
                  :cpntId='campos.estado_todas.id'
                  :cpntClassDivField='campos.estado_todas.classDivField'
                  :cpntNome='campos.estado_todas.nome'
                  :cpntValue='campos.estado_todas.value'
                  :cpntDisabled='campos.estado_todas.disabled'
                  :cpntMostrar='campos.estado_todas.mostrar'
                  :cpntMensagem='campos.estado_todas.mensagem'
                  :cpntMensagemTipo='campos.estado_todas.mensagemTipo'
                  :cpntOn='campos.estado_todas.on'
                  :cpntOff='campos.estado_todas.off'
                  :cpntExplica='campos.estado_todas.explica'
                  :cpntWidth='campos.estado_todas.width'
                  :cpntTabIndex='campos.estado_todas.tabIndex'
                  :cpntMask='campos.estado_todas.mask'
                  :cpntConfig='campos.estado_todas.config'
                  :cpntOnChange='campos.estado_todas.onChange'
                  :cpntOnBlur='campos.estado_todas.onBlur'
                  ref='estado_todas'
                ></App-Toggles>

                <App-Select :data-time="time" :class="campos.estado.id + ' ' + campos.estado.class" :title='campos.estado.title'
                  :cpntStatus='campos.estado.status'
                  :cpntId='campos.estado.id'
                  :cpntTabIndex='campos.estado.tabIndex'
                  :cpntNome='campos.estado.nome'
                  :cpntValue='campos.estado.value'
                  :cpntMensagem='campos.estado.mensagem'
                  :cpntMensagemTipo='campos.estado.mensagemTipo'
                  :cpntDisabled='campos.estado.disabled'
                  :cpntMostrar='campos.estado.mostrar'
                  :cpntExplica='campos.estado.explica'
                  :cpntPlaceholder='campos.estado.placeholder'
                  :cpntValueRef='campos.estado.valueRef'
                  :cpntRouter='campos.estado.router'
                  :cpntField='campos.estado.field'
                  :cpntWhere='campos.estado.where'
                  :cpntAddButForm='campos.estado.addButForm'
                  :cpntKeyMostra='campos.estado.keyMostra'
                  :cpntTipoOrder='campos.estado.tipoOrder'
                  :cpntOrder='campos.estado.order'
                  :cpntOptions='campos.estado.options'
                  :cpntOptionInicialNome='campos.estado.optionInicialNome'
                  :cpntOptionInicialValue='campos.estado.optionInicialValue'
                  :cpntKeyValue='campos.estado.keyValue'
                  :cpntSearchMinimo='campos.estado.searchMinimo'
                  :cpntMask='campos.estado.mask'
                  :cpntMultiple='campos.estado.multiple'
                  :cpntRequestAjax='campos.estado.requestAjax'

                  :cpntOnBuscarOptions='campos.estado.onBuscarOptions'
                  :cpntOnChange='campos.estado.onChange'
                  :cpntOnBlur='campos.estado.onBlur'
                  :cpntOnRealizaBusca='campos.estado.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.estado.onKeyPressEnter'
                  ref="estado"
                ></App-Select>

                <App-Tabela v-if="campos.estado.status === '' && this.proSitFisFormularioCampoEstadoMostrarTabela() === true" :style="campos.estado_todas.value === true ? 'display: none;' : ''" :cpntId="'pro-sit-fis-tab--estado'" :cpntColuna="tabela.estado.colunas" :cpntLinha="tabela.estado.linha">
                  <template v-slot:col_botao="{ indexL }">
                    <RF-Button :data-time="time"
                      :cpntId='tabela.remover.id + "estado--" + indexL + "--uf"'
                      :cpntStatus='tabela.remover.status' 
                      :cpntTipo='tabela.remover.tipo'
                      :cpntIcone='tabela.remover.icone'
                      :cpntClass='tabela.remover.class'
                      :cpntDisabled="tabela.remover.disabled"
                      @onClickButton='tabela.remover.onClick'
                    ></RF-Button>
                  </template>
                </App-Tabela>
              </div>

              <div class="pais" :class="campos.pais_todas.value === true ? 'pro-sit-fis-form--todos' : ''" v-if="proSitFisFormularioCampoPaisMostrar() === true">
                <App-Toggles :data-time="time" :class="campos.pais_todas.id + ' ' + campos.pais_todas.class" :title='campos.pais_todas.title'
                  :cpntStatus='campos.pais_todas.status'
                  :cpntId='campos.pais_todas.id'
                  :cpntClassDivField='campos.pais_todas.classDivField'
                  :cpntNome='campos.pais_todas.nome'
                  :cpntValue='campos.pais_todas.value'
                  :cpntDisabled='campos.pais_todas.disabled'
                  :cpntMostrar='campos.pais_todas.mostrar'
                  :cpntMensagem='campos.pais_todas.mensagem'
                  :cpntMensagemTipo='campos.pais_todas.mensagemTipo'
                  :cpntOn='campos.pais_todas.on'
                  :cpntOff='campos.pais_todas.off'
                  :cpntExplica='campos.pais_todas.explica'
                  :cpntWidth='campos.pais_todas.width'
                  :cpntTabIndex='campos.pais_todas.tabIndex'
                  :cpntMask='campos.pais_todas.mask'
                  :cpntConfig='campos.pais_todas.config'
                  :cpntOnChange='campos.pais_todas.onChange'
                  :cpntOnBlur='campos.pais_todas.onBlur'
                  ref='pais_todas'
                ></App-Toggles>

                <App-Select :data-time="time" :class="campos.pais.id + ' ' + campos.pais.class" :title='campos.pais.title' :key="campos.pais.matar" 
                  :cpntStatus='campos.pais.status'
                  :cpntId='campos.pais.id'
                  :cpntTabIndex='campos.pais.tabIndex'
                  :cpntNome='campos.pais.nome'
                  :cpntValue='campos.pais.value'
                  :cpntMensagem='campos.pais.mensagem'
                  :cpntMensagemTipo='campos.pais.mensagemTipo'
                  :cpntDisabled='campos.pais.disabled'
                  :cpntMostrar='campos.pais.mostrar'
                  :cpntExplica='campos.pais.explica'
                  :cpntPlaceholder='campos.pais.placeholder'
                  :cpntValueRef='campos.pais.valueRef'
                  :cpntRouter='campos.pais.router'
                  :cpntField='campos.pais.field'
                  :cpntWhere='campos.pais.where'
                  :cpntAddButForm='campos.pais.addButForm'
                  :cpntKeyMostra='campos.pais.keyMostra'
                  :cpntTipoOrder='campos.pais.tipoOrder'
                  :cpntOrder='campos.pais.order'
                  :cpntOptions='campos.pais.options'
                  :cpntOptionInicialNome='campos.pais.optionInicialNome'
                  :cpntOptionInicialValue='campos.pais.optionInicialValue'
                  :cpntKeyValue='campos.pais.keyValue'
                  :cpntSearchMinimo='campos.pais.searchMinimo'
                  :cpntMask='campos.pais.mask'
                  :cpntMultiple='campos.pais.multiple'
                  :cpntRequestAjax='campos.pais.requestAjax'

                  :cpntOnBuscarOptions='campos.pais.onBuscarOptions'
                  :cpntOnChange='campos.pais.onChange'
                  :cpntOnBlur='campos.pais.onBlur'
                  :cpntOnRealizaBusca='campos.pais.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.pais.onKeyPressEnter'
                  ref="pais"
                ></App-Select>

                <App-Tabela v-if="campos.pais.status === '' && proSitFisFormularioCampoPaisMostrarTabela() === true" :style="campos.pais_todas.value === true ? 'display: none;' : ''" :cpntId="'pro-sit-fis-tab--pais'" :cpntColuna="tabela.pais.colunas" :cpntLinha="tabela.pais.linha">
                  <template v-slot:col_img="{ linha }">
                    <template v-if="[ '', null, undefined, '0', 0 ].indexOf(linha.cPais) === -1">
                      <img :src="'/img/bandeira/' + linha.img + '.png'" :title='linha.xPais'/>
                    </template>
                  </template>
                  
                  <template v-slot:col_botao="{ indexL }">
                    <RF-Button :data-time="time"
                      :cpntId='tabela.remover.id + "pais--" + indexL + "--cPais"'
                      :cpntStatus='tabela.remover.status' 
                      :cpntTipo='tabela.remover.tipo'
                      :cpntIcone='tabela.remover.icone'
                      :cpntClass='tabela.remover.class'
                      :cpntDisabled="tabela.remover.disabled"
                      @onClickButton='tabela.remover.onClick'
                    ></RF-Button>
                  </template>
                </App-Tabela>
              </div>
            </div>

            <div class="campos">
              <div :class="campos.contato_todas.value === true ? 'pro-sit-fis-form--todos' : ''">
                <App-Toggles :data-time="time" :class="campos.contato_todas.id + ' ' + campos.contato_todas.class" :title='campos.contato_todas.title'
                  :cpntStatus='campos.contato_todas.status'
                  :cpntId='campos.contato_todas.id'
                  :cpntClassDivField='campos.contato_todas.classDivField'
                  :cpntNome='campos.contato_todas.nome'
                  :cpntValue='campos.contato_todas.value'
                  :cpntDisabled='campos.contato_todas.disabled'
                  :cpntMostrar='campos.contato_todas.mostrar'
                  :cpntMensagem='campos.contato_todas.mensagem'
                  :cpntMensagemTipo='campos.contato_todas.mensagemTipo'
                  :cpntOn='campos.contato_todas.on'
                  :cpntOff='campos.contato_todas.off'
                  :cpntExplica='campos.contato_todas.explica'
                  :cpntWidth='campos.contato_todas.width'
                  :cpntTabIndex='campos.contato_todas.tabIndex'
                  :cpntMask='campos.contato_todas.mask'
                  :cpntConfig='campos.contato_todas.config'
                  :cpntOnChange='campos.contato_todas.onChange'
                  :cpntOnBlur='campos.contato_todas.onBlur'
                  ref='contato_todas'
                ></App-Toggles>

                <App-Autocompletar :data-time="time" :class="campos.contato.id + ' ' + campos.contato.class" :title='campos.contato.title'
                  :cpntStatus='campos.contato.status'
                  :cpntId='campos.contato.id'
                  :cpntTabIndex='campos.contato.tabIndex'
                  :cpntNome='campos.contato.nome'
                  :cpntValue='campos.contato.value'
                  :cpntMensagem='campos.contato.mensagem'
                  :cpntMensagemTipo='campos.contato.mensagemTipo'
                  :cpntDisabled='campos.contato.disabled'
                  :cpntMostrar='campos.contato.mostrar === true'
                  :cpntExplica='campos.contato.explica'
                  :cpntPlaceholder='campos.contato.placeholder'
                  :cpntValueRef='campos.contato.valueRef'
                  :cpntRouter='campos.contato.router'
                  :cpntField='campos.contato.field'
                  :cpntWhere='campos.contato.where'
                  :cpntAddButForm='campos.contato.addButForm'
                  :cpntKeyMostra='campos.contato.keyMostra'
                  :cpntTipoOrder='campos.contato.tipoOrder'
                  :cpntOrder='campos.contato.order'
                  :cpntOptions='campos.contato.options'
                  :cpntKeyValue='campos.contato.keyValue'
                  :cpntSearchMinimo='campos.contato.searchMinimo'
                  :cpntMask='campos.contato.mask'
                  :cpntNewOption='campos.contato.newOption'

                  :cpntOnBuscarOptions='campos.contato.onBuscarOptions'
                  :cpntOnChange='campos.contato.onChange'
                  :cpntOnBlur='campos.contato.onBlur'
                  :cpntOnRealizaBusca='campos.contato.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.contato.onKeyPressEnter'
                  ref="contato"
                ></App-Autocompletar>

                <App-Tabela v-if="campos.contato.status === ''" :style="campos.contato_todas.value === true ? 'display: none;' : ''" :cpntId="'pro-sit-fis-tab--contato'" :cpntColuna="tabela.contato.colunas" :cpntLinha="tabela.contato.linha">
                  <template v-slot:col_botao="{ indexL }">
                    <RF-Button :data-time="time"
                      :cpntId='tabela.remover.id + "contato--" + indexL + "--id"'
                      :cpntStatus='tabela.remover.status' 
                      :cpntTipo='tabela.remover.tipo'
                      :cpntIcone='tabela.remover.icone'
                      :cpntClass='tabela.remover.class'
                      :cpntDisabled="tabela.remover.disabled"
                      @onClickButton='tabela.remover.onClick'
                    ></RF-Button>
                  </template>
                </App-Tabela>
              </div>

              <div :class="campos.ncm_todas.value === true ? 'pro-sit-fis-form--todos' : ''">
                <App-Toggles :data-time="time" :class="campos.ncm_todas.id + ' ' + campos.ncm_todas.class" :title='campos.ncm_todas.title'
                  :cpntStatus='campos.ncm_todas.status'
                  :cpntId='campos.ncm_todas.id'
                  :cpntClassDivField='campos.ncm_todas.classDivField'
                  :cpntNome='campos.ncm_todas.nome'
                  :cpntValue='campos.ncm_todas.value'
                  :cpntDisabled='campos.produto_todas.value === false'
                  :cpntMostrar='campos.ncm_todas.mostrar'
                  :cpntMensagem='campos.ncm_todas.mensagem'
                  :cpntMensagemTipo='campos.ncm_todas.mensagemTipo'
                  :cpntOn='campos.ncm_todas.on'
                  :cpntOff='campos.ncm_todas.off'
                  :cpntExplica='campos.ncm_todas.explica'
                  :cpntWidth='campos.ncm_todas.width'
                  :cpntTabIndex='campos.ncm_todas.tabIndex'
                  :cpntMask='campos.ncm_todas.mask'
                  :cpntConfig='campos.ncm_todas.config'
                  :cpntOnChange='campos.ncm_todas.onChange'
                  :cpntOnBlur='campos.ncm_todas.onBlur'
                  ref='ncm_todas'
                ></App-Toggles>

                <App-Autocompletar :data-time="time" :class="campos.ncm.id + ' ' + campos.ncm.class" :title='campos.ncm.title'
                  :cpntStatus='campos.ncm.status'
                  :cpntId='campos.ncm.id'
                  :cpntTabIndex='campos.ncm.tabIndex'
                  :cpntNome='campos.ncm.nome'
                  :cpntValue='campos.ncm.value'
                  :cpntMensagem='campos.ncm.mensagem'
                  :cpntMensagemTipo='campos.ncm.mensagemTipo'
                  :cpntDisabled='campos.produto_todas.value === false || campos.ncm_todas.value !== false || campos.ncm.disabled === true'
                  :cpntMostrar='campos.ncm.mostrar === true'
                  :cpntExplica='campos.ncm.explica'
                  :cpntPlaceholder='campos.ncm.placeholder'
                  :cpntValueRef='campos.ncm.valueRef'
                  :cpntRouter='campos.ncm.router'
                  :cpntMethod='campos.ncm.method'
                  :cpntField='campos.ncm.field'
                  :cpntWhere='campos.ncm.where'
                  :cpntAddButForm='campos.ncm.addButForm'
                  :cpntKeyMostra='campos.ncm.keyMostra'
                  :cpntTipoOrder='campos.ncm.tipoOrder'
                  :cpntOrder='campos.ncm.order'
                  :cpntOptions='campos.ncm.options'
                  :cpntKeyValue='campos.ncm.keyValue'
                  :cpntSearchMinimo='campos.ncm.searchMinimo'
                  :cpntMask='campos.ncm.mask'
                  :cpntNewOption='campos.ncm.newOption'

                  :cpntOnBuscarOptions='campos.ncm.onBuscarOptions'
                  :cpntOnChange='campos.ncm.onChange'
                  :cpntOnBlur='campos.ncm.onBlur'
                  :cpntOnRealizaBusca='campos.ncm.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.ncm.onKeyPressEnter'
                  ref="ncm"
                ></App-Autocompletar>

                <App-Tabela v-if="campos.ncm.status === ''" :style="campos.ncm_todas.value === true ? 'display: none;' : ''" :cpntId="'pro-sit-fis-tab--ncm'" :cpntColuna="tabela.ncm.colunas" :cpntLinha="tabela.ncm.linha">
                  <template v-slot:col_botao="{ indexL }">
                    <RF-Button :data-time="time"
                      :cpntId='tabela.remover.id + "ncm--" + indexL + "--ncm"'
                      :cpntStatus='tabela.remover.status' 
                      :cpntTipo='tabela.remover.tipo'
                      :cpntIcone='tabela.remover.icone'
                      :cpntClass='tabela.remover.class'
                      :cpntDisabled="tabela.remover.disabled"
                      @onClickButton='tabela.remover.onClick'
                    ></RF-Button>
                  </template>
                </App-Tabela>
              </div>

              <div :class="campos.produto_todas.value === true ? 'pro-sit-fis-form--todos' : ''">
                <App-Toggles :data-time="time" :class="campos.produto_todas.id + ' ' + campos.produto_todas.class" :title='campos.produto_todas.title'
                  :cpntStatus='campos.produto_todas.status'
                  :cpntId='campos.produto_todas.id'
                  :cpntClassDivField='campos.produto_todas.classDivField'
                  :cpntNome='campos.produto_todas.nome'
                  :cpntValue='campos.produto_todas.value'
                  :cpntDisabled='campos.ncm_todas.value === false'
                  :cpntMostrar='campos.produto_todas.mostrar'
                  :cpntMensagem='campos.produto_todas.mensagem'
                  :cpntMensagemTipo='campos.produto_todas.mensagemTipo'
                  :cpntOn='campos.produto_todas.on'
                  :cpntOff='campos.produto_todas.off'
                  :cpntExplica='campos.produto_todas.explica'
                  :cpntWidth='campos.produto_todas.width'
                  :cpntTabIndex='campos.produto_todas.tabIndex'
                  :cpntMask='campos.produto_todas.mask'
                  :cpntConfig='campos.produto_todas.config'
                  :cpntOnChange='campos.produto_todas.onChange'
                  :cpntOnBlur='campos.produto_todas.onBlur'
                  ref='produto_todas'
                ></App-Toggles>

                <App-Autocompletar :data-time="time" :class="campos.produto.id + ' ' + campos.produto.class" :title='campos.produto.title'
                  :cpntStatus='campos.produto.status'
                  :cpntId='campos.produto.id'
                  :cpntTabIndex='campos.produto.tabIndex'
                  :cpntNome='campos.produto.nome'
                  :cpntValue='campos.produto.value'
                  :cpntMensagem='campos.produto.mensagem'
                  :cpntMensagemTipo='campos.produto.mensagemTipo'
                  :cpntDisabled='campos.ncm_todas.value === false || campos.produto_todas.value !== false || campos.produto.disabled === true'
                  :cpntMostrar='campos.produto.mostrar === true'
                  :cpntExplica='campos.produto.explica'
                  :cpntPlaceholder='campos.produto.placeholder'
                  :cpntValueRef='campos.produto.valueRef'
                  :cpntRouter='campos.produto.router'
                  :cpntMethod='campos.produto.method'
                  :cpntField='campos.produto.field'
                  :cpntWhere='campos.produto.where'
                  :cpntAddButForm='campos.produto.addButForm'
                  :cpntKeyMostra='campos.produto.keyMostra'
                  :cpntTipoOrder='campos.produto.tipoOrder'
                  :cpntOrder='campos.produto.order'
                  :cpntOptions='campos.produto.options'
                  :cpntKeyValue='campos.produto.keyValue'
                  :cpntSearchMinimo='campos.produto.searchMinimo'
                  :cpntMask='campos.produto.mask'
                  :cpntNewOption='campos.produto.newOption'

                  :cpntOnBuscarOptions='campos.produto.onBuscarOptions'
                  :cpntOnChange='campos.produto.onChange'
                  :cpntOnBlur='campos.produto.onBlur'
                  :cpntOnRealizaBusca='campos.produto.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.produto.onKeyPressEnter'
                  ref="produto"
                ></App-Autocompletar>

                <App-Tabela v-if="campos.produto.status === ''" :style="campos.produto_todas.value === true ? 'display: none;' : ''" :cpntId="'pro-sit-fis-tab--produto'" :cpntColuna="tabela.produto.colunas" :cpntLinha="tabela.produto.linha">
                  <template v-slot:col_botao="{ indexL }">
                    <RF-Button :data-time="time"
                      :cpntId='tabela.remover.id + "produto--" + indexL + "--id"'
                      :cpntStatus='tabela.remover.status' 
                      :cpntTipo='tabela.remover.tipo'
                      :cpntIcone='tabela.remover.icone'
                      :cpntClass='tabela.remover.class'
                      :cpntDisabled="tabela.remover.disabled"
                      @onClickButton='tabela.remover.onClick'
                    ></RF-Button>
                  </template>
                </App-Tabela>
              </div>
            </div>

            <div class="mensagem" v-if="(campos.id_cfop.value !== '' && campos.id_cfop.value._id !== '') && ([ '5', '7', '1', '3' ].indexOf(campos.id_cfop.value.cfop_ini) === -1 || tabela.estado.chaves.length >= 1) && $store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 23 ], null, null, null, null, null, false) === true && (proSitFisFormularioCampoMensagemNFCeForaEstado() === true || proSitFisFormularioCampoMensagemCSTInvalida() === true)">
              <div style="text-align: center;"><b>Importante para NFC-e [65]</b></div>
              <br/>
              <template v-if="proSitFisFormularioCampoMensagemNFCeForaEstado() === true">
                <App-Icone :cpntTipo="'erro-vermelho'" style="margin-right: 5px;"></App-Icone>
                <span>CFOP não é permitido a emissão da NFC-e para fora do Estado ({{ $store.state.licenca.uf }}). Esta configuração não sera utilizada para NFC-e.</span>
              </template>
              <template v-else-if="proSitFisFormularioCampoMensagemCSTInvalida() === true">
                <App-Icone :cpntTipo="'alerta-amarelo'" style="margin-right: 5px;"></App-Icone>
                <span v-html="$store.state.licenca.rt_id === '3' ? 'As vendas com o documento <b>NFC-e</b> serão considerados apenas os seguintes <b>CST: 00, 20, 40, 41, 60, 90</b>' : 'Para as vendas com o documento <b>NFC-e</b> serão considerados apenas os seguintes <b>CSOSN: 102, 103, 300, 400, 500, 61, 900</b>'"></span>
              </template>
            </div>
          </div>

          <hr/>

          <div class="campos">
            <div class="titulo">
              <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
              ICMS
            </div>
            <div class="quadrado">
              <div>
                <App-Select :data-time="time" :class="campos.icms_orig.id + ' ' + campos.icms_orig.class" :title='campos.icms_orig.title'
                  :cpntStatus='campos.icms_orig.status'
                  :cpntId='campos.icms_orig.id'
                  :cpntTabIndex='campos.icms_orig.tabIndex'
                  :cpntNome='campos.icms_orig.nome'
                  :cpntValue='campos.icms_orig.value'
                  :cpntMensagem='campos.icms_orig.mensagem'
                  :cpntMensagemTipo='campos.icms_orig.mensagemTipo'
                  :cpntDisabled='campos.icms_orig.disabled'
                  :cpntMostrar='campos.icms_orig.mostrar'
                  :cpntExplica='campos.icms_orig.explica'
                  :cpntPlaceholder='campos.icms_orig.placeholder'
                  :cpntValueRef='campos.icms_orig.valueRef'
                  :cpntRouter='campos.icms_orig.router'
                  :cpntField='campos.icms_orig.field'
                  :cpntWhere='campos.icms_orig.where'
                  :cpntAddButForm='campos.icms_orig.addButForm'
                  :cpntKeyMostra='campos.icms_orig.keyMostra'
                  :cpntTipoOrder='campos.icms_orig.tipoOrder'
                  :cpntOrder='campos.icms_orig.order'
                  :cpntOptions='campos.icms_orig.options'
                  :cpntOptionInicialNome='campos.icms_orig.optionInicialNome'
                  :cpntOptionInicialValue='campos.icms_orig.optionInicialValue'
                  :cpntKeyValue='campos.icms_orig.keyValue'
                  :cpntSearchMinimo='campos.icms_orig.searchMinimo'
                  :cpntMask='campos.icms_orig.mask'

                  :cpntOnBuscarOptions='campos.icms_orig.onBuscarOptions'
                  :cpntOnChange='campos.icms_orig.onChange'
                  :cpntOnBlur='campos.icms_orig.onBlur'
                  :cpntOnRealizaBusca='campos.icms_orig.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.icms_orig.onKeyPressEnter'
                  ref="icms_orig"
                ></App-Select>

                <App-Select :data-time="time" :class="campos.icms_cst.id + ' ' + campos.icms_cst.class" :title='campos.icms_cst.title'
                  :cpntStatus='campos.icms_cst.status'
                  :cpntId='campos.icms_cst.id'
                  :cpntTabIndex='campos.icms_cst.tabIndex'
                  :cpntNome='proSitFisFormularioCampoIcmsCstNome'
                  :cpntValue='campos.icms_cst.value'
                  :cpntMensagem='campos.icms_cst.mensagem'
                  :cpntMensagemTipo='campos.icms_cst.mensagemTipo'
                  :cpntDisabled='campos.icms_cst.disabled'
                  :cpntMostrar='campos.icms_cst.mostrar'
                  :cpntExplica='campos.icms_cst.explica'
                  :cpntPlaceholder='campos.icms_cst.placeholder'
                  :cpntValueRef='campos.icms_cst.valueRef'
                  :cpntRouter='campos.icms_cst.router'
                  :cpntField='campos.icms_cst.field'
                  :cpntWhere='campos.icms_cst.where'
                  :cpntAddButForm='campos.icms_cst.addButForm'
                  :cpntKeyMostra='campos.icms_cst.keyMostra'
                  :cpntTipoOrder='campos.icms_cst.tipoOrder'
                  :cpntOrder='campos.icms_cst.order'
                  :cpntOptions='campos.icms_cst.options'
                  :cpntOptionInicialNome='campos.icms_cst.optionInicialNome'
                  :cpntOptionInicialValue='campos.icms_cst.optionInicialValue'
                  :cpntKeyValue='campos.icms_cst.keyValue'
                  :cpntSearchMinimo='campos.icms_cst.searchMinimo'
                  :cpntMask='campos.icms_cst.mask'

                  :cpntOnBuscarOptions='campos.icms_cst.onBuscarOptions'
                  :cpntOnChange='campos.icms_cst.onChange'
                  :cpntOnBlur='campos.icms_cst.onBlur'
                  :cpntOnRealizaBusca='campos.icms_cst.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.icms_cst.onKeyPressEnter'
                  ref="icms_cst"
                ></App-Select>
              </div>

              <div style="padding-top: 25px">
                <App-Select :data-time="time" :class="campos.icms_bc_mod.id + ' ' + campos.icms_bc_mod.class" :title='campos.icms_bc_mod.title'
                  :cpntStatus='campos.icms_bc_mod.status'
                  :cpntId='campos.icms_bc_mod.id'
                  :cpntTabIndex='campos.icms_bc_mod.tabIndex'
                  :cpntNome='campos.icms_bc_mod.nome'
                  :cpntValue='campos.icms_bc_mod.value'
                  :cpntMensagem='campos.icms_bc_mod.mensagem'
                  :cpntMensagemTipo='campos.icms_bc_mod.mensagemTipo'
                  :cpntDisabled='campos.icms_bc_mod.disabled()'
                  :cpntMostrar='campos.icms_bc_mod.mostrar'
                  :cpntExplica='campos.icms_bc_mod.explica'
                  :cpntPlaceholder='campos.icms_bc_mod.placeholder'
                  :cpntValueRef='campos.icms_bc_mod.valueRef'
                  :cpntRouter='campos.icms_bc_mod.router'
                  :cpntField='campos.icms_bc_mod.field'
                  :cpntWhere='campos.icms_bc_mod.where'
                  :cpntAddButForm='campos.icms_bc_mod.addButForm'
                  :cpntKeyMostra='campos.icms_bc_mod.keyMostra'
                  :cpntTipoOrder='campos.icms_bc_mod.tipoOrder'
                  :cpntOrder='campos.icms_bc_mod.order'
                  :cpntOptions='campos.icms_bc_mod.options'
                  :cpntOptionInicialNome='campos.icms_bc_mod.optionInicialNome'
                  :cpntOptionInicialValue='campos.icms_bc_mod.optionInicialValue'
                  :cpntKeyValue='campos.icms_bc_mod.keyValue'
                  :cpntSearchMinimo='campos.icms_bc_mod.searchMinimo'
                  :cpntMask='campos.icms_bc_mod.mask'

                  :cpntOnBuscarOptions='campos.icms_bc_mod.onBuscarOptions'
                  :cpntOnChange='campos.icms_bc_mod.onChange'
                  :cpntOnBlur='campos.icms_bc_mod.onBlur'
                  :cpntOnRealizaBusca='campos.icms_bc_mod.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.icms_bc_mod.onKeyPressEnter'
                  ref="icms_bc_mod"
                ></App-Select>

                <App-Input :data-time="time" :class="campos.icms_a.id + ' ' + campos.icms_a.class" :title='campos.icms_a.title'
                  :cpntStatus='campos.icms_a.status'
                  :cpntId='campos.icms_a.id'
                  :cpntClassDivField='campos.icms_a.classDivField'
                  :cpntNome='campos.icms_a.nome'
                  :cpntValue='campos.icms_a.value'
                  :cpntAutoComplete='campos.icms_a.autocomplete'
                  :cpntMask='campos.icms_a.mask'
                  :cpntOptionInicialNome='campos.icms_a.optionInicialNome'
                  :cpntOptionInicialValue='campos.icms_a.optionInicialValue'
                  :cpntDisabled='campos.icms_a.disabled()'
                  :cpntMostrar='campos.icms_a.mostrar'
                  :cpntExplica='campos.icms_a.explica'
                  :cpntAutoFocus='campos.icms_a.autofocus'
                  :cpntMensagem='campos.icms_a.mensagem'
                  :cpntMensagemTipo='campos.icms_a.mensagemTipo'
                  :cpntPlaceholder='campos.icms_a.placeholder'
                  :cpntPosicionar='campos.icms_a.posicionar'
                  :cpntOnChange='campos.icms_a.onChange'
                  :cpntOnBlur='campos.icms_a.onBlur'
                  ref='icms_a'
                ></App-Input>

                <App-Input :data-time="time" :class="campos.icms_bc_p_r.id + ' ' + campos.icms_bc_p_r.class" :title='campos.icms_bc_p_r.title'
                  :cpntStatus='campos.icms_bc_p_r.status'
                  :cpntId='campos.icms_bc_p_r.id'
                  :cpntClassDivField='campos.icms_bc_p_r.classDivField'
                  :cpntNome='campos.icms_bc_p_r.nome'
                  :cpntValue='campos.icms_bc_p_r.value'
                  :cpntAutoComplete='campos.icms_bc_p_r.autocomplete'
                  :cpntMask='campos.icms_bc_p_r.mask'
                  :cpntOptionInicialNome='campos.icms_bc_p_r.optionInicialNome'
                  :cpntOptionInicialValue='campos.icms_bc_p_r.optionInicialValue'
                  :cpntDisabled='campos.icms_bc_p_r.disabled()'
                  :cpntMostrar='campos.icms_bc_p_r.mostrar'
                  :cpntExplica='campos.icms_bc_p_r.explica'
                  :cpntAutoFocus='campos.icms_bc_p_r.autofocus'
                  :cpntMensagem='campos.icms_bc_p_r.mensagem'
                  :cpntMensagemTipo='campos.icms_bc_p_r.mensagemTipo'
                  :cpntPlaceholder='campos.icms_bc_p_r.placeholder'
                  :cpntPosicionar='campos.icms_bc_p_r.posicionar'
                  :cpntOnChange='campos.icms_bc_p_r.onChange'
                  :cpntOnBlur='campos.icms_bc_p_r.onBlur'
                  ref='icms_bc_p_r'
                ></App-Input>

                <App-Select :data-time="time" :class="campos.icms_bc_p_r_c.id + ' ' + campos.icms_bc_p_r_c.class" :title='campos.icms_bc_p_r_c.title'
                  :cpntStatus='campos.icms_bc_p_r_c.status'
                  :cpntId='campos.icms_bc_p_r_c.id'
                  :cpntTabIndex='campos.icms_bc_p_r_c.tabIndex'
                  :cpntNome='campos.icms_bc_p_r_c.nome'
                  :cpntValue='campos.icms_bc_p_r_c.value'
                  :cpntMensagem='campos.icms_bc_p_r_c.mensagem'
                  :cpntMensagemTipo='campos.icms_bc_p_r_c.mensagemTipo'
                  :cpntDisabled='campos.icms_bc_p_r_c.disabled()'
                  :cpntMostrar='campos.icms_bc_p_r_c.mostrar'
                  :cpntExplica='campos.icms_bc_p_r_c.explica'
                  :cpntPlaceholder='campos.icms_bc_p_r_c.placeholder'
                  :cpntValueRef='campos.icms_bc_p_r_c.valueRef'
                  :cpntRouter='campos.icms_bc_p_r_c.router'
                  :cpntField='campos.icms_bc_p_r_c.field'
                  :cpntWhere='campos.icms_bc_p_r_c.where'
                  :cpntAddButForm='campos.icms_bc_p_r_c.addButForm'
                  :cpntKeyMostra='campos.icms_bc_p_r_c.keyMostra'
                  :cpntTipoOrder='campos.icms_bc_p_r_c.tipoOrder'
                  :cpntOrder='campos.icms_bc_p_r_c.order'
                  :cpntOptions='campos.icms_bc_p_r_c.options'
                  :cpntOptionInicialNome='campos.icms_bc_p_r_c.optionInicialNome'
                  :cpntOptionInicialValue='campos.icms_bc_p_r_c.optionInicialValue'
                  :cpntKeyValue='campos.icms_bc_p_r_c.keyValue'
                  :cpntSearchMinimo='campos.icms_bc_p_r_c.searchMinimo'
                  :cpntMask='campos.icms_bc_p_r_c.mask'

                  :cpntOnBuscarOptions='campos.icms_bc_p_r_c.onBuscarOptions'
                  :cpntOnChange='campos.icms_bc_p_r_c.onChange'
                  :cpntOnBlur='campos.icms_bc_p_r_c.onBlur'
                  :cpntOnRealizaBusca='campos.icms_bc_p_r_c.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.icms_bc_p_r_c.onKeyPressEnter'
                  ref="icms_bc_p_r_c"
                ></App-Select>
              </div>

              <div style="padding-top: 25px">
                <App-Select :data-time="time" :class="campos.icms_st_bc_mod.id + ' ' + campos.icms_st_bc_mod.class" :title='campos.icms_st_bc_mod.title'
                  :cpntStatus='campos.icms_st_bc_mod.status'
                  :cpntId='campos.icms_st_bc_mod.id'
                  :cpntTabIndex='campos.icms_st_bc_mod.tabIndex'
                  :cpntNome='campos.icms_st_bc_mod.nome'
                  :cpntValue='campos.icms_st_bc_mod.value'
                  :cpntMensagem='campos.icms_st_bc_mod.mensagem'
                  :cpntMensagemTipo='campos.icms_st_bc_mod.mensagemTipo'
                  :cpntDisabled='campos.icms_st_bc_mod.disabled()'
                  :cpntMostrar='campos.icms_st_bc_mod.mostrar'
                  :cpntExplica='campos.icms_st_bc_mod.explica'
                  :cpntPlaceholder='campos.icms_st_bc_mod.placeholder'
                  :cpntValueRef='campos.icms_st_bc_mod.valueRef'
                  :cpntRouter='campos.icms_st_bc_mod.router'
                  :cpntField='campos.icms_st_bc_mod.field'
                  :cpntWhere='campos.icms_st_bc_mod.where'
                  :cpntAddButForm='campos.icms_st_bc_mod.addButForm'
                  :cpntKeyMostra='campos.icms_st_bc_mod.keyMostra'
                  :cpntTipoOrder='campos.icms_st_bc_mod.tipoOrder'
                  :cpntOrder='campos.icms_st_bc_mod.order'
                  :cpntOptions='campos.icms_st_bc_mod.options'
                  :cpntOptionInicialNome='campos.icms_st_bc_mod.optionInicialNome'
                  :cpntOptionInicialValue='campos.icms_st_bc_mod.optionInicialValue'
                  :cpntKeyValue='campos.icms_st_bc_mod.keyValue'
                  :cpntSearchMinimo='campos.icms_st_bc_mod.searchMinimo'
                  :cpntMask='campos.icms_st_bc_mod.mask'

                  :cpntOnBuscarOptions='campos.icms_st_bc_mod.onBuscarOptions'
                  :cpntOnChange='campos.icms_st_bc_mod.onChange'
                  :cpntOnBlur='campos.icms_st_bc_mod.onBlur'
                  :cpntOnRealizaBusca='campos.icms_st_bc_mod.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.icms_st_bc_mod.onKeyPressEnter'
                  ref="icms_st_bc_mod"
                ></App-Select>

                <App-Input :data-time="time" :class="campos.icms_st_a.id + ' ' + campos.icms_st_a.class" :title='campos.icms_st_a.title'
                  :cpntStatus='campos.icms_st_a.status'
                  :cpntId='campos.icms_st_a.id'
                  :cpntClassDivField='campos.icms_st_a.classDivField'
                  :cpntNome='campos.icms_st_a.nome'
                  :cpntValue='campos.icms_st_a.value'
                  :cpntAutoComplete='campos.icms_st_a.autocomplete'
                  :cpntMask='campos.icms_st_a.mask'
                  :cpntOptionInicialNome='campos.icms_st_a.optionInicialNome'
                  :cpntOptionInicialValue='campos.icms_st_a.optionInicialValue'
                  :cpntDisabled='campos.icms_st_a.disabled()'
                  :cpntMostrar='campos.icms_st_a.mostrar'
                  :cpntExplica='campos.icms_st_a.explica'
                  :cpntAutoFocus='campos.icms_st_a.autofocus'
                  :cpntMensagem='campos.icms_st_a.mensagem'
                  :cpntMensagemTipo='campos.icms_st_a.mensagemTipo'
                  :cpntPlaceholder='campos.icms_st_a.placeholder'
                  :cpntPosicionar='campos.icms_st_a.posicionar'
                  :cpntOnChange='campos.icms_st_a.onChange'
                  :cpntOnBlur='campos.icms_st_a.onBlur'
                  ref='icms_st_a'
                ></App-Input>

                <App-Input :data-time="time" :class="campos.icms_bc_st_p_r.id + ' ' + campos.icms_bc_st_p_r.class" :title='campos.icms_bc_st_p_r.title'
                  :cpntStatus='campos.icms_bc_st_p_r.status'
                  :cpntId='campos.icms_bc_st_p_r.id'
                  :cpntClassDivField='campos.icms_bc_st_p_r.classDivField'
                  :cpntNome='campos.icms_bc_st_p_r.nome'
                  :cpntValue='campos.icms_bc_st_p_r.value'
                  :cpntAutoComplete='campos.icms_bc_st_p_r.autocomplete'
                  :cpntMask='campos.icms_bc_st_p_r.mask'
                  :cpntOptionInicialNome='campos.icms_bc_st_p_r.optionInicialNome'
                  :cpntOptionInicialValue='campos.icms_bc_st_p_r.optionInicialValue'
                  :cpntDisabled='campos.icms_bc_st_p_r.disabled()'
                  :cpntMostrar='campos.icms_bc_st_p_r.mostrar'
                  :cpntExplica='campos.icms_bc_st_p_r.explica'
                  :cpntAutoFocus='campos.icms_bc_st_p_r.autofocus'
                  :cpntMensagem='campos.icms_bc_st_p_r.mensagem'
                  :cpntMensagemTipo='campos.icms_bc_st_p_r.mensagemTipo'
                  :cpntPlaceholder='campos.icms_bc_st_p_r.placeholder'
                  :cpntPosicionar='campos.icms_bc_st_p_r.posicionar'
                  :cpntOnChange='campos.icms_bc_st_p_r.onChange'
                  :cpntOnBlur='campos.icms_bc_st_p_r.onBlur'
                  ref='icms_bc_st_p_r'
                ></App-Input>

                <App-Input :data-time="time" :class="campos.icms_mva_p.id + ' ' + campos.icms_mva_p.class" :title='campos.icms_mva_p.title'
                  :cpntStatus='campos.icms_mva_p.status'
                  :cpntId='campos.icms_mva_p.id'
                  :cpntClassDivField='campos.icms_mva_p.classDivField'
                  :cpntNome='campos.icms_mva_p.nome'
                  :cpntValue='campos.icms_mva_p.value'
                  :cpntAutoComplete='campos.icms_mva_p.autocomplete'
                  :cpntMask='campos.icms_mva_p.mask'
                  :cpntOptionInicialNome='campos.icms_mva_p.optionInicialNome'
                  :cpntOptionInicialValue='campos.icms_mva_p.optionInicialValue'
                  :cpntDisabled='campos.icms_mva_p.disabled()'
                  :cpntMostrar='campos.icms_mva_p.mostrar'
                  :cpntExplica='campos.icms_mva_p.explica'
                  :cpntAutoFocus='campos.icms_mva_p.autofocus'
                  :cpntMensagem='campos.icms_mva_p.mensagem'
                  :cpntMensagemTipo='campos.icms_mva_p.mensagemTipo'
                  :cpntPlaceholder='campos.icms_mva_p.placeholder'
                  :cpntPosicionar='campos.icms_mva_p.posicionar'
                  :cpntOnChange='campos.icms_mva_p.onChange'
                  :cpntOnBlur='campos.icms_mva_p.onBlur'
                  ref='icms_mva_p'
                ></App-Input>
              </div>

              <div>
                <App-Input :data-time="time" :class="campos.icms_st_bc_rt.id + ' ' + campos.icms_st_bc_rt.class" :title='campos.icms_st_bc_rt.title'
                  :cpntStatus='campos.icms_st_bc_rt.status'
                  :cpntId='campos.icms_st_bc_rt.id'
                  :cpntClassDivField='campos.icms_st_bc_rt.classDivField'
                  :cpntNome='campos.icms_st_bc_rt.nome'
                  :cpntValue='campos.icms_st_bc_rt.value'
                  :cpntAutoComplete='campos.icms_st_bc_rt.autocomplete'
                  :cpntMask='campos.icms_st_bc_rt.mask'
                  :cpntOptionInicialNome='campos.icms_st_bc_rt.optionInicialNome'
                  :cpntOptionInicialValue='campos.icms_st_bc_rt.optionInicialValue'
                  :cpntDisabled='campos.icms_st_bc_rt.disabled()'
                  :cpntMostrar='campos.icms_st_bc_rt.mostrar'
                  :cpntExplica='campos.icms_st_bc_rt.explica'
                  :cpntAutoFocus='campos.icms_st_bc_rt.autofocus'
                  :cpntMensagem='campos.icms_st_bc_rt.mensagem'
                  :cpntMensagemTipo='campos.icms_st_bc_rt.mensagemTipo'
                  :cpntPlaceholder='campos.icms_st_bc_rt.placeholder'
                  :cpntPosicionar='campos.icms_st_bc_rt.posicionar'
                  :cpntOnChange='campos.icms_st_bc_rt.onChange'
                  :cpntOnBlur='campos.icms_st_bc_rt.onBlur'
                  ref='icms_st_bc_rt'
                ></App-Input>

                <App-Input :data-time="time" :class="campos.icms_st_rt.id + ' ' + campos.icms_st_rt.class" :title='campos.icms_st_rt.title'
                  :cpntStatus='campos.icms_st_rt.status'
                  :cpntId='campos.icms_st_rt.id'
                  :cpntClassDivField='campos.icms_st_rt.classDivField'
                  :cpntNome='campos.icms_st_rt.nome'
                  :cpntValue='campos.icms_st_rt.value'
                  :cpntAutoComplete='campos.icms_st_rt.autocomplete'
                  :cpntMask='campos.icms_st_rt.mask'
                  :cpntOptionInicialNome='campos.icms_st_rt.optionInicialNome'
                  :cpntOptionInicialValue='campos.icms_st_rt.optionInicialValue'
                  :cpntDisabled='campos.icms_st_rt.disabled()'
                  :cpntMostrar='campos.icms_st_rt.mostrar'
                  :cpntExplica='campos.icms_st_rt.explica'
                  :cpntAutoFocus='campos.icms_st_rt.autofocus'
                  :cpntMensagem='campos.icms_st_rt.mensagem'
                  :cpntMensagemTipo='campos.icms_st_rt.mensagemTipo'
                  :cpntPlaceholder='campos.icms_st_rt.placeholder'
                  :cpntPosicionar='campos.icms_st_rt.posicionar'
                  :cpntOnChange='campos.icms_st_rt.onChange'
                  :cpntOnBlur='campos.icms_st_rt.onBlur'
                  ref='icms_st_rt'
                ></App-Input>
              </div>
            </div>

            <div class="titulo">
              <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
              ICMS FCP
            </div>
            <div class="quadrado">
              <div>
                <App-Input :data-time="time" :class="campos.icms_fcp_a.id + ' ' + campos.icms_fcp_a.class" :title='campos.icms_fcp_a.title'
                  :cpntStatus='campos.icms_fcp_a.status'
                  :cpntId='campos.icms_fcp_a.id'
                  :cpntClassDivField='campos.icms_fcp_a.classDivField'
                  :cpntNome='campos.icms_fcp_a.nome'
                  :cpntValue='campos.icms_fcp_a.value'
                  :cpntAutoComplete='campos.icms_fcp_a.autocomplete'
                  :cpntMask='campos.icms_fcp_a.mask'
                  :cpntOptionInicialNome='campos.icms_fcp_a.optionInicialNome'
                  :cpntOptionInicialValue='campos.icms_fcp_a.optionInicialValue'
                  :cpntDisabled='campos.icms_fcp_a.disabled()'
                  :cpntMostrar='campos.icms_fcp_a.mostrar'
                  :cpntExplica='campos.icms_fcp_a.explica'
                  :cpntAutoFocus='campos.icms_fcp_a.autofocus'
                  :cpntMensagem='campos.icms_fcp_a.mensagem'
                  :cpntMensagemTipo='campos.icms_fcp_a.mensagemTipo'
                  :cpntPlaceholder='campos.icms_fcp_a.placeholder'
                  :cpntPosicionar='campos.icms_fcp_a.posicionar'
                  :cpntOnChange='campos.icms_fcp_a.onChange'
                  :cpntOnBlur='campos.icms_fcp_a.onBlur'
                  ref='icms_fcp_a'
                ></App-Input>

                <App-Input :data-time="time" :class="campos.icms_fcp_st_a_cf.id + ' ' + campos.icms_fcp_st_a_cf.class" :title='campos.icms_fcp_st_a_cf.title'
                  :cpntStatus='campos.icms_fcp_st_a_cf.status'
                  :cpntId='campos.icms_fcp_st_a_cf.id'
                  :cpntClassDivField='campos.icms_fcp_st_a_cf.classDivField'
                  :cpntNome='campos.icms_fcp_st_a_cf.nome'
                  :cpntValue='campos.icms_fcp_st_a_cf.value'
                  :cpntAutoComplete='campos.icms_fcp_st_a_cf.autocomplete'
                  :cpntMask='campos.icms_fcp_st_a_cf.mask'
                  :cpntOptionInicialNome='campos.icms_fcp_st_a_cf.optionInicialNome'
                  :cpntOptionInicialValue='campos.icms_fcp_st_a_cf.optionInicialValue'
                  :cpntDisabled='campos.icms_fcp_st_a_cf.disabled()'
                  :cpntMostrar='campos.icms_fcp_st_a_cf.mostrar'
                  :cpntExplica='campos.icms_fcp_st_a_cf.explica'
                  :cpntAutoFocus='campos.icms_fcp_st_a_cf.autofocus'
                  :cpntMensagem='campos.icms_fcp_st_a_cf.mensagem'
                  :cpntMensagemTipo='campos.icms_fcp_st_a_cf.mensagemTipo'
                  :cpntPlaceholder='campos.icms_fcp_st_a_cf.placeholder'
                  :cpntPosicionar='campos.icms_fcp_st_a_cf.posicionar'
                  :cpntOnChange='campos.icms_fcp_st_a_cf.onChange'
                  :cpntOnBlur='campos.icms_fcp_st_a_cf.onBlur'
                  ref='icms_fcp_st_a_cf'
                ></App-Input>
              
                <App-Input :data-time="time" :class="campos.icms_fcp_st_r_bc.id + ' ' + campos.icms_fcp_st_r_bc.class" :title='campos.icms_fcp_st_r_bc.title'
                  :cpntStatus='campos.icms_fcp_st_r_bc.status'
                  :cpntId='campos.icms_fcp_st_r_bc.id'
                  :cpntClassDivField='campos.icms_fcp_st_r_bc.classDivField'
                  :cpntNome='campos.icms_fcp_st_r_bc.nome'
                  :cpntValue='campos.icms_fcp_st_r_bc.value'
                  :cpntAutoComplete='campos.icms_fcp_st_r_bc.autocomplete'
                  :cpntMask='campos.icms_fcp_st_r_bc.mask'
                  :cpntOptionInicialNome='campos.icms_fcp_st_r_bc.optionInicialNome'
                  :cpntOptionInicialValue='campos.icms_fcp_st_r_bc.optionInicialValue'
                  :cpntDisabled='campos.icms_fcp_st_r_bc.disabled()'
                  :cpntMostrar='campos.icms_fcp_st_r_bc.mostrar'
                  :cpntExplica='campos.icms_fcp_st_r_bc.explica'
                  :cpntAutoFocus='campos.icms_fcp_st_r_bc.autofocus'
                  :cpntMensagem='campos.icms_fcp_st_r_bc.mensagem'
                  :cpntMensagemTipo='campos.icms_fcp_st_r_bc.mensagemTipo'
                  :cpntPlaceholder='campos.icms_fcp_st_r_bc.placeholder'
                  :cpntPosicionar='campos.icms_fcp_st_r_bc.posicionar'
                  :cpntOnChange='campos.icms_fcp_st_r_bc.onChange'
                  :cpntOnBlur='campos.icms_fcp_st_r_bc.onBlur'
                  ref='icms_fcp_st_r_bc'
                ></App-Input>
              </div>

              <div>
                <App-Input :data-time="time" :class="campos.icms_fcp_st_a.id + ' ' + campos.icms_fcp_st_a.class" :title='campos.icms_fcp_st_a.title'
                  :cpntStatus='campos.icms_fcp_st_a.status'
                  :cpntId='campos.icms_fcp_st_a.id'
                  :cpntClassDivField='campos.icms_fcp_st_a.classDivField'
                  :cpntNome='campos.icms_fcp_st_a.nome'
                  :cpntValue='campos.icms_fcp_st_a.value'
                  :cpntAutoComplete='campos.icms_fcp_st_a.autocomplete'
                  :cpntMask='campos.icms_fcp_st_a.mask'
                  :cpntOptionInicialNome='campos.icms_fcp_st_a.optionInicialNome'
                  :cpntOptionInicialValue='campos.icms_fcp_st_a.optionInicialValue'
                  :cpntDisabled='campos.icms_fcp_st_a.disabled()'
                  :cpntMostrar='campos.icms_fcp_st_a.mostrar'
                  :cpntExplica='campos.icms_fcp_st_a.explica'
                  :cpntAutoFocus='campos.icms_fcp_st_a.autofocus'
                  :cpntMensagem='campos.icms_fcp_st_a.mensagem'
                  :cpntMensagemTipo='campos.icms_fcp_st_a.mensagemTipo'
                  :cpntPlaceholder='campos.icms_fcp_st_a.placeholder'
                  :cpntPosicionar='campos.icms_fcp_st_a.posicionar'
                  :cpntOnChange='campos.icms_fcp_st_a.onChange'
                  :cpntOnBlur='campos.icms_fcp_st_a.onBlur'
                  ref='icms_fcp_st_a'
                ></App-Input>

                <App-Input :data-time="time" :class="campos.icms_fcp_st_r_a.id + ' ' + campos.icms_fcp_st_r_a.class" :title='campos.icms_fcp_st_r_a.title'
                  :cpntStatus='campos.icms_fcp_st_r_a.status'
                  :cpntId='campos.icms_fcp_st_r_a.id'
                  :cpntClassDivField='campos.icms_fcp_st_r_a.classDivField'
                  :cpntNome='campos.icms_fcp_st_r_a.nome'
                  :cpntValue='campos.icms_fcp_st_r_a.value'
                  :cpntAutoComplete='campos.icms_fcp_st_r_a.autocomplete'
                  :cpntMask='campos.icms_fcp_st_r_a.mask'
                  :cpntOptionInicialNome='campos.icms_fcp_st_r_a.optionInicialNome'
                  :cpntOptionInicialValue='campos.icms_fcp_st_r_a.optionInicialValue'
                  :cpntDisabled='campos.icms_fcp_st_r_a.disabled()'
                  :cpntMostrar='campos.icms_fcp_st_r_a.mostrar'
                  :cpntExplica='campos.icms_fcp_st_r_a.explica'
                  :cpntAutoFocus='campos.icms_fcp_st_r_a.autofocus'
                  :cpntMensagem='campos.icms_fcp_st_r_a.mensagem'
                  :cpntMensagemTipo='campos.icms_fcp_st_r_a.mensagemTipo'
                  :cpntPlaceholder='campos.icms_fcp_st_r_a.placeholder'
                  :cpntPosicionar='campos.icms_fcp_st_r_a.posicionar'
                  :cpntOnChange='campos.icms_fcp_st_r_a.onChange'
                  :cpntOnBlur='campos.icms_fcp_st_r_a.onBlur'
                  ref='icms_fcp_st_r_a'
                ></App-Input>
              </div>
            </div>

            <div class="titulo">
              <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
              PIS
            </div>
            <div class="quadrado">
              <div>
                <App-Select :data-time="time" :class="campos.pis_cst.id + ' ' + campos.pis_cst.class" :title='campos.pis_cst.title'
                  :cpntStatus='campos.pis_cst.status'
                  :cpntId='campos.pis_cst.id'
                  :cpntTabIndex='campos.pis_cst.tabIndex'
                  :cpntNome='campos.pis_cst.nome'
                  :cpntValue='campos.pis_cst.value'
                  :cpntMensagem='campos.pis_cst.mensagem'
                  :cpntMensagemTipo='campos.pis_cst.mensagemTipo'
                  :cpntDisabled='campos.pis_cst.disabled'
                  :cpntMostrar='campos.pis_cst.mostrar'
                  :cpntExplica='campos.pis_cst.explica'
                  :cpntPlaceholder='campos.pis_cst.placeholder'
                  :cpntValueRef='campos.pis_cst.valueRef'
                  :cpntRouter='campos.pis_cst.router'
                  :cpntField='campos.pis_cst.field'
                  :cpntWhere='campos.pis_cst.where'
                  :cpntAddButForm='campos.pis_cst.addButForm'
                  :cpntKeyMostra='campos.pis_cst.keyMostra'
                  :cpntTipoOrder='campos.pis_cst.tipoOrder'
                  :cpntOrder='campos.pis_cst.order'
                  :cpntOptions='campos.pis_cst.options'
                  :cpntOptionInicialNome='campos.pis_cst.optionInicialNome'
                  :cpntOptionInicialValue='campos.pis_cst.optionInicialValue'
                  :cpntKeyValue='campos.pis_cst.keyValue'
                  :cpntSearchMinimo='campos.pis_cst.searchMinimo'
                  :cpntMask='campos.pis_cst.mask'

                  :cpntOnBuscarOptions='campos.pis_cst.onBuscarOptions'
                  :cpntOnChange='campos.pis_cst.onChange'
                  :cpntOnBlur='campos.pis_cst.onBlur'
                  :cpntOnRealizaBusca='campos.pis_cst.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.pis_cst.onKeyPressEnter'
                  ref="pis_cst"
                ></App-Select>

                <App-Input :data-time="time" :class="campos.pis_a.id + ' ' + campos.pis_a.class" :title='campos.pis_a.title'
                  :cpntStatus='campos.pis_a.status'
                  :cpntId='campos.pis_a.id'
                  :cpntClassDivField='campos.pis_a.classDivField'
                  :cpntNome='campos.pis_a.nome'
                  :cpntValue='campos.pis_a.value'
                  :cpntAutoComplete='campos.pis_a.autocomplete'
                  :cpntMask='campos.pis_a.mask'
                  :cpntOptionInicialNome='campos.pis_a.optionInicialNome'
                  :cpntOptionInicialValue='campos.pis_a.optionInicialValue'
                  :cpntDisabled='campos.pis_a.disabled()'
                  :cpntMostrar='campos.pis_a.mostrar'
                  :cpntExplica='campos.pis_a.explica'
                  :cpntAutoFocus='campos.pis_a.autofocus'
                  :cpntMensagem='campos.pis_a.mensagem'
                  :cpntMensagemTipo='campos.pis_a.mensagemTipo'
                  :cpntPlaceholder='campos.pis_a.placeholder'
                  :cpntPosicionar='campos.pis_a.posicionar'
                  :cpntOnChange='campos.pis_a.onChange'
                  :cpntOnBlur='campos.pis_a.onBlur'
                  ref='pis_a'
                ></App-Input>
              </div>
            </div>
            
            <div class="titulo">
              <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
              COFINS
            </div>
            <div class="quadrado">
              <div>
                <App-Select :data-time="time" :class="campos.cofins_cst.id + ' ' + campos.cofins_cst.class" :title='campos.cofins_cst.title'
                  :cpntStatus='campos.cofins_cst.status'
                  :cpntId='campos.cofins_cst.id'
                  :cpntTabIndex='campos.cofins_cst.tabIndex'
                  :cpntNome='campos.cofins_cst.nome'
                  :cpntValue='campos.cofins_cst.value'
                  :cpntMensagem='campos.cofins_cst.mensagem'
                  :cpntMensagemTipo='campos.cofins_cst.mensagemTipo'
                  :cpntDisabled='campos.cofins_cst.disabled'
                  :cpntMostrar='campos.cofins_cst.mostrar'
                  :cpntExplica='campos.cofins_cst.explica'
                  :cpntPlaceholder='campos.cofins_cst.placeholder'
                  :cpntValueRef='campos.cofins_cst.valueRef'
                  :cpntRouter='campos.cofins_cst.router'
                  :cpntField='campos.cofins_cst.field'
                  :cpntWhere='campos.cofins_cst.where'
                  :cpntAddButForm='campos.cofins_cst.addButForm'
                  :cpntKeyMostra='campos.cofins_cst.keyMostra'
                  :cpntTipoOrder='campos.cofins_cst.tipoOrder'
                  :cpntOrder='campos.cofins_cst.order'
                  :cpntOptions='campos.cofins_cst.options'
                  :cpntOptionInicialNome='campos.cofins_cst.optionInicialNome'
                  :cpntOptionInicialValue='campos.cofins_cst.optionInicialValue'
                  :cpntKeyValue='campos.cofins_cst.keyValue'
                  :cpntSearchMinimo='campos.cofins_cst.searchMinimo'
                  :cpntMask='campos.cofins_cst.mask'

                  :cpntOnBuscarOptions='campos.cofins_cst.onBuscarOptions'
                  :cpntOnChange='campos.cofins_cst.onChange'
                  :cpntOnBlur='campos.cofins_cst.onBlur'
                  :cpntOnRealizaBusca='campos.cofins_cst.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.cofins_cst.onKeyPressEnter'
                  ref="cofins_cst"
                ></App-Select>

                <App-Input :data-time="time" :class="campos.cofins_a.id + ' ' + campos.cofins_a.class" :title='campos.cofins_a.title'
                  :cpntStatus='campos.cofins_a.status'
                  :cpntId='campos.cofins_a.id'
                  :cpntClassDivField='campos.cofins_a.classDivField'
                  :cpntNome='campos.cofins_a.nome'
                  :cpntValue='campos.cofins_a.value'
                  :cpntAutoComplete='campos.cofins_a.autocomplete'
                  :cpntMask='campos.cofins_a.mask'
                  :cpntOptionInicialNome='campos.cofins_a.optionInicialNome'
                  :cpntOptionInicialValue='campos.cofins_a.optionInicialValue'
                  :cpntDisabled='campos.cofins_a.disabled()'
                  :cpntMostrar='campos.cofins_a.mostrar'
                  :cpntExplica='campos.cofins_a.explica'
                  :cpntAutoFocus='campos.cofins_a.autofocus'
                  :cpntMensagem='campos.cofins_a.mensagem'
                  :cpntMensagemTipo='campos.cofins_a.mensagemTipo'
                  :cpntPlaceholder='campos.cofins_a.placeholder'
                  :cpntPosicionar='campos.cofins_a.posicionar'
                  :cpntOnChange='campos.cofins_a.onChange'
                  :cpntOnBlur='campos.cofins_a.onBlur'
                  ref='cofins_a'
                ></App-Input>
              </div>
            </div>


            <template v-if="[ '', 'dem_dev_cliente', 'dem_dev_fornecedor' ].indexOf(proSitFisDemandaSel) === -1 || campos.id_cfop.value.ind_devol === '0'">
              <div class="titulo">
                <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
                IPI
              </div>
              <div class="quadrado">
                <div>
                  <App-Select :data-time="time" :class="campos.ipi_cst.id + ' ' + campos.ipi_cst.class" :title='campos.ipi_cst.title'
                    :cpntStatus='campos.ipi_cst.status'
                    :cpntId='campos.ipi_cst.id'
                    :cpntTabIndex='campos.ipi_cst.tabIndex'
                    :cpntNome='campos.ipi_cst.nome'
                    :cpntValue='campos.ipi_cst.value'
                    :cpntMensagem='campos.ipi_cst.mensagem'
                    :cpntMensagemTipo='campos.ipi_cst.mensagemTipo'
                    :cpntDisabled='campos.ipi_cst.disabled()'
                    :cpntMostrar='campos.ipi_cst.mostrar'
                    :cpntExplica='campos.ipi_cst.explica'
                    :cpntPlaceholder='campos.ipi_cst.placeholder'
                    :cpntValueRef='campos.ipi_cst.valueRef'
                    :cpntRouter='campos.ipi_cst.router'
                    :cpntField='campos.ipi_cst.field'
                    :cpntWhere='campos.ipi_cst.where'
                    :cpntAddButForm='campos.ipi_cst.addButForm'
                    :cpntKeyMostra='campos.ipi_cst.keyMostra'
                    :cpntTipoOrder='campos.ipi_cst.tipoOrder'
                    :cpntOrder='campos.ipi_cst.order'
                    :cpntOptions='campos.ipi_cst.options'
                    :cpntOptionInicialNome='campos.ipi_cst.optionInicialNome'
                    :cpntOptionInicialValue='campos.ipi_cst.optionInicialValue'
                    :cpntKeyValue='campos.ipi_cst.keyValue'
                    :cpntSearchMinimo='campos.ipi_cst.searchMinimo'
                    :cpntMask='campos.ipi_cst.mask'
  
                    :cpntOnBuscarOptions='campos.ipi_cst.onBuscarOptions'
                    :cpntOnChange='campos.ipi_cst.onChange'
                    :cpntOnBlur='campos.ipi_cst.onBlur'
                    :cpntOnRealizaBusca='campos.ipi_cst.onRealizaBusca'
                    :cpntOnKeyPressEnter='campos.ipi_cst.onKeyPressEnter'
                    ref="ipi_cst"
                  ></App-Select>
  
                  <App-Input :data-time="time" :class="campos.ipi_a.id + ' ' + campos.ipi_a.class" :title='campos.ipi_a.title'
                    :cpntStatus='campos.ipi_a.status'
                    :cpntId='campos.ipi_a.id'
                    :cpntClassDivField='campos.ipi_a.classDivField'
                    :cpntNome='campos.ipi_a.nome'
                    :cpntValue='campos.ipi_a.value'
                    :cpntAutoComplete='campos.ipi_a.autocomplete'
                    :cpntMask='campos.ipi_a.mask'
                    :cpntOptionInicialNome='campos.ipi_a.optionInicialNome'
                    :cpntOptionInicialValue='campos.ipi_a.optionInicialValue'
                    :cpntDisabled='campos.ipi_a.disabled()'
                    :cpntMostrar='campos.ipi_a.mostrar'
                    :cpntExplica='campos.ipi_a.explica'
                    :cpntAutoFocus='campos.ipi_a.autofocus'
                    :cpntMensagem='campos.ipi_a.mensagem'
                    :cpntMensagemTipo='campos.ipi_a.mensagemTipo'
                    :cpntPlaceholder='campos.ipi_a.placeholder'
                    :cpntPosicionar='campos.ipi_a.posicionar'
                    :cpntOnChange='campos.ipi_a.onChange'
                    :cpntOnBlur='campos.ipi_a.onBlur'
                    ref='ipi_a'
                  ></App-Input>
                </div>
  
                <div>
                  <App-Select :data-time="time" :class="campos.ipi_enq.id + ' ' + campos.ipi_enq.class" :title='campos.ipi_enq.title'
                    :cpntStatus='campos.ipi_enq.status'
                    :cpntId='campos.ipi_enq.id'
                    :cpntTabIndex='campos.ipi_enq.tabIndex'
                    :cpntNome='campos.ipi_enq.nome'
                    :cpntValue='campos.ipi_enq.value'
                    :cpntMensagem='campos.ipi_enq.mensagem'
                    :cpntMensagemTipo='campos.ipi_enq.mensagemTipo'
                    :cpntDisabled='campos.ipi_enq.disabled()'
                    :cpntMostrar='campos.ipi_enq.mostrar'
                    :cpntExplica='campos.ipi_enq.explica'
                    :cpntPlaceholder='campos.ipi_enq.placeholder'
                    :cpntValueRef='campos.ipi_enq.valueRef'
                    :cpntRouter='campos.ipi_enq.router'
                    :cpntField='campos.ipi_enq.field'
                    :cpntWhere='campos.ipi_enq.where'
                    :cpntAddButForm='campos.ipi_enq.addButForm'
                    :cpntKeyMostra='campos.ipi_enq.keyMostra'
                    :cpntTipoOrder='campos.ipi_enq.tipoOrder'
                    :cpntOrder='campos.ipi_enq.order'
                    :cpntOptions='campos.ipi_enq.options'
                    :cpntOptionInicialNome='campos.ipi_enq.optionInicialNome'
                    :cpntOptionInicialValue='campos.ipi_enq.optionInicialValue'
                    :cpntKeyValue='campos.ipi_enq.keyValue'
                    :cpntSearchMinimo='campos.ipi_enq.searchMinimo'
                    :cpntMask='campos.ipi_enq.mask'
  
                    :cpntOnBuscarOptions='campos.ipi_enq.onBuscarOptions'
                    :cpntOnChange='campos.ipi_enq.onChange'
                    :cpntOnBlur='campos.ipi_enq.onBlur'
                    :cpntOnRealizaBusca='campos.ipi_enq.onRealizaBusca'
                    :cpntOnKeyPressEnter='campos.ipi_enq.onKeyPressEnter'
                    ref="ipi_enq"
                  ></App-Select>
  
                  <App-Select :data-time="time" :class="campos.ipi_selo.id + ' ' + campos.ipi_selo.class" :title='campos.ipi_selo.title'
                    :cpntStatus='campos.ipi_selo.status'
                    :cpntId='campos.ipi_selo.id'
                    :cpntTabIndex='campos.ipi_selo.tabIndex'
                    :cpntNome='campos.ipi_selo.nome'
                    :cpntValue='campos.ipi_selo.value'
                    :cpntMensagem='campos.ipi_selo.mensagem'
                    :cpntMensagemTipo='campos.ipi_selo.mensagemTipo'
                    :cpntDisabled='campos.ipi_selo.disabled()'
                    :cpntMostrar='campos.ipi_selo.mostrar'
                    :cpntExplica='campos.ipi_selo.explica'
                    :cpntPlaceholder='campos.ipi_selo.placeholder'
                    :cpntValueRef='campos.ipi_selo.valueRef'
                    :cpntRouter='campos.ipi_selo.router'
                    :cpntField='campos.ipi_selo.field'
                    :cpntWhere='campos.ipi_selo.where'
                    :cpntAddButForm='campos.ipi_selo.addButForm'
                    :cpntKeyMostra='campos.ipi_selo.keyMostra'
                    :cpntTipoOrder='campos.ipi_selo.tipoOrder'
                    :cpntOrder='campos.ipi_selo.order'
                    :cpntOptions='campos.ipi_selo.options'
                    :cpntOptionInicialNome='campos.ipi_selo.optionInicialNome'
                    :cpntOptionInicialValue='campos.ipi_selo.optionInicialValue'
                    :cpntKeyValue='campos.ipi_selo.keyValue'
                    :cpntSearchMinimo='campos.ipi_selo.searchMinimo'
                    :cpntMask='campos.ipi_selo.mask'
  
                    :cpntOnBuscarOptions='campos.ipi_selo.onBuscarOptions'
                    :cpntOnChange='campos.ipi_selo.onChange'
                    :cpntOnBlur='campos.ipi_selo.onBlur'
                    :cpntOnRealizaBusca='campos.ipi_selo.onRealizaBusca'
                    :cpntOnKeyPressEnter='campos.ipi_selo.onKeyPressEnter'
                    ref="ipi_selo"
                  ></App-Select>
                </div>
              </div>
            </template>
          </div>
        </div>
        
        <RF-Dialog v-if="[ '', null, undefined ].indexOf(conflito) === -1"
        :cpntLargura='"500px"'
        :cpntFundoFechar="false"
        :cpntOcultarBotoes="true"
        :cpntStatus="''">
        <template slot='titulo'>
          <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
          <b>Atenção: Conflitos encontrados</b>
        </template>

        <template slot='conteudo'>
          <div class="pro-sit-fis-form--conflito">
            <App-Icone :cpntTipo="'alerta-amarelo'"></App-Icone>
            <br/>
            <br/>
            OPS! {{ conflito.length >= 2 ? 'Foram' : 'Foi' }} encontrado{{ conflito.length >= 2 ? 's' : '' }} 
            <App-Button :cpntClass="'btn btn-default btn-sm qtde-conflito'" @onClick="proSitFisFormularioDialogMostrarConflito">{{ conflito.length }}</App-Button> conflito{{ conflito.length >= 2 ? 's' : '' }}. 
            <br/>
            <br/>
            Caso prossiga os mesmos serão excluídos. Deseja prosseguir?
            <br/>
            <br/>
            <App-Button :cpntClass="'btn btn-primary btn-sm acao'" @onClick="proSitFisFormularioConflitoContinuar">Sim</App-Button>
            <App-Button :cpntClass="'btn btn-default btn-sm acao'" @onClick="proSitFisFormularioConflitoCancelar">Não</App-Button>
          </div>
        </template>
        </RF-Dialog>

        <RF-Dialog v-if="[ '', null, undefined ].indexOf(conflito) === -1 && mostrarConflito === true"
        :cpntLargura='(tela * 0.95).toString() + "px"'
        :cpntStatus="''"
        :cpntOnFecharDialog="proSitFisFormularioDialogMostrarConflito">
        <template slot='titulo'>
          <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
          <b>Atenção: Conflitos encontrados</b>
        </template>

        <template slot='conteudo'>
          <Produto-Sit-Fiscal :cpntFiltros="[ { f: 'id', o: 'in', v: conflito.join(',') } ]" :cpntConflito="true"></Produto-Sit-Fiscal>
        </template>
        </RF-Dialog>

        <RF-Dialog v-if="[ '', null, undefined ].indexOf(copiar) === -1"
        :cpntLargura='(tela * 0.90).toString() + "px"'
        :cpntStatus="''"
        :cpntOnFecharDialog="() => { copiar = null }">
        <template slot='titulo'>
          <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
          <b>Copiar situação fiscal</b>
        </template>

        <template slot='conteudo'>
          <Produto-Sit-Fiscal :cpntSelecionar="copiar"></Produto-Sit-Fiscal>
        </template>
        </RF-Dialog>

        <!-- CONFIRMAR REINICIALIZACAO DO CASO -->
        <RF-Dialog v-if="dialog === 'CONFIRMAR_REINICIALIZACAO'"
        :cpntLargura='"500px"'
        :cpntOnFecharDialog='() => { proSitFisFormularioFecharConfirmacaoReinicializacao(false) }'>
        <template slot="conteudo">
          <div class="pro-sit-fis-form-acao-confirmacao">
            <!-- APRESENTA A MENSAGEM -->
            Não há nada a ser atualizado na situação fiscal. Para remover o triângulo você deve reinicializar o item. 
            <br/>
            <br/>
            Deseja reinicializar agora?
            <br/>

            <!-- SETA O BOTÃO DE NOVA -->
            <App-Button :cpntClass="[ 'btn', 'btn-primary', 'btn-sm' ]" @onClick="() => { proSitFisFormularioFecharConfirmacaoReinicializacao(true) }">Sim</App-Button>

            <!-- SETA O BOTÃO DE ATUALIZAR -->
            <App-Button :cpntClass="[ 'btn', 'btn-default', 'btn-sm' ]" @onClick="() => { proSitFisFormularioFecharConfirmacaoReinicializacao(false) }">Não</App-Button>
          </div>
        </template>
        </RF-Dialog>
      </template>
    </template>

    <template slot='rodape' v-if="statusGeral === ''">
      <div class="pro-sit-fis-form-botoes">
        <RF-Button
          :cpntStatus='botoes.cancelar.status' 
          :cpntId='botoes.cancelar.id' 
          :cpntTexto='botoes.cancelar.texto' 
          :cpntClass='botoes.cancelar.class'
          :cpntMostrar='botoes.salvar.mostrar'
          :cpntTabIndex='botoes.cancelar.tabIndex'
          @onClickButton='botoes.cancelar.onClick'
        ></RF-Button>

        <RF-Button
          :cpntStatus='botoes.salvar.status' 
          :cpntId='botoes.salvar.id' 
          :cpntTexto='botoes.salvar.texto' 
          :cpntClass='botoes.salvar.class'
          :cpntMostrar='botoes.salvar.mostrar'
          :cpntTabIndex='botoes.salvar.tabIndex'
          @onClickButton='botoes.salvar.onClick'
        ></RF-Button>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>


.pro-sit-fis-alerta {
  text-align: center;
}
  .pro-sit-fis-alerta > svg {
    font-size: 50px;
    opacity: 0.80;
    margin-bottom: 10px;
  }

.pro-sit-fis-form {
  width: calc(100% - 10px);
}
  .pro-sit-fis-form > .seletores > .demanda_cfop {
    width: 100%;
    display: block;
    clear: both;
  }
    .pro-sit-fis-form > .seletores > .demanda_cfop > .demanda {
      display: inline-block;
      width: 460px;
    }
      .pro-sit-fis-form > .seletores > .demanda_cfop > .demanda > div > .pro-sit-fis-form--id_cfop {
        width: 300px;
      }
      .pro-sit-fis-form > .seletores > .demanda_cfop > .demanda > div > .pro-sit-fis-form--demanda {
        width: 150px;
        margin-left: 10px;
      }
    .pro-sit-fis-form > .seletores > .demanda_cfop > .pais,
    .pro-sit-fis-form > .seletores > .demanda_cfop > .estado {
      width: calc(100% - 470px);
      margin-left: 10px;
      display: inline-block;
    }
  .pro-sit-fis-form > .seletores > .campos {
    padding-top: 20px;
    margin-bottom: 15px;
    width: 300px;
    display: inline-block;
    /* float: right; */
    vertical-align: top;
    float: left;
  }
  .pro-sit-fis-form > .seletores > .mensagem {
    float: right;
    vertical-align: top;
    display: inline-block;
    width: 330px;
    border: 1px solid #e9e9e9;
    border-radius: 10px;
    padding: 10px;
    text-align: justify;
    background: #fdfdfd;
    margin-right: 35px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .pro-sit-fis-form > .seletores ~ hr {
    clear: both;
  }

  /* demanda_cfop */
  .pro-sit-fis-form > .seletores > div > div {
    /* width: calc((100% / 4) - (30px / 4));
    display: inline-block; */
    /* vertical-align: top; */
  }
  /* .pro-sit-fis-form > .seletores > div > div:not(:last-child) { */
  .pro-sit-fis-form > .seletores > :not(.demanda_cfop) > div:not(:first-child) {
    /* margin-right: 10px; */
    margin-top: 25px;
  }
  .pro-sit-fis-form > .seletores > .demanda_cfop {
    padding-top: 5px;
  }
    .pro-sit-fis-form > .seletores > div > div > table {
      margin-top: 5px;
    }

  .pro-sit-fis-form > .seletores > div > div > .pro-sit-fis-form--produto_todas ~ .cpnt-app-campo,
  .pro-sit-fis-form > .seletores > div > div > .pro-sit-fis-form--ncm_todas ~ .cpnt-app-campo,
  .pro-sit-fis-form > .seletores > div > div > .pro-sit-fis-form--pais_todas ~ .cpnt-app-campo,
  .pro-sit-fis-form > .seletores > div > div > .pro-sit-fis-form--estado_todas ~ .cpnt-app-campo,
  .pro-sit-fis-form > .seletores > div > div > .pro-sit-fis-form--contato_todas ~ .cpnt-app-campo {
    width: calc(100% - 100px);
    margin-left: 10px;
  }

  .pro-sit-fis-form > .seletores > div > div > .pro-sit-fis-form--produto_todas,
  .pro-sit-fis-form > .seletores > div > div > .pro-sit-fis-form--ncm_todas,
  .pro-sit-fis-form > .seletores > div > div > .pro-sit-fis-form--pais_todas,
  .pro-sit-fis-form > .seletores > div > div > .pro-sit-fis-form--estado_todas,
  .pro-sit-fis-form > .seletores > div > div > .pro-sit-fis-form--contato_todas {
    margin-bottom: 0px;
    width: 90px;
  }
  

  .pro-sit-fis-form--todos > .pro-sit-fis-form--produto,
  .pro-sit-fis-form--todos > .pro-sit-fis-form--ncm,
  .pro-sit-fis-form--todos > .pro-sit-fis-form--pais,
  .pro-sit-fis-form--todos > .pro-sit-fis-form--estado,
  .pro-sit-fis-form--todos > .pro-sit-fis-form--contato {
    display: none;
  }
  .pro-sit-fis-form--todos > .pro-sit-fis-form--produto_todas,
  .pro-sit-fis-form--todos > .pro-sit-fis-form--ncm_todas,
  .pro-sit-fis-form--todos > .pro-sit-fis-form--pais_todas,
  .pro-sit-fis-form--todos > .pro-sit-fis-form--estado_todas,
  .pro-sit-fis-form--todos > .pro-sit-fis-form--contato_todas {
    width: 100% !important;
  }

.dem-edi-pro-tab-detalhe {
  margin-top: 15px;
  padding-right: 10px;
}
  /* .pro-sit-fis-form > .campos > div:first-child {
    padding-top: 10px;
  } */
  /* .pro-sit-fis-form > .campos > div:not(:first-child) {
    padding-top: 22px;
  }
  .pro-sit-fis-form > .campos > :not(:first-child) > div > div {
    vertical-align: top;
  } */
  .campos > .titulo:not(:first-child) {
    margin-top: 10px;
  }
  .titulo {
    font-weight: bold;
    margin-bottom: -2px;
  }
  .quadrado {
    background: #f9f9f9;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px 10px 10px 10px;
  }
.pro-sit-fis-form > hr {
  clear: both;
  margin-bottom: 10px;
}
.pro-sit-fis-form > .campos {
  clear: both;
}
.pro-sit-fis-form > .campos > div > div {
  padding-top: 10px;
}
.pro-sit-fis-form > .campos > div > div > div {
  width: calc(50% - 5px);
}

.pro-sit-fis-form > .campos > div > div:not(:first-child) {
  padding-top: 22px;
}

.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--id_cfop {
  width: calc(70% - 10px);
}
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--demanda {
  width: 30%;
  margin-left: 10px;
}

.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_st_bc_rt,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_orig {
  width: calc((100% / 2) - 10px);
}
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_st_rt,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_cst {
  width: calc((100% / 2));
}
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_bc_mod,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_a,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_bc_p_r,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_st_bc_mod,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_st_a,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_bc_st_p_r {
  width: calc((100% / 4) - 10px);
}
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_bc_p_r_c,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_mva_p {
  width: calc((100% / 4));
}

.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_fcp_st_a,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_fcp_st_r_a {
  width: calc((100% / 2) - 5px);
}
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_fcp_a,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_fcp_st_a_cf,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_fcp_st_r_bc {
  width: calc((100% / 3) - 7px);
}
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_fcp_a,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_fcp_st_a_cf,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_fcp_st_a {
  margin-right: 10px;
}

.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_orig,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_bc_mod,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_a,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_bc_p_r,

.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_st_bc_mod,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_st_a,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_bc_st_p_r,

.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--icms_st_bc_rt,

.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--pis_cst,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--cofins_cst,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--ipi_cst,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--ipi_enq {
  margin-right: 10px;
}



.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--pis_cst,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--cofins_cst,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--ipi_cst {
  width: 65%;
}
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--pis_a,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--cofins_a,
.pro-sit-fis-form > .campos > div > div > .pro-sit-fis-form--ipi_a {
  width: calc(35% - 10px);
}

.pro-sit-fis-form-botoes {
  text-align: right;
}
  .pro-sit-fis-form-botoes > button:not(:first-child) {
    margin-left: 5px;
  }

.pro-sit-fis-form--conflito {
  text-align: center;
}
  .pro-sit-fis-form--conflito > button:not(.qtde-conflito) {
    margin: 0px 5px;
    width: 70px;
  }
  .pro-sit-fis-form--conflito > button.qtde-conflito {
    padding: 0px 5px;
    min-width: 20px;
    font-size: 14px;
  }

  .pro-sit-fis-form-acao-confirmacao {
    text-align: center;
    padding-top: 5px;
  }
    .pro-sit-fis-form-acao-confirmacao > button {
      width: 150px;
      margin: 15px 8px;
    }
</style>

<style>
.pro-sit-fis-form > .seletores > .mensagem > span > img {
  margin-right: 5px;
}
.pro-sit-fis-form--conflito > span > img {
  width: 50px;
  height: 50px;
}
.pro-sit-fis-form > .seletores > div > div > table > thead > tr > th.col_botao,
.pro-sit-fis-form > .seletores > div > div > table > tbody > tr > td.col_botao {
  width: 50px;
}
  .pro-sit-fis-form > .seletores > div > div > table > tbody > tr > td.col_botao > div > span > button {
    padding: 2px 4px;
    border: none;
    color: #777;
  }

.pro-sit-fis-form > .seletores > div > div > .pro-sit-fis-form--produto_todas > div,
.pro-sit-fis-form > .seletores > div > div > .pro-sit-fis-form--ncm_todas > div,
.pro-sit-fis-form > .seletores > div > div > .pro-sit-fis-form--pais_todas > div,
.pro-sit-fis-form > .seletores > div > div > .pro-sit-fis-form--estado_todas > div,
.pro-sit-fis-form > .seletores > div > div > .pro-sit-fis-form--contato_todas > div {
  width: 100% !important;
}
</style>

<script>
  export default {
    props: {
      cpntId: {
        required: true,
        type: [ String, Number, Array ],
        default: function () {
          return 0
        }
      },
      cpntIsOpenDemanda: {
        required: false,
        default: function () {
          return false
        }
      },
      cpntDemanda: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntProdutos: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntContatos: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntEstados: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntPais: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntNcms: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntDiff: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntIdConUF: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntIdConPessoa: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntFecharFormulario: {
        required: true
      }
    },
    components: {
      'Produto-Sit-Fiscal': () => import('@/components/produto/sit-fiscal/Produto-Sit-Fiscal.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        tela: window.innerWidth,
        conflito: '',
        copiar: null,
        mostrarConflito: false,
        dialog: null,
        tabela: {
          remover: {
            status: '',
            id: 'pro-sit-fis-tab--',
            tipo: 'icone',
            icone: { tipo: 'cancelar' },
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            onClick: this.proSitFisFormularioRemoverLinha
          },
          // demanda: {
          //   chaves: [],
          //   colunas: [
          //     { mPer: 1, chave: 'nome', nome: 'Demanda' },
          //     { mPer: 1, chave: 'botao', nome: 'Excluir' }
          //   ],
          //   linha: [],
          // },
          produto: {
            chaves: [],
            colunas: [
              { mPer: 1, chave: 'codigo', nome: 'Código' },
              { mPer: 1, chave: 'nome',   nome: 'Nome' },
              { mPer: 1, chave: 'botao', nome: 'Excluir' }
            ],
            linha: [],
          },
          ncm: {
            chaves: [],
            colunas: [
              { mPer: 1, chave: 'ncm', nome: 'NCM/SH' },
              { mPer: 1, chave: 'botao', nome: 'Excluir' }
            ],
            linha: [],
          },
          pais: {
            chaves: [],
            colunas: [
              { mPer: 1, chave: 'cPais', nome: 'Cód.' },
              { mPer: 1, chave: 'img', nome: 'Bandeira' },
              { mPer: 1, chave: 'xPais', nome: 'País' },
              { mPer: 1, chave: 'botao', nome: 'Excluir' }
            ],
            linha: [],
          },
          estado: {
            chaves: [],
            colunas: [
              { mPer: 1, chave: 'uf', nome: 'UF' },
              { mPer: 1, chave: 'estado', nome: 'Estado' },
              { mPer: 1, chave: 'botao', nome: 'Excluir' }
            ],
            linha: [],
          },
          contato: {
            chaves: [],
            colunas: [
              { mPer: 1, chave: 'nome', nome: 'Nome' },
              { mPer: 1, chave: 'botao', nome: 'Excluir' }
            ],
            linha: [],
          }
        },
        botoes: {
          cancelar: {
            status: '',
            id: this.cpntId + '--acao-editar--cancelar',
            texto: 'Cancelar',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            onClick: () => { this.proSitFisFormularioFechar(false) }
          },
          salvar: {
            status: '',
            id: this.cpntId + '--acao-editar--salvar',
            texto: 'Salvar',
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: () => { this.proSitFisFormularioSalvar() }
          },
        },
        campos: {
          id_caso: {
            id: 'pro-sit-fis-form--id_caso',
            status: '',
            class: '',
            title: '',
            nome: 'Caso',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            mostrar: true,
            options: [],
            value: '',
            valueIni: '',
            newOption: true,
            optionInicialNome: 'Selecione',
            apiEnv: 'id_caso',
            onBuscarOptions: this.proSitFisFormularioBuscarCasos,
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          demanda: {
            id: 'pro-sit-fis-form--demanda',
            status: '',
            class: '',
            title: '',
            nome: 'Demanda',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            mostrar: true,
            optionInicialNome: 'Selecione',
            options: [],
            value: '',
            valueIni: '',
            apiEnv: 'demanda',
            disabled: () => { return this.proSitFisFormularioCampoDemandaDisabled() },
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },

          ncm_todas: {
            id: 'pro-sit-fis-form--ncm_todas',
            status: '',
            class: '',
            title: '',
            nome: 'NCM',
            on: 'Todas (menos as exceções)',
            off: 'Sel. Todos',
            value: true,
            onChange: this.proSitFisFormularioOnChangeValue
          },
          ncm: {
            id: 'pro-sit-fis-form--ncm',
            status: '',
            class: '',
            title: '',
            nome: '',
            keyValue: 'ncm',
            keyMostra: [ 'ncm' ],
            newOption: {
              tipo: 'icone',
              icone: { tipo: 'ico-mais' },
              explica: { titulo: '', mensagem: 'Adicionar nova ncm' },
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              onClick: this.proSitFisFormularioOnNovoNcm
            },
            mostrar: true,
            value: '',
            valueIni: '',
            router: '',
            // router: '/produto/get',
            method: 'POST',
            field: { ncm: { o: 'distinct' } },
            where: { aAnd: [ 
              { f: 'status', o: '=', v: '1' },
              { f: 'ncm', o: '<>', v: '' },
              { f: 'ncm', o: 'isNotNull' },
              { f: 'ncm', o: 'like', v: '%#BUSCA#%' },
              { f: 'ncm', o: 'notIn', r: 'ncm', q: {
                model: 'produto_sit_fiscal2',
                where: { aAnd: [
                  { f: 'ncm', o: 'in', r: 'ncm', q: {
                    model: 'produto',
                    where: { aAnd: [
                      { f: 'status', o: '=', v: '1' },
                      { f: 'ncm', o: '<>', v: '' },
                      { f: 'ncm', o: 'isNotNull' },
                      { f: 'ncm', o: 'like', v: '%#BUSCA#%' },
                    ] }
                  } }
                ] }
              } }
            ] },
            disabled: false,
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          produto_todas: {
            id: 'pro-sit-fis-form--produto_todas',
            status: '',
            class: '',
            title: '',
            nome: 'Produto',
            on: 'Todos (menos as exceções)',
            off: 'Sel. Todos',
            value: true,
            onChange: this.proSitFisFormularioOnChangeValue
          },
          produto: {
            id: 'pro-sit-fis-form--produto',
            status: '',
            class: '',
            title: '',
            nome: '',
            where: 'dem-edi-pro',
            keyValue: 'id',
            keyMostra: [ 'nome', ' - ', 'id_cat_nome', ' - ', 'id_mar_nome', ' - ', 'codigo' ],
            newOption: {
              tipo: 'icone',
              icone: { tipo: 'ico-mais' },
              explica: { titulo: '', mensagem: 'Adicionar novo produto' },
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              onClick: this.proSitFisFormularioOnNovoProduto
            },
            mostrar: true,
            value: '',
            valueIni: '',
            router: '/produto/get',
            method: 'POST',
            field: { id: null, codigo: null, nome: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } } },
            disabled: false,
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },

          estado_todas: {
            id: 'pro-sit-fis-form--estado_todas',
            status: '',
            class: '',
            title: '',
            nome: 'Estado',
            on: 'Todos (menos as exceções)',
            off: 'Sel. Todos',
            value: true,
            disabled: false,
            onChange: this.proSitFisFormularioOnChangeValue
          },
          estado: {
            id: 'pro-sit-fis-form--estado',
            status: '',
            class: '',
            title: '',
            nome: '',
            keyValue: 'uf',
            keyMostra: [ 'uf', ' - ', 'estado' ],
            options: [],
            optionInicialNome: '',
            optionInicialValue: '',
            mostrar: true,
            value: '',
            valueIni: '',
            disabled: false,
            onBuscarOptions: this.proSitFisFormularioBuscarEstados,
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },

          pais_todas: {
            id: 'pro-sit-fis-form--pais_todas',
            status: '',
            class: '',
            title: '',
            nome: 'País',
            on: 'Todos (menos as exceções)',
            off: 'Sel. Todos',
            value: true,
            disabled: false,
            onChange: this.proSitFisFormularioOnChangeValue
          },
          pais: {
            id: 'pro-sit-fis-form--pais',
            matar: '',
            status: '',
            class: '',
            title: '',
            nome: '',
            keyValue: 'cPais',
            keyMostra: [ 'xPais', ' (', 'cPais', ')' ],
            options: [],
            optionInicialNome: '',
            optionInicialValue: '',
            mostrar: true,
            value: '',
            valueIni: '',
            disabled: false,
            onBuscarOptions: this.proSitFisFormularioBuscarPais,
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },

          contato_todas: {
            id: 'pro-sit-fis-form--contato_todas',
            status: '',
            class: '',
            title: '',
            nome: 'Contato',
            on: 'Todos (menos as exceções)',
            off: 'Sel. Todos',
            value: true,
            onChange: this.proSitFisFormularioOnChangeValue
          },
          contato: {
            id: 'pro-sit-fis-form--contato',
            status: '',
            class: '',
            title: '',
            nome: '',
            keyValue: 'id',
            keyMostra: [ 'nome', ' | ', 'empresa', ' | ', 'cnpj_cpf' ],
            newOption: {
              tipo: 'icone',
              icone: { tipo: 'ico-mais' },
              explica: { titulo: '', mensagem: 'Adicionar novo contato' },
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              onClick: this.proSitFisFormularioOnNovoContato
            },
            mostrar: true,
            value: '',
            valueIni: '',
            onBuscarOptions: this.proSitFisFormularioBuscarContatos,
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },

          id_cfop: {
            id: 'pro-sit-fis-form--id_cfop',
            status: '',
            class: '',
            title: '',
            nome: 'CFOP',
            keyValue: 'cfop',
            keyMostra: [ 'cfop', ' - ', 'descricao' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            apiEnv: 'id_cfop',
            onBuscarOptions: this.proSitFisFormularioOnBuscarCFOP,
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          icms_orig: {
            id: 'pro-sit-fis-form--icms_orig',
            status: '',
            class: '',
            title: '',
            nome: 'Origem',
            keyValue: 'ref_icms_origem_id',
            keyMostra: [ 'ref_icms_origem_id', ' - ', 'ref_icms_origem_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            apiEnv: 'icms_orig',
            onBuscarOptions: this.proSitFisFormularioOnBuscarIcmsOrigem,
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          icms_cst: {
            id: 'pro-sit-fis-form--icms_cst',
            status: '',
            class: '',
            title: '',
            keyValue: 'ref_icms_cst',
            keyMostra: [ 'ref_icms_cst', ' - ', 'ref_icms_cst_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            apiEnv: 'icms_cst',
            onBuscarOptions: this.proSitFisFormularioOnBuscarCstIcms,
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },

          icms_bc_mod: {
            id: 'pro-sit-fis-form--icms_bc_mod',
            status: '',
            class: '',
            title: '',
            nome: 'Mod. BC',
            keyValue: 'ref_icms_mod_bc_id',
            keyMostra: [ 'ref_icms_mod_bc_id', ' - ', 'ref_icms_mod_bc_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            explica: { mensagem: 'Modalidade base de cálculo ICMS' },
            value: '',
            valueIni: '',
            apiEnv: 'icms_bc_mod',
            disabled: () => { return this.proSitFisFormularioCampoIcmsModBcDisabled() },
            onBuscarOptions: this.proSitFisFormularioOnBuscarIcmsModBc,
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          icms_a: {
            id: 'pro-sit-fis-form--icms_a',
            status: '',
            class: '',
            title: '',
            nome: '% ICMS',
            mask: 'valorMoeda',
            explica: { mensagem: 'Alíquota ICMS' },
            value: '',
            valueIni: '',
            apiEnv: 'icms_a',
            disabled: () => { return this.proSitFisFormularioCampoIcmsAliquotaDisabled() },
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          icms_bc_p_r: {
            id: 'pro-sit-fis-form--icms_bc_p_r',
            status: '',
            class: '',
            title: '',
            nome: '% Redução',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            apiEnv: 'icms_bc_p_r',
            disabled: () => { return this.proSitFisFormularioCampoIcmsReducaoDisabled() },
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          icms_bc_p_r_c: {
            id: 'pro-sit-fis-form--icms_bc_p_r_c',
            status: '',
            class: '',
            title: '',
            nome: 'Sobre',
            keyValue: 'id',
            keyMostra: [ 'descricao' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            apiEnv: 'icms_bc_p_r_c',
            disabled: () => { return this.proSitFisFormularioCampoIcmsReducaoSobreDisabled() },
            onBuscarOptions: this.proSitFisFormularioOnBuscarRedSobre,
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },

          icms_st_bc_mod: {
            id: 'pro-sit-fis-form--icms_st_bc_mod',
            status: '',
            class: '',
            title: '',
            nome: 'Mod. BC ST',
            keyValue: 'ref_icms_mod_bc_st_id',
            keyMostra: [ 'ref_icms_mod_bc_st_id', ' - ', 'ref_icms_mod_bc_st_desc' ],
            options: [],
            optionInicialNome: 'Não aplicável',
            optionInicialValue: '-1',
            mostrar: true,
            explica: { mensagem: 'Modalidade base de cálculo ICMS Substituição Tributária' },
            value: '',
            valueIni: '',
            apiEnv: 'icms_st_bc_mod',
            disabled: () => { return this.proSitFisFormularioCampoIcmsStModBcDisabled() },
            onBuscarOptions: this.proSitFisFormularioOnBuscarIcmsModBcSt,
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          icms_mva_p: {
            id: 'pro-sit-fis-form--icms_mva_p',
            status: '',
            class: '',
            title: '',
            nome: 'MVA %',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            apiEnv: 'icms_mva_p',
            disabled: () => { return this.proSitFisFormularioCampoIcmsStMvaDisabled() },
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          icms_st_bc_rt: {
            id: 'pro-sit-fis-form--icms_st_bc_rt',
            status: '',
            class: '',
            title: '',
            nome: 'Valor BC ICMS retido por ST',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            apiEnv: 'icms_st_bc_rt',
            disabled: () => { return this.proSitFisFormularioCampoIcmsBCRetidoPorStDisabled() },
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          icms_st_rt: {
            id: 'pro-sit-fis-form--icms_st_rt',
            status: '',
            class: '',
            title: '',
            nome: 'Valor ICMS retido por ST',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            apiEnv: 'icms_st_rt',
            disabled: () => { return this.proSitFisFormularioCampoIcmsRetidoPorStDisabled() },
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          icms_st_a: {
            id: 'pro-sit-fis-form--icms_st_a',
            status: '',
            class: '',
            title: '',
            nome: '% ICMS ST',
            mask: 'valorMoeda',
            explica: { mensagem: 'Alíquota ICMS Substituição Tributária' },
            value: '',
            valueIni: '',
            apiEnv: 'icms_st_a',
            disabled: () => { return this.proSitFisFormularioCampoIcmsStAliquotaDisabled() },
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          icms_bc_st_p_r: {
            id: 'pro-sit-fis-form--icms_bc_st_p_r',
            status: '',
            class: '',
            title: '',
            nome: 'Redução ST %',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            apiEnv: 'icms_bc_st_p_r',
            disabled: () => { return this.proSitFisFormularioCampoIcmsStReducaoDisabled() },
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },

          icms_fcp_a: {
            id: 'pro-sit-fis-form--icms_fcp_a',
            status: '',
            class: '',
            title: '',
            nome: 'Alíquota FCP %',
            mask: 'valorMoeda',
            value: '0,00',
            valueIni: '0,00',
            apiEnv: 'icms_fcp_a',
            disabled: () => { return this.proSitFisFormularioCampoIcmsFcpAliquotaDisabled() },
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          icms_fcp_st_a_cf: {
            id: 'pro-sit-fis-form--icms_fcp_st_a_cf',
            status: '',
            class: '',
            title: '',
            nome: '% Suportada pelo Consumidor Final',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            apiEnv: 'icms_fcp_st_a_cf',
            explica: { mensagem: 'Alíquota suportada pelo Consumidor Final' },
            disabled: () => { return this.proSitFisFormularioCampoIcmsFcpSupConFinalDisabled() },
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          icms_fcp_st_r_bc: {
            id: 'pro-sit-fis-form--icms_fcp_st_r_bc',
            status: '',
            class: '',
            title: '',
            nome: 'Valor BC retido por ST',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            apiEnv: 'icms_fcp_st_r_bc',
            explica: { mensagem: 'Valor da Base de Cálculo do FCP retido anteriormente por ST' },
            disabled: () => { return this.proSitFisFormularioCampoIcmsFcpBcRetidoSTDisabled() },
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          icms_fcp_st_a: {
            id: 'pro-sit-fis-form--icms_fcp_st_a',
            status: '',
            class: '',
            title: '',
            nome: 'Alíquota FCP ST %',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            apiEnv: 'icms_fcp_st_a',
            disabled: () => { return this.proSitFisFormularioCampoIcmsFcpSTAliquotaDisabled() },
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          icms_fcp_st_r_a: {
            id: 'pro-sit-fis-form--icms_fcp_st_r_a',
            status: '',
            class: '',
            title: '',
            nome: '% do FCP retido por ST',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            apiEnv: 'icms_fcp_st_r_a',
            explica: { mensagem: 'Percentual do Fundo de Combate à Pobreza (FCP) retido anteriormente por ST' },
            disabled: () => { return this.proSitFisFormularioCampoIcmsFcpAliquotaRetidoSTDisabled() },
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },

          pis_cst: {
            id: 'pro-sit-fis-form--pis_cst',
            status: '',
            class: '',
            title: '',
            nome: 'CST',
            keyValue: 'ref_pc_cst',
            keyMostra: [ 'ref_pc_cst', ' - ', 'ref_pc_cst_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            apiEnv: 'pis_cst',
            onBuscarOptions: this.proSitFisFormularioOnBuscarCstPisCofins,
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          pis_a: {
            id: 'pro-sit-fis-form--pis_a',
            status: '',
            class: '',
            title: '',
            nome: 'Alíquota %',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            apiEnv: 'pis_a',
            disabled: () => { return this.proSitFisFormularioCampoPisAliquotaDisabled() },
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },

          cofins_cst: {
            id: 'pro-sit-fis-form--cofins_cst',
            status: '',
            class: '',
            title: '',
            nome: 'CST',
            keyValue: 'ref_pc_cst',
            keyMostra: [ 'ref_pc_cst', ' - ', 'ref_pc_cst_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            apiEnv: 'cofins_cst',
            onBuscarOptions: this.proSitFisFormularioOnBuscarCstPisCofins,
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          cofins_a: {
            id: 'pro-sit-fis-form--cofins_a',
            status: '',
            class: '',
            title: '',
            nome: 'Alíquota %',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            apiEnv: 'cofins_a',
            disabled: () => { return this.proSitFisFormularioCampoCofinsAliquotaDisabled() },
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },

          ipi_cst: {
            id: 'pro-sit-fis-form--ipi_cst',
            status: '',
            class: '',
            title: '',
            nome: 'CST',
            keyValue: 'ref_ipi_cst',
            keyMostra: [ 'ref_ipi_cst', ' - ', 'ref_ipi_cst_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            optionInicialValue: '',
            mostrar: true,
            value: '',
            valueIni: '',
            apiEnv: 'ipi_cst',
            // [ '', 'dem_dev_cliente', 'dem_dev_fornecedor' ].indexOf(this.proSitFisDemandaSel) !== -1 && this.campos.id_cfop.value.ind_devol !== '0'
            disabled: () => { return ([ '', 'dem_dev_cliente', 'dem_dev_fornecedor' ].indexOf(this.proSitFisDemandaSel) !== -1 && this.campos.id_cfop.value.ind_devol !== '0') },
            onBuscarOptions: this.proSitFisFormularioOnBuscarCstIpi,
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          ipi_a: {
            id: 'pro-sit-fis-form--ipi_a',
            status: '',
            class: '',
            title: '',
            nome: 'Alíquota %',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            apiEnv: 'ipi_a',
            disabled: () => { return ([ '', 'dem_dev_cliente', 'dem_dev_fornecedor' ].indexOf(this.proSitFisDemandaSel) !== -1 && this.campos.id_cfop.value.ind_devol !== '0') || this.proSitFisFormularioCampoIpiAliquotaDisabled() },
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },

          ipi_enq: {
            id: 'pro-sit-fis-form--ipi_enq',
            status: '',
            class: '',
            title: '',
            nome: 'Enquadramento',
            keyValue: 'ref_ipi_enq',
            keyMostra: [ 'ref_ipi_enq', ' - ', 'ref_ipi_enq_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            apiEnv: 'ipi_enq',
            disabled: () => { return ([ '', 'dem_dev_cliente', 'dem_dev_fornecedor' ].indexOf(this.proSitFisDemandaSel) !== -1 && this.campos.id_cfop.value.ind_devol !== '0') || this.proSitFisFormularioCampoIpiEnquadramentoDisabled() },
            onBuscarOptions: this.proSitFisFormularioOnBuscarEnquadramentoIpi,
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          },
          ipi_selo: {
            id: 'pro-sit-fis-form--ipi_selo',
            status: '',
            class: '',
            title: '',
            nome: 'Selo',
            keyValue: 'ref_ipi_selo',
            keyMostra: [ 'ref_ipi_selo', ' - ', 'ref_ipi_tipo', ' - ', 'ref_ipi_cor' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            apiEnv: 'ipi_selo',
            disabled: () => { return ([ '', 'dem_dev_cliente', 'dem_dev_fornecedor' ].indexOf(this.proSitFisDemandaSel) !== -1 && this.campos.id_cfop.value.ind_devol !== '0') || this.proSitFisFormularioCampoIpiSeloDisabled() },
            onBuscarOptions: this.proSitFisFormularioOnBuscarSeloIpi,
            onChange: this.proSitFisFormularioOnChangeValue,
            onKeyPressEnter: this.proSitFisFormularioOnKeyPressEnter
          }
        }
      }
    },
    mounted: function () {
      // SETA O STATUS DA TELA
      this.proSitFisFormularioSetarStatusGeral('carregando')

      // VERIFICA SE TEM AS CONFIGURAÇÕES MINIMAS PARA ABRIR A TELA
      if ([ '', null, undefined ].indexOf(this.$store.state.licenca.uf) !== -1) {
        this.proSitFisFormularioSetarStatusGeral('estado')
      } else if ([ '1', '2', '3' ].indexOf(this.$store.state.licenca.rt_id) === -1) {
        this.proSitFisFormularioSetarStatusGeral('regime')
      } else {
        this.proSitFisFormularioIniciar()
      }
    },
    methods: {
      proSitFisFormularioIniciar: function () {
        if ([ '', null, undefined, '0', 0 ].indexOf(this.cpntId) === -1 && typeof this.cpntId !== 'object') {
          // SETA OS VALORES RECEBIDOS
          // this.campos.demanda.status = 'carregando'
          this.campos.ncm.status = 'carregando'
          this.campos.produto.status = 'carregando'
          this.campos.estado.status = 'carregando'
          this.campos.pais.status = 'carregando'
          this.campos.contato.status = 'carregando'
          this.campos.pis_cst.status = 'carregando'
          this.campos.cofins_cst.status = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // CARREGA OS DADOS DO AGRUPAMENTO
          this.proSitFisFormularioBuscarValores(this.cpntId, () => { this.proSitFisFormularioSetarStatusGeral('') })
        } else if ([ '0', 0 ].indexOf(this.cpntId) !== -1) {
          // // VERIFICA O REGIME TRIBUTARIO E SE DEVE SETAR O VALOR DA ALIQUOTA DO NO CAMPO
          // if ([ '1', '2' ].indexOf(this.$store.state.licenca.rt_id) !== -1) {
          //   // SETA O VALOR QUE DEVE SELECIONAR
          //   this.campos.pis_cst.value = { ref_pc_cst: '49', ref_pc_ope: '1', ref_pc_cst_desc: 'Outras Operações de Saída', 'ref_pc_a': '1' }

          //   // SETA O VALOR QUE DEVE SELECIONAR
          //   this.campos.cofins_cst.value = { ref_pc_cst: '49', ref_pc_ope: '1', ref_pc_cst_desc: 'Outras Operações de Saída', 'ref_pc_a': '1' }
          // }

          // SETA OS VALORES RECEBIDOS
          // this.campos.demanda.status = 'carregando'
          this.campos.ncm.status = 'carregando'
          this.campos.produto.status = 'carregando'
          this.campos.estado.status = 'carregando'
          this.campos.pais.status = 'carregando'
          this.campos.contato.status = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA BUSCAR E SETAR OS PRODUTOS DESEJADOS
          this.proSitFisFormularioBuscaSetarProdutos()

          // CHAMA A FUNÇÃO PARA BUSCAR E SETAR OS CONTATOS DESEJADOS
          this.proSitFisFormularioBuscaSetarContatos()

          // CHAMA A FUNÇÃO PARA BUSCAR E SETAR OS ESTADOS DESEJADOS
          this.proSitFisFormularioBuscaSetarEstados()

          // CHAMA A FUNÇÃO PARA BUSCAR E SETAR OS ESTADOS DESEJADOS
          this.proSitFisFormularioBuscaSetarPais()

          // CHAMA A FUNÇÃO SETAR AS NCMS DESEJADOS
          this.proSitFisFormularioSetarNcms()

          // // CHAMA A FUNÇÃO SETAR AS DEMANDAS DESEJADOS
          // this.proSitFisFormularioSetarDemanda()

          // VERIFICA SE TEM DIFERENÇA A SER SETADA
          if ([ '', null, undefined ].indexOf(this.cpntDiff) === -1) {
            this.proSitFisFormularioSetarDiferencas()
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // SETA O STATUS DA TELA
          this.proSitFisFormularioSetarStatusGeral('')
        }
      },
      proSitFisFormularioSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proSitFisFormularioSetarNcms: function () {
        // LIMPA AS VARIAVEIS
        this.tabela.ncm.linha = []
        this.tabela.ncm.chaves = []

        // VERIFICA SE DEVE INCLUIR O VALOR NA TABELA
        if (this.cpntNcms !== null && this.cpntNcms.length >= 1) {
          for (var indexR in this.cpntNcms) {
            if ([ '', null, undefined ].indexOf(this.cpntNcms[indexR]) === -1) {
              // SETA OS ncm RECEBIDO
              var vetor = { ncm: this.cpntNcms[indexR] }

              // ADICIONA O VALOR NA TABELA
              this.tabela.ncm.linha.push(JSON.parse(JSON.stringify(vetor)))

              // ADICIONA O VALOR NO VETOR
              this.tabela.ncm.chaves.push(vetor.ncm)
            }
          }
        }

        // VERIFICA SE ESTÁ SELECIONADO TODOS
        this.campos.ncm_todas.value = this.tabela.ncm.chaves.length === 0

        // SETA O STATUS DO CAMPO
        this.campos.ncm.status = ''

        // VERIFICA SE DEVE DESATIVAR O CAMPO
        this.proSitFisFormularioCampoVerificaInserirMais('ncm')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proSitFisFormularioBuscaSetarProdutos: function (registros = [], total = null) {
        if (this.cpntProdutos !== null && this.cpntProdutos.length >= 1 && (total === null || registros.length < total)) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, field: { id: null, nome: null, status: null } }
  
          // SETA BUSCA QUE DEVE REALIZAR
          queryGet.where = { aAnd: [ { f: 'id', o: 'in', v: this.cpntProdutos.join() } ] }
  
          // FAZ A BUSCA NA API
          this.$store.state.comunicaAPI('/produto/get', 'POST', queryGet, (retorno) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(retorno.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS OUTROS REGISTROS
            this.proSitFisFormularioBuscaSetarProdutos(registros, Number(retorno.countAll))
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.produto.status = apiError
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // LIMPA AS VARIAVEIS
          this.tabela.produto.linha = []
          this.tabela.produto.chaves = []

          // ADICIONA OS VALORES RECEBIDOS
          for (var indexR in registros) {
            // ADICIONA O VALOR NA TABELA
            this.tabela.produto.linha.push(registros[indexR])

            // ADICIONA O VALOR NO VETOR
            this.tabela.produto.chaves.push(registros[indexR].id)
          }

          // VERIFICA SE DEVE ABRIR O TODOS SELECIONADO
          this.campos.produto_todas.value = this.tabela.produto.chaves.length === 0

          // SETA O STATUS DO CAMPO
          this.campos.produto.status = ''

          // VERIFICA SE DEVE DESATIVAR O CAMPO
          this.proSitFisFormularioCampoVerificaInserirMais('produto')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      proSitFisFormularioBuscaSetarContatos: function (registros = [], total = null) {
        if (this.cpntContatos !== null && this.cpntContatos.length >= 1 && (total === null || registros.length < total)) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, field: { id: null, nome: null, empresa: null, cnpj_cpf: null } }
  
          // SETA BUSCA QUE DEVE REALIZAR
          queryGet.where = { aAnd: [ { f: 'id', o: 'in', v: this.cpntContatos.join() } ] }
  
          // FAZ A BUSCA NA API
          this.$store.state.comunicaAPI('/contato/get', 'POST', queryGet, (retorno) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(retorno.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS OUTROS REGISTROS
            this.proSitFisFormularioBuscaSetarContatos(registros, Number(retorno.countAll))
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.contato.status = apiError
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // ADICIONA OS VALORES RECEBIDOS
          for (var indexR in registros) {
            // ADICIONA O VALOR NA TABELA
            this.tabela.contato.linha.push(registros[indexR])

            // ADICIONA O VALOR NO VETOR
            this.tabela.contato.chaves.push(registros[indexR].id)
          }

          // SETA O STATUS DO CAMPO
          this.campos.contato.status = ''

          // VERIFICA SE DEVE DESATIVAR O CAMPO
          this.proSitFisFormularioCampoVerificaInserirMais('contato')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      proSitFisFormularioBuscaSetarPais: function (registros = [], total = null) {
        if (this.cpntPais !== null && this.cpntPais.length >= 1 && (total === null || registros.length < total)) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, field: { cPais: null, xPais: null, img: null } }
  
          // SETA BUSCA QUE DEVE REALIZAR
          queryGet.where = { aAnd: [ { f: 'cPais', o: 'in', v: this.cpntPais.join() } ] }
  
          // FAZ A BUSCA NA API
          this.$store.state.comunicaAPI('/referencia/pro-pais/get', 'POST', queryGet, (retorno) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(retorno.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS OUTROS REGISTROS
            this.proSitFisFormularioBuscaSetarPais(registros, Number(retorno.countAll))
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.pais.status = apiError
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // ADICIONA OS VALORES RECEBIDOS
          for (var indexR in registros) {
            // ADICIONA O VALOR NA TABELA
            this.tabela.pais.linha.push(registros[indexR])

            // ADICIONA O VALOR NO VETOR
            this.tabela.pais.chaves.push(registros[indexR].uf)
          }

          // SETA O STATUS DO CAMPO
          this.campos.pais.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      proSitFisFormularioBuscaSetarEstados: function (registros = [], total = null) {
        if (this.cpntEstados !== null && this.cpntEstados.length >= 1 && (total === null || registros.length < total)) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, field: { uf: null, estado: null } }
  
          // SETA BUSCA QUE DEVE REALIZAR
          queryGet.where = { aAnd: [ { f: 'uf', o: 'in', v: this.cpntEstados.join() } ] }
  
          // FAZ A BUSCA NA API
          this.$store.state.comunicaAPI('/referencia/cep-estado/get/', 'GET', queryGet, (retorno) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(retorno.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS OUTROS REGISTROS
            this.proSitFisFormularioBuscaSetarEstados(registros, Number(retorno.countAll))
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.estado.status = apiError
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // ADICIONA OS VALORES RECEBIDOS
          for (var indexR in registros) {
            // ADICIONA O VALOR NA TABELA
            this.tabela.estado.linha.push(registros[indexR])

            // ADICIONA O VALOR NO VETOR
            this.tabela.estado.chaves.push(registros[indexR].uf)
          }

          // SETA O STATUS DO CAMPO
          this.campos.estado.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      proSitFisFormularioBuscarValores: function (id, callback = null) {
        // MONTA O QUERY GET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

        // SETA OS CAMPOS QUE DEVEM BUSCAR
        queryGet.field = {
          id: null,
          demanda: null,
          id_caso: { j: { nome: null } },
          id_con: { j: { nome: null } },
          id_pro: { j: { nome: null, status: null } },
          id_p_pais: { j: { xPais: null, img: null } },
          id_uf: { j: { estado: null } },
          ncm: null,

          id_cfop: { j: { descricao: null, j_demanda: null, ind_devol: null } },
          icms_orig: { j: { ref_icms_origem_desc: null } },
          icms_cst: { j: { ref_icms_rt_id: null, ref_icms_cst_desc: null, ref_icms_aa: null, ref_icms_bc_mod: null, ref_icms_a: null, ref_icms_bc_p_r: null, ref_icms_bc_p_r_c: null, ref_icms_st_bc_mod: null, ref_icms_st_a: null, ref_icms_bc_st_p_r: null, ref_icms_st_bc_rt: null, ref_icms_st_rt: null, ref_icms_mva_p: null, ref_icms_fcp_a: null, ref_icms_fcp_st_a: null, ref_icms_fcp_st_a_cf: null, ref_icms_fcp_st_r_a: null, ref_icms_fcp_st_r_bc: null } },
          icms_bc_mod: { j: { ref_icms_mod_bc_desc: null } },
          icms_a: null,
          icms_bc_p_r: null,
          icms_bc_p_r_c: null,
          icms_st_bc_mod: { j: { ref_icms_mod_bc_st_desc: null } },
          icms_st_a: null,
          icms_bc_st_p_r: null,
          icms_st_bc_rt: null,
          icms_st_rt: null,
          icms_mva_p: null,
          icms_fcp_a: null,
          icms_fcp_st_a: null,
          icms_fcp_st_a_cf: null,
          icms_fcp_st_r_a: null,
          icms_fcp_st_r_bc: null,
          pis_cst: { j: { ref_pc_a: null, ref_pc_ope: null, ref_pc_cst_desc: null } },
          pis_a: null,
          cofins_cst: { j: { ref_pc_a: null, ref_pc_ope: null, ref_pc_cst_desc: null } },
          cofins_a: null,
          ipi_cst: { j: { ref_ipi_cst_desc: null, ref_ipi_ope: null, ref_ipi_a: null, ref_ipi_enq: null, ref_ipi_selo: null } },
          ipi_a: null,
          ipi_enq: { j: { ref_ipi_enq_desc: null } },
          ipi_selo: { j: { ref_ipi_tipo: null, ref_ipi_cor: null } }
        }

        // SETA O WHERE QUE DEVE REALIZAR
        queryGet.where = { aAnd: [ { f: 'id', o: 'in', v: id } ] }

        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI('/produto/sit-fiscal2/get', 'POST', queryGet, (retorno) => {
          // PEGA OS VALORES RECEBIDOS
          retorno = retorno.data[0]

          // LIMPA O VALOR DO CAMPO
          if (retorno.id_p_pais === '0') {
            retorno.id_p_pais = ''
          }

          // PEGA O NOME DAS CHAVES
          var chaves = Object.keys(this.campos)

          // VERIFICA SE ESTÁ FAZENDO UMA COPIA
          if (id !== this.cpntId) {
            chaves = chaves.filter(item => [ 'id_caso', 'ncm', 'estado', 'contato', 'produto' ].indexOf(item) === -1)
          }

          // INICIA A VARIAVEL A SER UTILIZADA
          var vetor = ''

          // SETA OS VALORES NOS CAMPOS
          for (var index in chaves) {
            // PEGA O NOME DA CHAVE QUE DEVE TRABALHAR
            var indexC = chaves[index]

            // VERIFICA O CAMPO QUE DEVE ATUALIZAR
            switch (indexC) {
              case 'demanda':
                // CHAMA A FUNÇÃO PARA CARREGAR AS DEMANDAS
                this.proSitFisFormularioSetarDemandas(null, retorno.id_cfop_j_demanda)

                // SETA OS DEMANDA RECEBIDO
                var demanda = retorno.demanda === '' ? { id: '', nome: 'TODOS' } : this.campos.demanda.options.filter(item => item.id === retorno.demanda)[0]

                // SETA O STATUS DO CAMPO
                this.campos.demanda.value = demanda

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
                break

              case 'id_caso':
                // SETA O STATUS DO CAMPO
                this.campos.id_caso.value = { id: retorno.id_caso, nome: retorno.id_caso_nome }

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
                break

              case 'ncm':
                // VERIFICA SE ESTÁ SELECIONADO TODOS
                this.campos.ncm_todas.value = retorno.ncm === ''

                // VERIFICA SE DEVE INCLUIR O VALOR NA TABELA
                if (retorno.ncm !== '') {
                  // SETA OS ncm RECEBIDO
                  vetor = { ncm: retorno.ncm }

                  // ADICIONA O VALOR NA TABELA
                  this.tabela.ncm.linha.push(JSON.parse(JSON.stringify(vetor)))
  
                  // ADICIONA O VALOR NO VETOR
                  this.tabela.ncm.chaves.push(vetor.ncm)
                }

                // SETA O STATUS DO CAMPO
                this.campos.ncm.status = ''

                // VERIFICA SE DEVE DESATIVAR O CAMPO
                this.proSitFisFormularioCampoVerificaInserirMais('ncm')

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
                break

              case 'estado':
                // SETA O ESTADO SELECIONADO
                this.proSitFisFormularioTratarEstado(retorno.id_uf)
                break

              case 'pais':
                this.proSitFisFormularioTratarPais(retorno.id_p_pais)
                break

              case 'contato':
                // VERIFICA SE ESTÁ SELECIONADO TODOS
                this.campos.contato_todas.value = retorno.id_con === '0'

                // VERIFICA SE DEVE INCLUIR O VALOR NA TABELA
                if (retorno.id_con !== '0') {
                  // SETA OS CONTATO RECEBIDO
                  vetor = { id: retorno.id_con, nome: retorno.id_con_nome }

                  // ADICIONA O VALOR NA TABELA
                  this.tabela.contato.linha.push(JSON.parse(JSON.stringify(vetor)))
  
                  // ADICIONA O VALOR NO VETOR
                  this.tabela.contato.chaves.push(vetor.id)
                }

                // SETA O STATUS DO CAMPO
                this.campos.contato.status = ''

                // VERIFICA SE DEVE DESATIVAR O CAMPO
                this.proSitFisFormularioCampoVerificaInserirMais('contato')

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
                break

              case 'produto':
                // VERIFICA SE ESTÁ SELECIONADO TODOS
                this.campos.produto_todas.value = retorno.id_pro === '0'

                // VERIFICA SE DEVE INCLUIR O VALOR NA TABELA
                if (retorno.id_pro !== '0') {
                  // SETA OS produto RECEBIDO
                  vetor = { id: retorno.id_pro, nome: retorno.id_pro_nome }

                  // ADICIONA O VALOR NA TABELA
                  this.tabela.produto.linha.push(JSON.parse(JSON.stringify(vetor)))
  
                  // ADICIONA O VALOR NO VETOR
                  this.tabela.produto.chaves.push(vetor.id)
                }

                // SETA O STATUS DO CAMPO
                this.campos.produto.status = ''

                // VERIFICA SE DEVE DESATIVAR O CAMPO
                this.proSitFisFormularioCampoVerificaInserirMais('produto')

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
                break

              case 'id_cfop':
                // SETA O VALOR DO CAMPO
                this.campos[indexC].value = { cfop: retorno.id_cfop, descricao: retorno.id_cfop_descricao, j_demanda: retorno.id_cfop_j_demanda, ind_devol: retorno.id_cfop_ind_devol, cfop_ini: retorno.id_cfop.substring(0, 1) }

                // // CHAMA A FUNÇÃO PARA CARREGAR AS OPÕES DE DEMANDA
                // this.proSitFisFormularioSetarDemandas()

                // // INICIA A VARIAVEL ESTADO
                // var estado = [ '1', '3', '5', '7' ].indexOf(retorno.id_cfop.substring(0, 1)) !== -1 ? this.$store.state.licenca.uf : ''

                // // CHAMA A FUNÇÃO PARA TRATAR OS ESTADOS
                // this.proSitFisFormularioTratarEstado(estado)

                // CHAMA A FUNÇÃO PARA TRATAR OS ESTADOS
                this.proSitFisFormularioTratarEstado()

                // CHAMA A FUNÇÃO PARA TRATAR OS ESTADOS
                this.proSitFisFormularioTratarPais()
                break

              case 'icms_orig':
                this.campos[indexC].value = { ref_icms_origem_id: retorno.icms_orig, ref_icms_origem_desc: retorno.icms_orig_ref_icms_origem_desc }
                break

              case 'icms_cst':
                this.campos[indexC].value = {
                  ref_icms_cst: retorno.icms_cst,
                  ref_icms_rt_id: retorno.icms_cst_ref_icms_rt_id,
                  ref_icms_cst_desc: retorno.icms_cst_ref_icms_cst_desc,
                  ref_icms_aa: retorno.icms_cst_ref_icms_aa,
                  ref_icms_bc_mod: retorno.icms_cst_ref_icms_bc_mod,
                  ref_icms_a: retorno.icms_cst_ref_icms_a,
                  ref_icms_bc_p_r: retorno.icms_cst_ref_icms_bc_p_r,
                  ref_icms_bc_p_r_c: retorno.icms_cst_ref_icms_bc_p_r_c,
                  ref_icms_st_bc_mod: retorno.icms_cst_ref_icms_st_bc_mod,
                  ref_icms_st_a: retorno.icms_cst_ref_icms_st_a,
                  ref_icms_bc_st_p_r: retorno.icms_cst_ref_icms_bc_st_p_r,
                  ref_icms_st_bc_rt: retorno.icms_cst_ref_icms_st_bc_rt,
                  ref_icms_st_rt: retorno.icms_cst_ref_icms_st_rt,
                  ref_icms_mva_p: retorno.icms_cst_ref_icms_mva_p,
                  ref_icms_fcp_a: retorno.icms_cst_ref_icms_fcp_a,
                  ref_icms_fcp_st_a: retorno.icms_cst_ref_icms_fcp_st_a,
                  ref_icms_fcp_st_a_cf: retorno.icms_cst_ref_icms_fcp_st_a_cf,
                  ref_icms_fcp_st_r_a: retorno.icms_cst_ref_icms_fcp_st_r_a,
                  ref_icms_fcp_st_r_bc: retorno.icms_cst_ref_icms_fcp_st_r_bc
                }
                break

              case 'icms_bc_mod':
                this.campos[indexC].value = { ref_icms_mod_bc_id: retorno.icms_bc_mod, ref_icms_mod_bc_desc: retorno.icms_bc_mod_ref_icms_mod_bc_desc }
                break

              case 'icms_st_bc_mod':
                this.campos[indexC].value = [ '', null, undefined, '-1', -1 ].indexOf(retorno.icms_st_bc_mod) !== -1 ? '' : { ref_icms_mod_bc_st_id: retorno.icms_st_bc_mod, ref_icms_mod_bc_st_desc: retorno.icms_st_bc_mod_ref_icms_mod_bc_st_desc }
                break

              case 'ipi_cst':
                this.campos[indexC].value = [ '', null, undefined, ' ', '-1', -1 ].indexOf(retorno[indexC]) !== -1 ? { ref_ipi_a: '0', ref_ipi_cst: ' ', ref_ipi_cst_desc: 'Não aplicável', ref_ipi_enq: '0', ref_ipi_ope: '0', ref_ipi_selo: '0' } : {
                  ref_ipi_cst: retorno.ipi_cst,
                  ref_ipi_ope: retorno.ipi_cst_ref_ipi_ope,
                  ref_ipi_cst_desc: retorno.ipi_cst_ref_ipi_cst_desc,
                  ref_ipi_a: retorno.ipi_cst_ref_ipi_a,
                  ref_ipi_enq: retorno.ipi_cst_ref_ipi_enq,
                  ref_ipi_selo: retorno.ipi_cst_ref_ipi_selo
                }
                break

              case 'ipi_enq':
                this.campos[indexC].value = { ref_ipi_enq: retorno.ipi_enq, ref_ipi_enq_desc: retorno.ipi_enq_ref_ipi_enq_desc }
                break

              case 'ipi_selo':
                this.campos[indexC].value = { ref_ipi_selo: retorno.ipi_selo, ref_ipi_cor: retorno.ipi_selo_ref_ipi_cor, ref_ipi_tipo: retorno.ipi_selo_ref_ipi_tipo }
                break
              
              case 'pis_cst':
                this.campos[indexC].value = {
                  ref_pc_cst: retorno.pis_cst,
                  ref_pc_cst_desc: retorno.pis_cst_ref_pc_cst_desc,
                  ref_pc_a: retorno.pis_cst_ref_pc_a,
                  ref_pc_ope: retorno.pis_cst_ref_pc_ope
                }
                break

              case 'cofins_cst':
                this.campos[indexC].value = {
                  ref_pc_cst: retorno.cofins_cst,
                  ref_pc_cst_desc: retorno.cofins_cst_ref_pc_cst_desc,
                  ref_pc_a: retorno.cofins_cst_ref_pc_a,
                  ref_pc_ope: retorno.cofins_cst_ref_pc_ope
                }
                break

              case 'icms_a':
              case 'icms_bc_p_r':
              case 'icms_bc_p_r_c':
              case 'icms_mva_p':
              case 'icms_st_a':
              case 'icms_bc_st_p_r':
              case 'pis_a':
              case 'cofins_a':
              case 'ipi_a':
              case 'icms_fcp_st_a':
              case 'icms_st_bc_rt':
              case 'icms_st_rt':
              case 'icms_fcp_a':
              case 'icms_fcp_st_a_cf':
              case 'icms_fcp_st_r_bc':
              case 'icms_fcp_st_r_a':
                this.campos[indexC].value = retorno[indexC]
                break
            }

            // LIMPA AS MENSAGENS DO CAMPO
            if ([ '', null, undefined ].indexOf(this.campos[indexC].mensagem) === -1) {
              this.campos[indexC].mensagem = ''
              this.campos[indexC].mensagemTipo = ''
            }
          }

          // SETA O VALOR INICIAL
          this.campos[indexC].valueIni = JSON.parse(JSON.stringify(this.campos[indexC].value))

          // SETA OS VALORES RECEBIDOS
          this.campos.pis_cst.status = ''
          this.campos.cofins_cst.status = ''
          
          // VERIFICA SE TEM DIFERENÇA A SER SETADA
          if ([ '', null, undefined ].indexOf(this.cpntDiff) === -1) {
            this.proSitFisFormularioSetarDiferencas()
          }
          
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }, (apiError) => {
          // SETA OS VALORES RECEBIDOS
          this.campos.ncm.status = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        })
      },
      proSitFisFormularioPegarValorSelecionado: function (value, indexC) {
        // VERIFICA SE TEM QUE PEGAR O VALOR DO OBJETO
        value = [ 'string', 'number' ].indexOf(typeof value) !== -1 ? value : value[this.campos[indexC].keyValue]

        // VERIFICA SE TEM QUE CONVERTER ALUM VALOR
        switch (this.campos[indexC].mask) {
          case 'valorMoeda':
            value = this.$store.state.FUN_MASK_VALOR('valorMoeda', value)
            break
        }
        
        // RETORNA O VALOR MONTADO
        return value
      },
      proSitFisFormularioSetarDiferencas: function () {
        // INICIA A VARIAVEL DE CAMPOS IGNORADOS
        var ignorados = []
        var faltantes = []

        // CAMPOS ATUALIZADOS
        var qtde_encontrada = 0

        // SETA OS DADOS DO CAMPO
        for (var indexC in this.cpntDiff) {
          if ([ '', null, undefined ].indexOf(this.campos[indexC]) === -1 && Object.keys(this.campos[indexC]).length >= 1) {
            if ((typeof this.campos[indexC].disabled === 'function' && this.campos[indexC].disabled() === false) || (typeof this.campos[indexC].disabled !== 'function' && this.campos[indexC].disabled !== true)) {
              // SETA O VALOR DO CAMPO E VERIFICA SE É UMA STRING OU UM OBJETO A SE SELECIONADO
              var valueIni = this.proSitFisFormularioPegarValorSelecionado(this.campos[indexC].value, indexC)

              // SETA O VALOR DO CAMPO E VERIFICA SE É UMA STRING OU UM OBJETO A SE SELECIONADO
              var valueNov = this.proSitFisFormularioPegarValorSelecionado(this.cpntDiff[indexC], indexC)

              // ALTERA A CLASSE DO CAMPO
              this.proSitFisFormularioOnChangeValue(this.cpntDiff[indexC], this.campos[indexC].id)

              // SETA O VALOR DO TITLE
              this.campos[indexC].title = 'Alterado de (' + valueIni + ') para (' + valueNov + ')'

              // LIMPA AS MENSAGENS DO CAMPO
              this.campos[indexC].mensagem = ''
              this.campos[indexC].mensagemTipo = ''
  
              // ALTERA A CLASSE DO CAMPO
              this.$set(this.campos[indexC], 'class', 'rf-field-destaque-busca_api')

              // SOMA A QUANTIDADE DE CAMPOS ATUALIZADOS
              qtde_encontrada++
            } else {
              ignorados.push(this.campos[indexC].nome)
            }
          } else {
            faltantes.push(indexC)
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA A FUNÇÃO DE FINALIZAÇÃO
        var finalizar = () => {
          // VERIFICA SE DEVE COLOCAR A COR EM OUTRO CAMPO
          setTimeout(() => {
            // VERIFICA SE TEM QUE ATUALIZAR O CFOP
            if ([ '', null, undefined ].indexOf(this.cpntDiff.id_cfop) === -1) {
              // ATUALIZA A COR DO CAMPO
              this.$set(this.campos.demanda, 'class', 'rf-field-destaque-busca_api')

              // INICIA A VARIAVEL ESTADO
              var uf = [ '1', '3', '5', '7' ].indexOf(this.cpntDiff.id_cfop.cfop.substring(0, 1)) !== -1 ? this.$store.state.licenca.uf : ''

              // CHAMA A FUNÇÃO PARA TRATAR OS ESTADOS
              this.proSitFisFormularioTratarEstado(uf, true)
            }

            // VERIFICA SE DEVE FAZER O ATUALIZAR AUTOMATICAMENTE
            if ([ '', null, undefined, '0', 0 ].indexOf(this.cpntId) === -1 && typeof this.cpntId !== 'object') {
              this.proSitFisFormularioSalvar()
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, 100)
        }

        // // VERIFICA SE TEM ALGUM ERRO A SER APRESENTADO
        // if (ignorados.length >= 1 || faltantes.length >= 1) {
        //   // INICIA A VARIAVEL PARA MENSAGEM
        //   var mensagem = ''

        //   // VERIFICA SE EXITE CAMPO IGNORADO
        //   if (ignorados.length >= 1) {
        //     // SETA OS CAMPOS QUE NÃO PODE SER SETADOS
        //     mensagem = 'WEB [406]: O(s) campo(s) abaixo, não pode ser alterados, pois a configuração deste caso não permite preenchimento dos valores.<br/><br/>'
  
        //     // INICIA A LISTA DE CAMPOS
        //     mensagem += '<ul style="text-align: left; padding-left: 50px;"><li>'
  
        //     // SETA O NOME DOS CAMPOS
        //     mensagem += ignorados.join('</li><li>')
            
        //     // FINALIZA A LISTA DE CAMPOS
        //     mensagem += '</li></ul>'

        //     // APRESENTA A MENSAGEM DE ERRO MONTADA
        //     this.$store.state.msgWarn(mensagem, 'warning')

        //     // EXECUTA A FUNÇÃO DE FINALIZAÇÃO
        //     finalizar()
        //   } else if (faltantes.length >= 1 && qtde_encontrada === 0) {
        //     // SETA A ABERTURA DA TELA
        //     this.dialog = 'CONFIRMAR_REINICIALIZACAO'

        //     // EXECUTA A FUNÇÃO DE FINALIZAÇÃO
        //     finalizar()
        //   } else {
        //     finalizar()
        //   }
        // } else {
        //   finalizar()
        // }

        if (faltantes.length >= 1 && qtde_encontrada === 0) {
          // SETA A ABERTURA DA TELA
          this.dialog = 'CONFIRMAR_REINICIALIZACAO'

          // EXECUTA A FUNÇÃO DE FINALIZAÇÃO
          finalizar()
        } else {
          finalizar()
        }
      },
      proSitFisFormularioFecharConfirmacaoReinicializacao: function (atualizar) {
        this.proSitFisFormularioFechar(atualizar)
      },
      proSitFisFormularioFechar: function (atualizar, id) {
        // CHAMA A FUNÇÃO PARA FEHCAR A TELA
        this.cpntFecharFormulario(atualizar, id)

        // REDIRECIONA PARA TELA DE GERENCIAR
        if (this.$route.name === 'produto_sit_fiscal_form') {
          this.$router.push({ name: 'produto_sit_fiscal' })
        }
      },
      proSitFisFormularioCampoVerificaInserirMais: function (chave) {
        // PEGA O VALOR OD CAMPO
        var valores = this.tabela[chave].chaves

        // VERIFICA SE DEVE DESATIVAR O CAMPO
        this.campos[chave].disabled = ([ '', null, undefined, '0', 0 ].indexOf(this.cpntId) === -1 || this.cpntIsOpenDemanda === true) && valores.length >= 1

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proSitFisFormularioOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')[1]

        // SETA O VALOR RECEBIDO
        this.campos[index].value = value

        // REMOVE A CLASS DO CAMPO
        this.campos[index].class = ''

        // REMOVE A MENSAGEM DE ERRO
        this.campos[index].mensagem = ''
        this.campos[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE TEM QUE PERSONALIZAR ALGUMA COISA
        switch (index) {
          case 'contato':
            // ADICIONA O VALOR NA TABELA
            this.tabela[index].linha.push(value)

            // ADICIONA O VALOR NO VETOR
            this.tabela[index].chaves.push(value[this.campos[index].keyValue])

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // AGUARDA UNS SEGUNDOS PARA ATUALIZAR
            setTimeout(() => {
              // REMOVE A OPÇÃO DO SELETOR
              this.campos[index].options = []

              // SETA O VALOR RECEBIDO
              this.campos[index].value = ''

              // VERIFICA SE DEVE DESATIVAR O CAMPO
              this.proSitFisFormularioCampoVerificaInserirMais(index)

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }, 250)
            break

          case 'ncm':
            // ADICIONA O VALOR NA TABELA
            this.tabela[index].linha.push(value)

            // ADICIONA O VALOR NO VETOR
            this.tabela[index].chaves.push(value[this.campos[index].keyValue])

            // CHAMA A FUNÇÃO PARA ATUALIZAR NOTIN DO CAMPO
            this.proSitFisFormularioSetarNotInCampoNCM()

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // AGUARDA UNS SEGUNDOS PARA ATUALIZAR
            setTimeout(() => {
              // REMOVE A OPÇÃO DO SELETOR
              this.campos[index].options = []

              // SETA O VALOR RECEBIDO
              this.campos[index].value = ''

              // VERIFICA SE DEVE DESATIVAR O CAMPO
              this.proSitFisFormularioCampoVerificaInserirMais(index)

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }, 250)
            break

          case 'produto':
            // ADICIONA O VALOR NA TABELA
            this.tabela[index].linha.push(value)

            // ADICIONA O VALOR NO VETOR
            this.tabela[index].chaves.push(value[this.campos[index].keyValue])

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // AGUARDA UNS SEGUNDOS PARA ATUALIZAR
            setTimeout(() => {
              // REMOVE A OPÇÃO DO SELETOR
              this.campos[index].options = []

              // SETA O VALOR RECEBIDO
              this.campos[index].value = ''

              // VERIFICA SE DEVE DESATIVAR O CAMPO
              this.proSitFisFormularioCampoVerificaInserirMais(index)

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }, 250)
            break

          case 'id_cfop':
            // SETA A DEMANDA DO CAMPO
            this.proSitFisFormularioSetarDemandas()

            // CHAMA A FUNÇÃO PARA TRATAR O ESTADO
            if ([ '', null, undefined].indexOf(value) === -1 && [ '', null, undefined].indexOf(value._id) === -1) {
              // VERIFICA SE DEVE FORÇAR A ATUALIZAÇÃO
              var force = this.proSitFisFormularioCampoEstadoMostrar() === false

              // FAZ A ATUALIZAÇÃO DO CAMPO
              this.proSitFisFormularioTratarEstado((force === true ? this.$store.state.licenca.uf : ''), force)
            }

            // CHAMA A FUNÇÃO PARA LIMPAR OS CAMPOS
            if ([ '0', 0 ].indexOf(this.cpntId) !== -1) {
              this.proSitFisFormularioLimparValoresCampos([ 'pis_cst', 'cofins_cst' ]).then(() => {
                // PEGA O CFOP SELECIONADO
                var cfop_ini = typeof this.campos.id_cfop.value !== 'object' ? this.campos.id_cfop.value : this.campos.id_cfop.value.cfop

                // PEGA O VALOR INICIAL DO CAMPO
                cfop_ini = cfop_ini.substring(0, 1)

                // VERIFICA O REGIME TRIBUTARIO E SE DEVE SETAR O VALOR DA ALIQUOTA DO NO CAMPO
                if ([ '1', '2' ].indexOf(this.$store.state.licenca.rt_id) !== -1) {
                  switch (cfop_ini) {
                    case '1':
                    case '2':
                    case '3':
                      // SETA O VALOR QUE DEVE SELECIONAR
                      this.campos.pis_cst.value = { ref_pc_a: '0', ref_pc_cst: '07', ref_pc_cst_desc: 'Operação Isenta da Contribuição', ref_pc_ope: '0,1' }
      
                      // SETA O VALOR QUE DEVE SELECIONAR
                      this.campos.cofins_cst.value = { ref_pc_a: '0', ref_pc_cst: '07', ref_pc_cst_desc: 'Operação Isenta da Contribuição', ref_pc_ope: '0,1' }
                      break

                    case '5':
                    case '6':
                    case '7':
                      // SETA O VALOR QUE DEVE SELECIONAR
                      this.campos.pis_cst.value = { ref_pc_cst: '49', ref_pc_ope: '1', ref_pc_cst_desc: 'Outras Operações de Saída', 'ref_pc_a': '1' }
      
                      // SETA O VALOR QUE DEVE SELECIONAR
                      this.campos.cofins_cst.value = { ref_pc_cst: '49', ref_pc_ope: '1', ref_pc_cst_desc: 'Outras Operações de Saída', 'ref_pc_a': '1' }
                      break
                  }
                }
              })
            }
            break

          case 'estado':
            // INICIA A VARIAVEL DISABLED
            var estadoDisabled = false

            // VERIFICA O VALOR RECEBIDO
            if (typeof value === 'object' && value[this.campos[index].keyValue] === '-1') {
              // SETA O VALOR CORRETO DO CAMPO
              value[this.campos[index].keyValue] = ''

              // SETA O VALOR SELECIONADO
              value.estado = value._text
            }

            // VERIFICA SE FOI MARCADO A OPÇÃO TODOS
            if (value._id === '-1') {
              // ADICIONA O VALOR NA TABELA
              value = { uf: '---', estado: 'TODOS' }

              // LIMPA OS VALORES SELECIONADOS
              this.tabela[index].linha = []
              this.tabela[index].chaves = []

              // SETA O STATUS DO DISABLED PARA O CMAPO
              estadoDisabled = true
            }

            // ADICIONA O VALOR NA TABELA
            this.tabela[index].linha.push(value)

            // ADICIONA O VALOR NO VETOR
            this.tabela[index].chaves.push(value[this.campos[index].keyValue])

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // AGUARDA UNS SEGUNDOS PARA ATUALIZAR
            setTimeout(() => {
              // REMOVE A OPÇÃO DO SELETOR
              this.campos[index].options = []

              // SETA O VALOR RECEBIDO
              this.campos[index].value = ''

              // SETA O VALOR RECEBIDO
              this.campos[index].disabled = estadoDisabled

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // VERIFICA SE DEVE DESATIVAR O CAMPO
              // this.proSitFisFormularioCampoVerificaInserirMais('estado')
              if ([ '', null, undefined, '0', 0 ].indexOf(this.cpntId) === -1) {
                this.proSitFisFormularioTratarEstado(value.uf)
              }
            }, 100)
            break

          case 'pais':
            // LIMPA OS VALORES SELECIONADOS
            if ([ '', null, undefined, '0', 0 ].indexOf(this.cpntId) === -1) {
              this.tabela[index].linha = []
              this.tabela[index].chaves = []
            }

            // VERIFICA O VALOR RECEBIDO
            if (typeof value === 'object' && value[this.campos[index].keyValue] === '-1') {
              // SETA O VALOR CORRETO DO CAMPO
              value[this.campos[index].keyValue] = ''

              // SETA O VALOR SELECIONADO
              value.xPais = value._text
            }

            // VERIFICA SE FOI MARCADO A OPÇÃO TODOS
            if (value._id === '-1') {
              // ADICIONA O VALOR NA TABELA
              value = { cPais: '---', xPais: 'TODOS' }

              // LIMPA OS VALORES SELECIONADOS
              this.tabela[index].linha = []
              this.tabela[index].chaves = []
            }

            // ADICIONA O VALOR NA TABELA
            this.tabela[index].linha.push(value)

            // ADICIONA O VALOR NO VETOR
            this.tabela[index].chaves.push(value[this.campos[index].keyValue])

            // VERIFICA SE A TABELA ESTA SENDO MOSTRADA
            if (this.campos.pais.status === '' && this.proSitFisFormularioCampoPaisMostrarTabela() === true) {
              // REMOVE A OPÇÃO DO SELETOR
              this.campos[index].value = ''
              this.campos[index].options = []
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
  
              // FORÇA O SELECT2 A REINICIAR POR 
              setTimeout(() => { this.campos[index].matar = new Date().getTime() }, 100)
            }
            break

          case 'produto_todas':
            if (value === false) {
              setTimeout(() => { this.proSitFisFormularioRealizarFocusCampo('produto') }, 200)
            }
            break

          case 'estado_todas':
            if (value === false) {
              setTimeout(() => { this.proSitFisFormularioRealizarFocusCampo('estado') }, 200)
            }
            break

          case 'contato_todas':
            if (value === false) {
              setTimeout(() => { this.proSitFisFormularioRealizarFocusCampo('contato') }, 200)
            }
            break

          case 'ncm_todas':
            if (value === false) {
              setTimeout(() => { this.proSitFisFormularioRealizarFocusCampo('ncm') }, 200)
            }
            break
        }
      },
      proSitFisFormularioRealizarFocusCampo: function (chave, tentativa = 0) {
        if (this.$store.state.mobile === false) {
          if (tentativa <= 10) {
            if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1 && [ '', null, undefined ].indexOf(this.$refs[chave].cpntRealizarFocus) === -1) {
              this.$refs[chave].cpntRealizarFocus()
            } else {
              setTimeout(() => { this.proSitFisFormularioRealizarFocusCampo(chave, (tentativa + 1)) }, 100)
            }
          }
        }
      },
      proSitFisFormularioSetarNotInCampoNCM: function () {
        // REMOVE A CHAVE NOTIN DO WHERE DA NCM
        if (this.campos.ncm.where.aAnd.length === 6) {
          this.campos.ncm.where.aAnd.splice(5, 1)
        }
        
        // VERIFICA SE TEM QUE ADICIONAR NOTIN NA BUSCA
        if (this.tabela.ncm.chaves.length >= 1) {
          this.campos.ncm.where.aAnd.push({ f: 'ncm', o: 'notIn', v: this.tabela.ncm.chaves.join(',') })
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proSitFisFormularioOnNovoContato: function (value) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: true, id: 0, tipo: 'contato', nome: value }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar, id, dados) => {
          if (atualizar === true) {
            this.proSitFisFormularioOnChangeValue(dados, this.campos.contato.id)
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      proSitFisFormularioOnNovoProduto: function (value) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: true, id: 0, tipo: 'produto', nome: value }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar, id, dados) => {
          if (atualizar === true) {
            this.proSitFisFormularioOnChangeValue(dados, this.campos.produto.id)
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      proSitFisFormularioOnNovoNcm: function (value) {
        if ([ '', null, undefined ].indexOf(value) !== -1) {
          this.$store.state.msgWarn('WEB [406]: Digite a NCM desejada e depois aperter no botão para adicionar', 'warning')
        } else {
          this.proSitFisFormularioOnChangeValue({ ncm: value }, this.campos.ncm.id)
        }
      },
      proSitFisFormularioTratarEstado: function (uf = this.$store.state.licenca.uf, force = false) {
        if (force === true || (this.proSitFisFormularioCampoEstadoMostrar() === false && this.proSitFisFormularioCampoEstadoMostrarTabela() === false) || (uf !== this.$store.state.licenca.uf)) {
          // MUDA O SELECIONAR TODOS PARA FALSE
          this.campos.estado_todas.value = [ '', null, undefined ].indexOf(uf) !== -1

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // AGUARDA UNS SEGUNDOS PARA ATUALIZAR
          if ([ '', null, undefined ].indexOf(uf) === -1) {
            setTimeout(() => {
              // MUDA O SELECIONAR TODOS PARA FALSE
              this.campos.estado_todas.value = [ '', null, undefined ].indexOf(uf) !== -1
  
              // PEGA O ESTADO SELECIONADO NO CADASTRO
              var estado = this.$store.state.UFs.filter(item => item.uf === uf)[0]
    
              // SETA O ESTADO NO SELETOR
              this.campos.estado.value = estado           
      
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
      
              // AGUARDA UNS SEGUNDOS PARA ATUALIZAR
              setTimeout(() => {
                // DESATIVA O CAMPO
                this.campos.estado_todas.disabled = ([ '', null, undefined ].indexOf(uf) !== -1 && uf === this.$store.state.licenca.uf)
                this.campos.estado.disabled = ([ '', null, undefined ].indexOf(uf) !== -1 && uf === this.$store.state.licenca.uf)
      
                // MUDA O SELECIONAR TODOS PARA FALSE
                this.campos.estado_todas.value = [ '', null, undefined ].indexOf(uf) !== -1
      
                // LIMPA OS VALORES SELECIONADOS
                this.tabela.estado.linha = [ estado ]
                this.tabela.estado.chaves = [ estado.uf ]
      
                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
              }, 250)
            }, 400)
          } else {
            // MUDA O SELECIONAR TODOS PARA FALSE
            this.campos.estado_todas.value = true

            // LIMPA OS VALORES SELECIONADOS
            this.tabela.estado.linha = []
            this.tabela.estado.chaves = []

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }
        } else {
          // LIMPA OS VALORES SELECIONADOS
          this.tabela.estado.linha = []
          this.tabela.estado.chaves = []

          // SETA O ESTADO NO SELETOR
          this.campos.estado.value = ''

          // DESATIVA O CAMPO
          this.campos.estado.disabled = false
          this.campos.estado_todas.disabled = false

          // MUDA O SELECIONAR TODOS PARA FALSE
          this.campos.estado_todas.value = true

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      proSitFisFormularioTratarPais: function (cPais = '1058', force = false) {
        if (cPais === '') {
          cPais = '1058'
        }
        
        if ((force === true || (this.proSitFisFormularioCampoPaisMostrar() === false && this.proSitFisFormularioCampoPaisMostrarTabela() === false)) && (cPais !== '1058')) {
          // MUDA O SELECIONAR TODOS PARA FALSE
          this.campos.estado_todas.value = [ '', null, undefined ].indexOf(cPais) !== -1

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // AGUARDA UNS SEGUNDOS PARA ATUALIZAR
          if ([ '', null, undefined ].indexOf(cPais) === -1) {
            var finalizaOption = () => {
              setTimeout(() => {
                // MUDA O SELECIONAR TODOS PARA FALSE
                this.campos.pais_todas.value = [ '', null, undefined ].indexOf(cPais) !== -1
    
                // PEGA O ESTADO SELECIONADO NO CADASTRO
                var pais = this.campos.pais.options.filter(item => item.cPais === cPais)[0]
      
                // SETA O PAIS NO SELETOR
                this.campos.pais.value = pais
        
                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
        
                // AGUARDA UNS SEGUNDOS PARA ATUALIZAR
                setTimeout(() => {
                  // DESATIVA O CAMPO
                  this.campos.pais_todas.disabled = ([ '', null, undefined ].indexOf(cPais) !== -1 && cPais === '1058')
                  this.campos.pais.disabled = ([ '', null, undefined ].indexOf(cPais) !== -1 && cPais === '1058')
        
                  // MUDA O SELECIONAR TODOS PARA FALSE
                  this.campos.pais_todas.value = [ '', null, undefined ].indexOf(cPais) !== -1
        
                  // LIMPA OS VALORES SELECIONADOS
                  this.tabela.pais.linha = [ pais ]
                  this.tabela.pais.chaves = [ pais.cPais ]
        
                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  this.time = new Date().getTime()
                }, 250)
              }, 400)
            }

            // VERIFICA SE TEM QUE BUSCAR OS OPTIONS
            if (this.campos.pais.options.length === 0) {
              this.proSitFisFormularioBuscarPais(finalizaOption)
            } else {
              finalizaOption()
            }
          } else {
            // LIMPA OS VALORES SELECIONADOS
            this.tabela.pais.linha = []
            this.tabela.pais.chaves = []

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }
        } else {
          // LIMPA OS VALORES SELECIONADOS
          this.tabela.pais.linha = []
          this.tabela.pais.chaves = []

          // SETA O ESTADO NO SELETOR
          this.campos.pais.value = ''

          // DESATIVA O CAMPO
          this.campos.pais.disabled = false
          this.campos.pais_todas.disabled = false

          // MUDA O SELECIONAR TODOS PARA FALSE
          this.campos.pais_todas.value = true

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      proSitFisFormularioSetarDemandas: function (callback = null, demandas = null) {
        // VERIFICA SE TEM DEMANDA NO PARAMETRO
        if (demandas === null) {
          // SETA O VALOR RECEBIDO
          demandas = this.campos.id_cfop.value

          // VERIFICA SE TEM O CAMPO J_DEMANDA PARA CARREGAR
          demandas = ([ '', null, undefined ].indexOf(demandas) !== -1 || [ '', null, undefined ].indexOf(demandas.j_demanda) !== -1) ? '[]' : demandas.j_demanda
        }

        // VERIFICA SE PRECISA CONVERTER O JSON RECEBIDO
        if (typeof demandas === 'string') {
          demandas = JSON.parse(demandas)
        } else if (demandas === null) {
          demandas = []
        }

        // INICIA A VARIAVEL DE OPTIONS
        var options = []

        // RODA O VETOR, ADICIONANDO AS OPÇÕES
        for (var indexD in demandas) {
          switch (demandas[indexD]) {
            case 'dem_venda':
              options.push({ id: demandas[indexD], nome: 'Venda' })
              break
          
            case 'dem_dev_fornecedor':
              options.push({ id: demandas[indexD], nome: 'Devolução Fornecedor' })
              break

            case 'dem_compra':
              options.push({ id: demandas[indexD], nome: 'Compra' })
              break
          
            case 'dem_dev_cliente':
              options.push({ id: demandas[indexD], nome: 'Devolução Cliente' })
              break
          }
        }

        // SETA AS OPÇÕES DO CAMPO
        this.campos.demanda.options = options

        // SETA AS OPÇÕES DO CAMPO
        this.campos.demanda.value = options.length === 1 ? options[0].id : ''
4
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // EXECUTA O CALLBACK RECEBIDO
        if (callback !== null && typeof callback === 'function') {
          callback()
        }
      },
      // proSitFisFormularioBuscarDemandas: function (callback) {
      //   // SETA TODOS OS OPTIONS DISPONIVEIS
      //   var options = [ 
      //     { id: 'dem_venda', nome: 'Venda' },
      //     { id: 'dem_compra', nome: 'Compra' }
      //   ]

      //   // INICIA O VETOR
      //   var vetor = []
        
      //   // VERIFICA OS ESTADOS SELECIONADOS
      //   for (var indexU in options) {
      //     if (this.tabela.demanda.chaves.indexOf(options[indexU].id) === -1) {
      //       vetor.push(options[indexU])
      //     }
      //   }

      //   // SETA OS VALORES RECEBIDOS
      //   this.campos.demanda.options = vetor

      //   // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      //   this.time = new Date().getTime()

      //   // EXECUTA A FUNÇÃO CALLBACK
      //   callback()
      // },
      proSitFisFormularioBuscarNcmsNaoCadastradas: function (ids, callback, qtde = 300, ini = null, fim = null, registros = []) {
        // SETA OS DADOS QUE SERÁ BUSCADO
        if (ini === null && fim === null) {
          ini = 0
          fim = qtde
        } else if (ids.length > (ini + qtde)) {
          ini += qtde
          fim += qtde
        } else {
          ini = null
          fim = null
        }

        if (ini !== null && fim !== null && ids.length >= 1) {
          // PEGA OS NCMS QUE DEVE VERIFICAR
          var buscar = ids.slice(ini, fim)

          // INICIA O QUERYGET QUE SERÁ FEITO NA API
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { ncm: { o: 'distinct' } } }
  
          // SETA O WHERE PARA PEGAR OS REGISTROS PAIS
          queryGet.where = { aAnd: [ { f: 'ncm', o: 'in', v: buscar.join(',') } ] }
  
          // FAZ A BUSCA NA API
          this.$store.state.comunicaAPI('/produto/sit-fiscal2/get', 'POST', queryGet, (retorno) => {
            // REMOVE TODAS AS NCMS QUE EXISTE VALORES
            if (retorno.data.length >= 1) {
              for (var indexR in retorno.data) {
                buscar = buscar.filter(item => item !== retorno.data[indexR].ncm)
              }
            }

            // JUNTA OS VALORES NÃO CADASTRADOS AINDA
            registros = registros.concat(buscar)

            // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
            this.proSitFisFormularioBuscarNcmsNaoCadastradas(ids, callback, qtde, ini, fim, registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.ncm.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // INICIA O VETOR DE DADOS
          var vetor = []

          // FORMATA TODOS OS VALORES
          for (var indexF in registros) {
            if (this.tabela.ncm.chaves.indexOf(registros[indexF]) === -1) {
              vetor.push({ ncm: registros[indexF] })
            }
          }

          // EXECUTA A FUNÇÃO CALLBACK
          callback(vetor)
        }
      },
      proSitFisFormularioBuscarPais: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA O NOME DOS CAMPOS
          queryGet.field = { cPais: null, xPais: null, img: null }

          // ORDENA 
          queryGet.order = { xPais: 'asc' }

          // SETA O STATUS DO VENDEDOR
          queryGet.where = { f: 'cPais', o: '<>', v: '1058' }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-pais/get', 'POST', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.proSitFisFormularioBuscarPais(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.pais.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campos.pais.onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA O CAMINHO DA IMAGEM DO BANCO
          for (var indexR in registros) {
            registros[indexR]._img = '/img/bandeira/' + registros[indexR].img + '.png'
          }

          // SETA OS VALORES RECEBIDOS
          this.$set(this.campos.pais, 'options', registros)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      proSitFisFormularioBuscarEstados: function (callback) {
        // INICIA O VETOR
        var vetor = []
        
        // VERIFICA OS ESTADOS SELECIONADOS
        for (var indexU in this.$store.state.UFs) {
          if (this.tabela.estado.chaves.indexOf(this.$store.state.UFs[indexU].uf) === -1) {
            vetor.push(this.$store.state.UFs[indexU])
          }
        }

        // // ADICIONA O VALOR NO VETOR
        // vetor.unshift({ uf: '-1', estado: 'TODOS' })

        // REOMVE O PROPRIO ESTADO
        vetor = vetor.filter(item => item.uf !== this.$store.state.licenca.uf)

        // SETA OS VALORES RECEBIDOS
        this.campos.estado.options = vetor

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // EXECUTA A FUNÇÃO CALLBACK
        callback()
      },
      proSitFisFormularioBuscarContatos: function (busca, callback) {
        // MONTA O QUERY GET
        var queryGet = { type: 'list', limit: { row: 0, qty: 200 }, field: { id: null, nome: null, empresa: null, cnpj_cpf: null } }

        // SETA BUSCA QUE DEVE REALIZAR
        queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'contato', o: 's.ft', v: busca } ] }

        // FAZ A BUSCA NA API
        this.$store.state.comunicaAPI('/contato/get', 'POST', queryGet, (retorno) => { callback(retorno.data) }, (apiError) => {
          // SETA OS VALORES RECEBIDOS
          this.campos.contato.status = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        })
      },
      proSitFisFormularioBuscarCasos: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, field: { id: null, nome: null } }

          // PEGA APENAS NOMES QUE NÃO ESTÃO EXCLUIDOS
          queryGet.where = { f: 'status', o: '=', v: '1' }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/produto/sit-fiscal/caso/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.proSitFisFormularioBuscarCasos(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.id_caso.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campos.id_caso.onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.id_caso.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      proSitFisFormularioOnBuscarCFOP: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, field: { cfop: null, descricao: null, j_demanda: null, ind_devol: null } }

          // VERIFICA O VALOR QUE DEVE BUSCAR
          if ([ '', null, undefined ].indexOf(this.cpntIdConPessoa) === -1 || [ '', null, undefined ].indexOf(this.cpntIdConUF) === -1) {
            switch (this.cpntIdConPessoa + '__' + (this.cpntIdConUF === this.$store.state.licenca.uf)) {
              case 'e__true':
              case 'e__false':
                queryGet.where = { aOr: [
                  { aAnd: [
                    { f: 'cfop', o: '>=', v: '3000' },
                    { f: 'cfop', o: '<=', v: '3999' }
                  ] },
                  { aAnd: [
                    { f: 'cfop', o: '>=', v: '7000' },
                    { f: 'cfop', o: '<=', v: '7999' }
                  ] }
                ] }
                break

              case 'f__true':
                queryGet.where = { aOr: [
                  { aAnd: [
                    { f: 'cfop', o: '>=', v: '1000' },
                    { f: 'cfop', o: '<=', v: '1999' }
                  ] },
                  { aAnd: [
                    { f: 'cfop', o: '>=', v: '5000' },
                    { f: 'cfop', o: '<=', v: '5999' }
                  ] }
                ] }
                break

              case 'j__false':
                queryGet.where = { aOr: [
                  { aAnd: [
                    { f: 'cfop', o: '>=', v: '2000' },
                    { f: 'cfop', o: '<=', v: '2999' }
                  ] },
                  { aAnd: [
                    { f: 'cfop', o: '>=', v: '6000' },
                    { f: 'cfop', o: '<=', v: '6999' }
                  ] }
                ] }
                break
            }
          }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-cfop/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.proSitFisFormularioOnBuscarCFOP(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.id_cfop.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // TRATA O VETOR RECEBIDO
          for (var index in registros) {
            // PEGA O CFOP SELECIONADO
            registros[index].cfop_ini = [ 'string', 'number' ].indexOf(typeof registros[index].cfop) !== -1 ? registros[index].cfop : registros[index].cfop
  
            // PEGA O PRIMEIRO DIGITO DO CFOP
            registros[index].cfop_ini = registros[index].cfop_ini.substring(0, 1)
          }

          // SETA OS VALORES RECEBIDOS
          this.campos.id_cfop.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      proSitFisFormularioOnBuscarCasos: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = { id: null, nome: null }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { f: 'status', o: '=', v: '1' }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/produto/sit-fiscal/caso/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.proSitFisFormularioOnBuscarCasos(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.caso.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.caso.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      proSitFisFormularioOnBuscarIcmsModBc: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-icms-mod-bc/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.proSitFisFormularioOnBuscarIcmsModBc(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.icms_bc_mod.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.icms_bc_mod.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      proSitFisFormularioOnBuscarRedSobre: function (callback) {
        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI('/referencia/pro-icms-ret-sobre/get', 'GET', null, (apiSuccess) => {
          // SETA OS VALORES RECEBIDOS
          this.campos.icms_bc_p_r_c.options = apiSuccess.data

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }, (apiError) => {
          // SETA OS VALORES RECEBIDOS
          this.campos.icms_bc_p_r_c.status = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        })
      },
      proSitFisFormularioOnBuscarIcmsModBcSt: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-icms-mod-bc-st/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.proSitFisFormularioOnBuscarIcmsModBcSt(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.icms_st_bc_mod.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.icms_st_bc_mod.options = registros.filter(item => item.ref_icms_mod_bc_st_id !== '-1')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      proSitFisFormularioOnBuscarIcmsOrigem: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-icms-origem/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.proSitFisFormularioOnBuscarIcmsOrigem(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.icms_orig.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.icms_orig.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      proSitFisFormularioOnBuscarCstIcms: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { f: 'ref_icms_rt_id', o: '=', v: (this.$store.state.licenca.rt_id === '3' ? '3' : '1,2') }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-icms-cst/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.proSitFisFormularioOnBuscarCstIcms(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.icms_cst.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.icms_cst.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      proSitFisFormularioOnBuscarCstIpi: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-ipi-cst/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.proSitFisFormularioOnBuscarCstIpi(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.ipi_cst.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // ADICIONA O CAMPO NÃO APLICAVEL
          registros.unshift({ ref_ipi_a: '0', ref_ipi_cst: ' ', ref_ipi_cst_desc: 'Não aplicável', ref_ipi_enq: '0', ref_ipi_ope: '0', ref_ipi_selo: '0' })
          // registros.unshift({ 'Não aplicável' })

          // SETA OS VALORES RECEBIDOS
          this.campos.ipi_cst.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      proSitFisFormularioLimparValoresCampos: function (campos = []) {
        return new Promise((success) => {
          // VERIFICA OS CAMPOS QUE DEVE LIMPAR
          for (var indexC in campos) {
            // PEGA O NOME DO CAMPO
            var campo = campos[indexC]
  
            // SETA OS VALORES RECEBIDOS
            this.campos[campo].options = []
  
            // LIMPA O VALOR DO CAMPO
            this.campos[campo].value = ''
          }
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // FINALIZA O CARREGAMENTO
          success()
        })
      },
      proSitFisFormularioOnBuscarCstPisCofins: function (callback, id, total = null, registros = []) {
        // SETA O NOME DO CAMPOS QUE DEVE ATUALIZAR
        var indexF = id.split('--')[1]

        // PEGA O CFOP SELECIONADO
        var cfop_ini = typeof this.campos.id_cfop.value !== 'object' ? this.campos.id_cfop.value : this.campos.id_cfop.value.cfop

        // VERIFICA SE FOI ENCONTRADO O CFOP SELECIONADO
        if ([ '', null, undefined ].indexOf(cfop_ini) !== -1) {
          // SETA OS VALORES RECEBIDOS
          this.campos[indexF].options = [ {} ]

          // SETA OS VALORES RECEBIDOS
          this.campos[indexF].onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()

          // AGUARDA O FECHAMENTO DO CAMPO PARA DAR FOCUS NO OUTRO
          setTimeout(() => {
            // SETA OS VALORES RECEBIDOS
            this.campos[indexF].options = []

            // REMOVE O FOCUS DE QUALQUER CAMPO
            if (document.activeElement !== document.body) {
              document.activeElement.blur()
            }

            // SETA A MENSAGEM DE ERRO
            this.campos.id_cfop.mensagem = 'É necessario selecionar o CFOP primeiro para depois carregar as CST de PIS/COFINS.'

            // SETA OS VALORES RECEBIDOS
            setTimeout(() => { this.campos[indexF].onBuscarOptions = this.proSitFisFormularioOnBuscarCstPisCofins }, 1000)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // SETA O FOCUS NO CAMPO
            setTimeout(() => { this.proSitFisFormularioRealizarFocusCampo('id_cfop') }, 250)
          }, 100)
        } else {
          // PEGA O VALOR INICIAL DO CAMPO
          cfop_ini = cfop_ini.substring(0, 1)

          // VERIFICA SE O CAMPO EXISTE
          if ([ '', null, undefined ].indexOf(this.campos[indexF]) === -1) {
            if (total === null || total < registros.length) {
              // MONTA O QUERY GET
              var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

              // MONTA O WHERE QUE SERÁ REALIZADO
              switch(cfop_ini) {
                case '1':
                case '2':
                case '3':
                  queryGet.where = { f: 'ref_pc_ope', o: 'LIKE', v: '0' }
                  break

                case '5':
                case '6':
                case '7':
                  queryGet.where = { f: 'ref_pc_ope', o: 'LIKE', v: '1' }
                  break
              }  
      
              // FAZ A BUSCA DOS DADOS
              this.$store.state.comunicaAPI('/referencia/pro-pis-cof-cst/get/', 'GET', queryGet, (apiSuccess) => {
                // JUNTA OS VALORES RECEBIDOS
                registros = registros.concat(apiSuccess.data)
    
                // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
                this.proSitFisFormularioOnBuscarCstPisCofins(callback, id, Number(apiSuccess.countAll), registros)
              }, (apiError) => {
                // SETA OS VALORES RECEBIDOS
                this.campos[indexF].status = apiError
    
                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
              })
            } else {
              // SETA OS VALORES RECEBIDOS
              this.campos[indexF].options = registros
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
    
              // EXECUTA A FUNÇÃO CALLBACK
              if (callback !== null) {
                callback()
              }
            }
          }
        }
      },
      proSitFisFormularioOnBuscarSeloIpi: function (callback, id, total = null, registros = []) {
        // SETA O NOME DO CAMPOS QUE DEVE ATUALIZAR
        var indexF = id.split('--')[1]

        // VERIFICA SE O CAMPO EXISTE
        if ([ '', null, undefined ].indexOf(this.campos[indexF]) === -1) {
          if (total === null || total < registros.length) {
            // MONTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
    
            // FAZ A BUSCA DOS DADOS
            this.$store.state.comunicaAPI('/referencia/pro-ipi-selo/get/', 'GET', queryGet, (apiSuccess) => {
              // JUNTA OS VALORES RECEBIDOS
              registros = registros.concat(apiSuccess.data)
  
              // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
              this.proSitFisFormularioOnBuscarSeloIpi(callback, id, Number(apiSuccess.countAll), registros)
            }, (apiError) => {
              // SETA OS VALORES RECEBIDOS
              this.campos[indexF].status = apiError
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          } else {
            // SETA OS VALORES RECEBIDOS
            this.campos[indexF].options = registros
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
  
            // EXECUTA A FUNÇÃO CALLBACK
            callback()
          }
        }
      },
      proSitFisFormularioOnBuscarEnquadramentoIpi: function (callback, id, total = null, registros = []) {
        // SETA O NOME DO CAMPOS QUE DEVE ATUALIZAR
        var indexF = id.split('--')[1]

        // VERIFICA SE O CAMPO EXISTE
        if ([ '', null, undefined ].indexOf(this.campos[indexF]) === -1) {
          if (total === null || total < registros.length) {
            // MONTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
    
            // FAZ A BUSCA DOS DADOS
            this.$store.state.comunicaAPI('/referencia/pro-ipi-enquadramento/get/', 'GET', queryGet, (apiSuccess) => {
              // JUNTA OS VALORES RECEBIDOS
              registros = registros.concat(apiSuccess.data)
  
              // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
              this.proSitFisFormularioOnBuscarEnquadramentoIpi(callback, id, Number(apiSuccess.countAll), registros)
            }, (apiError) => {
              // SETA OS VALORES RECEBIDOS
              this.campos[indexF].status = apiError
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          } else {
            // SETA OS VALORES RECEBIDOS
            this.campos[indexF].options = registros
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
  
            // EXECUTA A FUNÇÃO CALLBACK
            callback()
          }
        }
      },
      proSitFisFormularioRemoverLinha: function (id) {
        // PEGA OS PARAMETROS RECEBIDOS
        var index = id.split('--')

        // REMOVE A LINHA NA TABLEA
        var linha = this.tabela[index[1]].linha.splice(index[2], 1)
        
        // REMOVE O VALOR DA CHAVE REFERENCIA
        this.tabela[index[1]].chaves = this.tabela[index[1]].chaves.filter(item => item !== linha[0][index[3]])
        
        // FAZ A ATUALIZAÇÃO DO CAMPO
        this.proSitFisFormularioCampoVerificaInserirMais(index[1])

        // CHAMA A FUNÇÃO PARA ATUALIZAR NOTIN DO CAMPO
        if (index[1] === 'ncm') {
          this.proSitFisFormularioSetarNotInCampoNCM()
        }
        
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proSitFisFormularioSetarStatusBotoes: function (status = '') {
        // SETA O STATUS DOS BOTÕES
        this.botoes.salvar.status = status
        this.botoes.salvar.status = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proSitFisFormularioSalvarNomeCaso: function (_formData, callback) {
        if (_formData.id_caso !== '__NOVO_OPTION__') {
          callback(_formData)
        } else {
          // PEGA O VALOR DIGITADO PELO CLIENTE
          var option = this.campos.id_caso.value

          // INICIA AS VARIAVEIS
          var formData = { nome: option._text }

          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/produto/sit-fiscal/caso', 'POST', formData, (retorno) => {
            // LIMPA OS OPTIONS PARA BUSCAR NOVAMENTE AO ABRIR O CAMPO
            this.campos.id_caso.options = []
            this.campos.id_caso.value = { id: retorno.ref.id, nome: option._text }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // SETA O ID ATUALIZADO DO MODELO
            _formData.id_caso = retorno.ref.id

            // FINALIZA O PROCESSO E RETORNA A FUNÇÃO
            callback(_formData)
          }, this.proSitFisFormularioSetarStatusGeral, this.proSitFisFormularioTratarValidacao)
        }
      },
      proSitFisFormularioSalvar: function (conflito = 's') {
        // SETA O STATUS DOS BOTOES
        this.proSitFisFormularioSetarStatusBotoes('carregando')

        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_MONTAR_FORMDATA_API(this.campos, { check_ini: false, disabled: false, disabled_set: null }).then((formData) => {
          this.proSitFisFormularioSalvarNomeCaso(formData, (formData) => {
            // SETA O METHOD QUE DEVE CHAMAR
            var method = 'POST'
            
            // VERIFICA OS CAMPOS QUE DEVE ENVIAR
            if ([ '', null, undefined, '0', 0 ].indexOf(this.cpntId) === -1) {
              // SETA QUE SERÁ UMA ATUALIZAÇÃO
              method = 'PUT'

              // SETA O NOME DAS CHAVES QUE DEVE REMOVER PARA O PUT
              var remover = [ 'j_sit_fiscal2_conflito_stop', 'j_id_con', 'j_id_uf', 'j_id_p_pais', 'j_ncm' ]

              // REMOVE AS CHAVE INFORMADA
              for (var indexR in remover) {
                delete formData[remover[indexR]]
              }

              // INICIA O VETOR QUE SERÁ ADICIONADO
              var _formData = []

              // PEGA OS IDS QUE DEVE ATUALIZAR
              var vetorIds = typeof this.cpntId === 'object' ? this.cpntId : [ this.cpntId ]

              // TRABALHA CADA ID QUE DEVE EDITAR
              for (var indexI in vetorIds) {
                // SETA O ID DO REGISTRO QUE DEVE EDITAR
                formData.id = vetorIds[indexI].toString()

                // SETA OS CONTATOS QUE DEVE INSERIR
                formData.id_pro = this.campos.produto_todas.value === false ? this.tabela.produto.chaves[0] : '0'

                // SETA OS CONTATOS QUE DEVE INSERIR
                formData.id_con = this.campos.contato_todas.value === false ? this.tabela.contato.chaves[0] : '0'

                // SETA OS ESTADOS QUE DEVE INSERIR
                formData.id_uf = this.proSitFisFormularioCampoEstadoMostrar() === true && this.campos.estado_todas.value === false ? this.tabela.estado.chaves[0] : ''

                // SETA OS ESTADOS QUE DEVE INSERIR
                formData.id_p_pais = this.proSitFisFormularioCampoPaisMostrar() === true && this.campos.pais_todas.value === false ? this.tabela.pais.chaves[0] : '0'

                // SETA AS NCMS QUE DEVE INSERIR
                formData.ncm = this.campos.ncm_todas.value === false ? this.tabela.ncm.chaves[0] : ''

                // SETA AS NCMS QUE DEVE INSERIR
                formData.demanda = this.campos.demanda.value
                formData.demanda = typeof formData.demanda === 'string' ? formData.demanda : formData.demanda.id

                // VERIFICA SE TEM QUE CONVERTER O VALOR DO CAMPO
                if ([ '-1', ' ' ].indexOf(formData.ipi_cst) !== -1) {
                  formData.ipi_cst = null
                }

                // VERIFICA SE TEM QUE CONVERTER O VALOR DO CAMPO
                if ([ '', null, undefined ].indexOf(formData.ipi_selo) !== -1) {
                  formData.ipi_selo = null
                }

                // ADICIONA O VALOR AO VETOR
                _formData.push(JSON.parse(JSON.stringify(formData)))
              }

              // CONVERTE O CAMPO EM LOT
              formData = { lot: _formData }
            } else {
              // SETA O VALOR INICIAL DO CAMPO
              formData.j_sit_fiscal2_conflito_stop = conflito === true ? 'n' : 's'

              // // SETA AS DEMANDAS QUE DEVE INSERIR
              // formData.j_demanda = JSON.stringify([ 'dem_venda' ])

              // SETA OS CONTATOS QUE DEVE INSERIR
              formData.j_id_pro = this.campos.produto_todas.value === false ? JSON.stringify(this.tabela.produto.chaves) : '[0]'

              // SETA OS CONTATOS QUE DEVE INSERIR
              formData.j_id_con = this.campos.contato_todas.value === false ? JSON.stringify(this.tabela.contato.chaves) : '[0]'

              // SETA OS ESTADOS QUE DEVE INSERIR
              formData.j_id_uf = this.proSitFisFormularioCampoEstadoMostrar() === true && this.campos.estado_todas.value === false ? JSON.stringify(this.tabela.estado.chaves) : '[""]'

              // SETA OS ESTADOS QUE DEVE INSERIR
              formData.j_id_p_pais = this.proSitFisFormularioCampoPaisMostrar() === true && this.campos.pais_todas.value === false ? JSON.stringify(this.tabela.pais.chaves) : '["0"]'

              // SETA AS NCMS QUE DEVE INSERIR
              formData.j_ncm = this.campos.ncm_todas.value === false ? JSON.stringify(this.tabela.ncm.chaves) : '[""]'

              // SETA AS NCMS QUE DEVE INSERIR
              formData.demanda = this.campos.demanda.value
              formData.demanda = typeof formData.demanda === 'string' ? formData.demanda : formData.demanda.id

              // VERIFICA SE TEM QUE CONVERTER O VALOR DO CAMPO
              if ([ '-1', ' ' ].indexOf(formData.ipi_cst) !== -1) {
                formData.ipi_cst = null
              }

              // VERIFICA SE TEM QUE CONVERTER O VALOR DO CAMPO
              if ([ '', null, undefined ].indexOf(formData.ipi_selo) !== -1) {
                formData.ipi_selo = null
              }
            }

            // FAZ A BUSCA NA API
            this.$store.state.comunicaAPI('/produto/sit-fiscal2', method, formData, (retorno) => {
              // PEGA O VALOR RECEBIDO
              retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : Object.assign({ code: '200', message: retorno.message }, retorno)

              // VERIFICA O RETORNO RECEBIDO
              if (method === 'PUT' && retorno.code !== '200') {
                this.proSitFisFormularioTratarValidacao(retorno.message, retorno.code)
              } else {
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(retorno)

                // PEGA O ID QUE DEVE PREENCHER
                var id = ([ '', null, undefined ].indexOf(retorno.ref) !== -1 || [ '', null, undefined ].indexOf(retorno.ref.id) !== -1) ? undefined : retorno.ref.id
  
                // INFORMA QUE A CONFIGURAÇÃO FOI FEITA E FECHA O FORMULARIO
                this.proSitFisFormularioFechar(true, id)
              }
            }, this.proSitFisFormularioSetarStatusGeral, this.proSitFisFormularioTratarValidacao)
          })
        }).catch(this.proSitFisFormularioSetarStatusGeral)
      },
      proSitFisFormularioTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        if (typeof apiValid === 'object' && [ '', null, undefined ].indexOf(apiValid.j_sit_fiscal2_conflito) === -1) {
          // PEGA OS DADOS DO CONFLITO RECEBIDO
          var conflito = apiValid.j_sit_fiscal2_conflito

          // PEGA OS DAODS RECEBIDO E CONVERTE PARA JSON
          conflito = typeof conflito === 'string' ? JSON.parse(conflito) : conflito

          // SETA O CONFLITO NA TELA PARA CONFIRMAÇÃO
          this.conflito = conflito

          // SETA O STATUS DOS BOTOES
          this.proSitFisFormularioSetarStatusBotoes('')
        } else {
          // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
          const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API
  
          // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
          FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
            // SETA O STATUS DOS BOTOES
            this.proSitFisFormularioSetarStatusBotoes('')
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
            
            // EXECUTA O CALLBACK RECEBIDO
            if (callback !== null && typeof callback === 'function') {
              callback()
            }
          })
        }
      },
      proSitFisFormularioDialogMostrarConflito: function () {
        this.mostrarConflito = !this.mostrarConflito
      },
      proSitFisFormularioConflitoContinuar: function () {
        // FECHA A DIALOG DE CONFLITO
        this.proSitFisFormularioConflitoCancelar()
        
        // MANDA SALVAR OS DADOS E EXCLUIR O CONFLITO
        this.proSitFisFormularioSalvar(true)
      },
      proSitFisFormularioConflitoCancelar: function () {
        // SETA O CONFLITO NA TELA PARA CONFIRMAÇÃO
        this.conflito = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA O STATUS DOS BOTOES
        this.proSitFisFormularioSetarStatusBotoes('')
      },
      proSitFisFormularioExcluirCaso: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE FOI SELECIONADO ALGUM REGISTRO
        if (window.confirm('Deseja realmente excluir a situação fiscal selecionada?')) {
          // INICIA O FORMULARIO
          var formData = { j_id: JSON.stringify([ this.cpntId ]) }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/produto/sit-fiscal2', 'DELETE', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

                // MANDA ATUALIZAR A TABELA
                this.proSitFisFormularioFechar(true)
                break

              default:
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)
                break
            }
          }, this.proSitFisFormularioSetarStatusGeral)
        }
      },
      proSitFisFormularioCopiarCaso: function () {
        this.copiar = (dados) => {
          // SETA O STATUS DOS BOTOES
          this.proSitFisFormularioSetarStatusBotoes('carregando')

          // FECHA A TELA DE COPIA DE DADOS
          this.copiar = null

          // BUSCA OS DADOS SOLICITADOS
          this.proSitFisFormularioBuscarValores(dados.id, () => {
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
  
            // SETA O STATUS DOS BOTOES
            this.proSitFisFormularioSetarStatusBotoes('')
  
            // APRESENTA A MENSAGEM
            this.$store.state.msgWarn('WEB [200]: Dados de situação fiscal copiados com sucesso.', 'success')
          })
        }
      },
      proSitFisFormularioCampoPisAliquotaDisabled: function () {
        // VERIFICA SE DEVE MOSTRAR O CAMPO
        var disabled = [ '', null, undefined ].indexOf(this.campos.pis_cst.value) !== -1 || typeof this.campos.pis_cst.value !== 'object' || this.campos.pis_cst.value.ref_pc_a !== '1'
        
        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.pis_a.value = ''
        } else if (this.campos.pis_a.value === '') {
          this.campos.pis_a.value = '0.00'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIcmsCstDisabled: function () {
        // VERIFICA SE DEVE MOSTRAR O CAMPO
        var disabled = [ '', null, undefined ].indexOf(this.campos.icms_cst.value) !== -1 || this.campos.icms_cst.value.ref_icms_cst === ''

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoDemandaDisabled: function () {
        // VERIFICA SE JÁ ESTÁ DESABILITADO OU TEM SELECIONADO UM CST
        var disabled = this.campos.demanda.options.length <= 1

        // CARREGA OS DADOS DO CAMPO CFOP
        var id_cfop = [ '', null, undefined ].indexOf(this.campos.id_cfop.value) !== -1 ? '' : this.campos.id_cfop.value.cfop

        // LIMPA O VALOR DO CAMPO
        if ([ '', null, undefined ].indexOf(id_cfop) !== -1) {
          this.campos.demanda.value = ''
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIcmsModBcDisabled: function () {
        // VERIFICA SE JÁ ESTÁ DESABILITADO OU TEM SELECIONADO UM CST
        var disabled = this.proSitFisFormularioCampoIcmsCstDisabled() === true || this.campos.icms_cst.value.ref_icms_bc_mod !== '1'

        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.icms_bc_mod.value = ''
        }

        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.icms_bc_mod.value = ''
          this.campos.icms_bc_mod.optionInicialNome = ''
          this.campos.icms_bc_mod.optionInicialValue = ''
        } else {
          this.campos.icms_bc_mod.optionInicialNome = 'Selecione'
          this.campos.icms_bc_mod.optionInicialValue = ''
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIcmsAliquotaDisabled: function () {
        // VERIFICA SE JÁ ESTÁ DESABILITADO OU TEM SELECIONADO UM CST
        var disabled = this.proSitFisFormularioCampoIcmsCstDisabled() === true || this.campos.icms_cst.value.ref_icms_a !== '1'

        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.icms_a.value = ''
        } else if (this.campos.icms_a.value === '') {
          this.campos.icms_a.value = '0.00'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIcmsReducaoDisabled: function () {
        // VERIFICA SE JÁ ESTÁ DESABILITADO OU TEM SELECIONADO UM CST
        var disabled = this.proSitFisFormularioCampoIcmsCstDisabled() === true || this.campos.icms_cst.value.ref_icms_bc_p_r !== '1'

        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.icms_bc_p_r.value = ''
        } else if (this.campos.icms_bc_p_r.value === '') {
          this.campos.icms_bc_p_r.value = '0.00'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIcmsReducaoSobreDisabled: function () {
        // VERIFICA SE JÁ ESTÁ DESABILITADO OU TEM SELECIONADO UM CST
        var disabled = this.proSitFisFormularioCampoIcmsCstDisabled() === true || this.campos.icms_cst.value.ref_icms_bc_p_r_c !== '1'

        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.icms_bc_p_r_c.value = ''
          this.campos.icms_bc_p_r_c.optionInicialNome = ''
        } else {
          this.campos.icms_bc_p_r_c.optionInicialNome = 'Selecione'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIcmsStModBcDisabled: function () {
        // VERIFICA SE JÁ ESTÁ DESABILITADO OU TEM SELECIONADO UM CST
        var disabled = this.proSitFisFormularioCampoIcmsCstDisabled() === true || this.campos.icms_cst.value.ref_icms_st_bc_mod !== '1'

        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.icms_st_bc_mod.value = ''
          this.campos.icms_st_bc_mod.optionInicialNome = ''
          this.campos.icms_st_bc_mod.optionInicialValue = ''
        } else {
          // SETA OS NOVOS VALORES DO PRIMEIRO OPTION
          this.campos.icms_st_bc_mod.optionInicialNome = 'Não aplicável'
          this.campos.icms_st_bc_mod.optionInicialValue = '-1'

          // VERIFICA SE TEM QUE SELECIONAR O PRIMEIRO OPTION
          if (this.campos.icms_st_bc_mod.value === '') {
            this.campos.icms_st_bc_mod.value = '-1'
          }
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIcmsStDisabled: function () {
        // PEGA O VALOR SELECIONADO NO CAMPO
        var value = this.campos.icms_st_bc_mod.value

        // VERIFICA SE TEM QUE CONVERTER OBJECT EM STRING
        value = typeof value === 'string' ? value : value[this.campos.icms_st_bc_mod.keyValue]

        // VERIFICA O VALOR SELECIONADO DEVE HABILITAR OU DESABILITAR O CAMPO
        return [ '', null, undefined, '-1' ].indexOf(value) !== -1
      },
      proSitFisFormularioCampoIcmsStAliquotaDisabled: function () {
        // VERIFICA SE JÁ ESTÁ DESABILITADO OU TEM SELECIONADO UM CST
        var disabled = this.proSitFisFormularioCampoIcmsStDisabled() === true || this.campos.icms_cst.value.ref_icms_st_a !== '1'

        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.icms_st_a.value = ''
        } else if (this.campos.icms_st_a.value === '') {
          this.campos.icms_st_a.value = '0.00'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIcmsStReducaoDisabled: function () {
        // VERIFICA SE JÁ ESTÁ DESABILITADO OU TEM SELECIONADO UM CST
        var disabled = this.proSitFisFormularioCampoIcmsStDisabled() === true || this.campos.icms_cst.value.ref_icms_bc_st_p_r !== '1'

        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.icms_bc_st_p_r.value = ''
        } else if (this.campos.icms_bc_st_p_r.value === '') {
          this.campos.icms_bc_st_p_r.value = '0.00'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIcmsRetidoPorStDisabled: function () {
        // VERIFICA SE JÁ ESTÁ DESABILITADO OU TEM SELECIONADO UM CST
        var disabled = this.campos.icms_cst.value.ref_icms_st_rt !== '1'

        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.icms_st_rt.value = ''
        } else if (this.campos.icms_st_rt.value === '') {
          this.campos.icms_st_rt.value = '0.00'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIcmsBCRetidoPorStDisabled: function () {
        // VERIFICA SE JÁ ESTÁ DESABILITADO OU TEM SELECIONADO UM CST
        var disabled = this.campos.icms_cst.value.ref_icms_st_bc_rt !== '1'

        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.icms_st_bc_rt.value = ''
        } else if (this.campos.icms_st_bc_rt.value === '') {
          this.campos.icms_st_bc_rt.value = '0.00'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIcmsStMvaDisabled: function () {
        // VERIFICA SE JÁ ESTÁ DESABILITADO OU TEM SELECIONADO UM CST
        var disabled = this.proSitFisFormularioCampoIcmsStDisabled() === true || this.campos.icms_cst.value.ref_icms_mva_p !== '1'

        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.icms_mva_p.value = ''
        } else if (this.campos.icms_mva_p.value === '') {
          this.campos.icms_mva_p.value = '0.00'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIcmsFcpSTAliquotaDisabled: function () {
        // VERIFICA SE JÁ ESTÁ DESABILITADO OU TEM SELECIONADO UM CST
        var disabled = this.proSitFisFormularioCampoIcmsCstDisabled() === true || this.campos.icms_cst.value.ref_icms_fcp_st_a !== '1'

        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.icms_fcp_st_a.value = ''
        } else if (this.campos.icms_fcp_st_a.value === '') {
          this.campos.icms_fcp_st_a.value = '0.00'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIcmsFcpAliquotaRetidoSTDisabled: function () {
        // VERIFICA SE JÁ ESTÁ DESABILITADO OU TEM SELECIONADO UM CST
        var disabled = this.proSitFisFormularioCampoIcmsCstDisabled() === true || this.campos.icms_cst.value.ref_icms_fcp_st_r_a !== '1'

        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.icms_fcp_st_r_a.value = ''
        } else if (this.campos.icms_fcp_st_r_a.value === '') {
          this.campos.icms_fcp_st_r_a.value = '0.00'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIcmsFcpSupConFinalDisabled: function () {
        // VERIFICA SE JÁ ESTÁ DESABILITADO OU TEM SELECIONADO UM CST
        var disabled = this.proSitFisFormularioCampoIcmsCstDisabled() === true || this.campos.icms_cst.value.ref_icms_fcp_st_a_cf !== '1'

        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.icms_fcp_st_a_cf.value = ''
        } else if (this.campos.icms_fcp_st_a_cf.value === '') {
          this.campos.icms_fcp_st_a_cf.value = '0.00'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIcmsFcpAliquotaDisabled: function () {
        // VERIFICA SE JÁ ESTÁ DESABILITADO OU TEM SELECIONADO UM CST
        var disabled = this.proSitFisFormularioCampoIcmsCstDisabled() === true || this.campos.icms_cst.value.ref_icms_fcp_a !== '1'

        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.icms_fcp_a.value = ''
        } else if (this.campos.icms_fcp_a.value === '') {
          this.campos.icms_fcp_a.value = '0.00'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIcmsFcpBcRetidoSTDisabled: function () {
        // VERIFICA SE JÁ ESTÁ DESABILITADO OU TEM SELECIONADO UM CST
        var disabled = this.proSitFisFormularioCampoIcmsCstDisabled() === true || this.campos.icms_cst.value.ref_icms_fcp_st_r_bc !== '1'

        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.icms_fcp_st_r_bc.value = ''
        } else if (this.campos.icms_fcp_st_r_bc.value === '') {
          this.campos.icms_fcp_st_r_bc.value = '0.00'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoCofinsAliquotaDisabled: function () {
        // VERIFICA SE DEVE MOSTRAR O CAMPO
        var disabled = [ '', null, undefined ].indexOf(this.campos.cofins_cst.value) !== -1 || typeof this.campos.cofins_cst.value !== 'object' || this.campos.cofins_cst.value.ref_pc_a !== '1'
        
        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.cofins_a.value = ''
        } else if (this.campos.cofins_a.value === '') {
          this.campos.cofins_a.value = '0.00'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIpiAliquotaDisabled: function () {
        // VERIFICA SE DEVE MOSTRAR O CAMPO
        var disabled = [ '', null, undefined ].indexOf(this.campos.ipi_cst.value) !== -1 || typeof this.campos.ipi_cst.value !== 'object' || this.campos.ipi_cst.value.ref_ipi_a !== '1'
        
        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.ipi_a.value = ''
        } else if (this.campos.ipi_a.value === '') {
          this.campos.ipi_a.value = '0.00'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIpiEnquadramentoDisabled: function () {
        // VERIFICA SE DEVE MOSTRAR O CAMPO
        var disabled = [ '', null, undefined ].indexOf(this.campos.ipi_cst.value) !== -1 || typeof this.campos.ipi_cst.value !== 'object' || this.campos.ipi_cst.value.ref_ipi_enq !== '1'
        
        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.ipi_enq.value = ''
          this.campos.ipi_enq.optionInicialNome = ''
        } else {
          this.campos.ipi_enq.optionInicialNome = 'Selecione'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoIpiSeloDisabled: function () {
        // VERIFICA SE DEVE MOSTRAR O CAMPO
        var disabled = [ '', null, undefined ].indexOf(this.campos.ipi_cst.value) !== -1 || typeof this.campos.ipi_cst.value !== 'object' || this.campos.ipi_cst.value.ref_ipi_selo !== '1'
        
        // LIMPA O VALOR DO CAMPO
        if (disabled === true) {
          this.campos.ipi_selo.value = ''
          this.campos.ipi_selo.optionInicialNome = ''
        } else {
          this.campos.ipi_selo.optionInicialNome = 'Selecione'
        }

        // RETORNA O VALOR CALCULADO
        return disabled
      },
      proSitFisFormularioCampoEstadoMostrar: function () {
        if (this.campos.id_cfop.value !== '' && this.campos.id_cfop.value._id !== '') {
          // PEGA O CFOP SELECIONADO
          var cfop_ini = typeof this.campos.id_cfop.value !== 'object' ? this.campos.id_cfop.value : this.campos.id_cfop.value.cfop
  
          // PEGA O VALOR INICIAL DO CAMPO
          cfop_ini = cfop_ini.substring(0, 1)
  
          // VERIFICA A AÇÃO QUE DEVE REALIZAR
          switch (cfop_ini) {
            case '1':
            case '3':
            case '5':
            case '7':
              return false
            
            default:
              return true
          }
        } else {
          return false
        }
      },
      proSitFisFormularioCampoPaisMostrar: function () {
        if (this.campos.id_cfop.value !== '' && this.campos.id_cfop.value._id !== '') {
          // PEGA O CFOP SELECIONADO
          var cfop_ini = typeof this.campos.id_cfop.value !== 'object' ? this.campos.id_cfop.value : this.campos.id_cfop.value.cfop
  
          // PEGA O VALOR INICIAL DO CAMPO
          cfop_ini = cfop_ini.substring(0, 1)
  
          // VERIFICA A AÇÃO QUE DEVE REALIZAR
          switch (cfop_ini) {
            case '1':
            case '2':
            case '5':
            case '6':
              return false
            
            default:
              return true
          }
        } else {
          return false
        }
      },
      proSitFisFormularioCampoEstadoMostrarTabela: function () {
        return [ '', null, undefined, '0', 0 ].indexOf(this.cpntId) !== -1
      },
      proSitFisFormularioCampoPaisMostrarTabela: function () {
        return [ '', null, undefined, '0', 0 ].indexOf(this.cpntId) !== -1
      },
      proSitFisFormularioCampoMensagemNFCeForaEstado: function () {
        return this.tabela.estado.chaves.length !== 1 || this.tabela.estado.chaves.indexOf(this.$store.state.licenca.uf) === -1
      },
      proSitFisFormularioCampoMensagemCSTInvalida: function () {
        // PEGA O VALOR SELECIONADO NO CAMPO
        var value = typeof this.campos.icms_cst.value === 'string' ? this.campos.icms_cst.value : this.campos.icms_cst.value.ref_icms_cst

        // INICIA A VARIAVEL DE OPÇOES
        var options = []

        // VERIFICA A AÇÃO QUE DEVE REALIZAR PARA O REGIME
        switch (this.$store.state.licenca.rt_id) {
          case '3':
            options = [ '00', '20', '40', '41', '60', '90' ]
            break
        
          default:
            options = [ '102', '103', '300', '400', '500', '900' ]
            break
        }

        // FAZ A VERIFICAÇÃO
        return [ '', null, undefined ].indexOf(value) === -1 && options.indexOf(value) === -1
      }
    },
    computed: {
      proSitFisDemandaSel: function () {
        return (typeof this.campos.demanda.value === 'string' ? this.campos.demanda.value : this.campos.demanda.value.id)
      },
      proSitFisFormularioCampoIcmsCstNome: function () {
        return this.$store.state.licenca.rt_id === '3' ? 'CST' : 'CSOSN'
      }
    }
  }
</script>
